export const summaries = {
    "cpb-aacip-127-009w0z0q.h264": {
        "videoID": "cpb-aacip-127-009w0z0q.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip - # 1",
        "time": "1:02:35",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Ac'urunaq (nickname-aqluku Maqista) (Kass'atun Joshua Phillip) Tuulkessarmiu qallatellruuq interview-ami Yugtun qalarcaram tamanritlerkaanek, yuum kencikiyaraanek naklekiyarakun piciuyarakun, nunam mer'em-llu auluklerkaagnek uqlanermek. Cali-llu qallatellruuq irniam anglicallerkaanek, nengaungellermek, qanrucunarqellrianek, irniam ayagatesqenritellranek, teglenritlerkamek-llu."
                ],
                [
                    "Joshua Phillip (Ac'urunaq; nicknamed Maqista) of Tuluksak talks in the interview about the preservation of the Yup'ik language, the reverence of others with compassion and truth, and taking care of the land and water from pollution. He also talks about child rearing, taking in a son-in-law, qanrucunalriit (people who adhere to instructions), instructions not to bring a child places, and admonishments not to steal from others."
                ]
            ],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Yugtun qalarcaram tamanritlerkaa",
                "Yup'ik langauge preservation"
            ],
            "15": [
                "01:30",
                "Kencikiyaraq; naklekiyaraq; piciuyaraq",
                "Reverence; compassion; truthfulness"
            ],
            "72": [
                "06:55",
                "Uqlaneq; nunam mer'em-llu auluklerkaat",
                "Pollution; taking care of the land and water"
            ],
            "286": [
                "29:49",
                "Irniamek anglicarillerkaq",
                "Child rearing"
            ],
            "331": [
                "35:06",
                "Nengaungelleq",
                "Taking in a son-in-law"
            ],
            "341": [
                "36:34",
                "Qanrucunarqellriit (qanruyutnek maligtaquilriit)",
                "Qanrucunarqellriit (people who adhere to instructions)"
            ],
            "366": [
                "39:51",
                "Irniaq ellangyuallrani ayagatesqevkenaku alerquutnguuq",
                "An instruction to not bring a growing child to other places"
            ],
            "389": [
                "42:10",
                "Teglegyaqunak; cikiqenglleq quyanarqenruuq akurtunermi; kevgiurturyaraq",
                "Do not steal; it is better to give than to receive; serving others"
            ],
            "444": [
                "56:52",
                "Tuyuryarmi; Nasaurlurmiut (Nasaurlormiut) Yupiit Elders Qasgiat (Kasgiat).",
                "Footage of Togiak; and Nasaurlormiut Yupiit Elders Kasgiat."
            ]
        },
        "elderTags": [
            "23.52"
        ],
        "tags": [
            "2.2.42",
            "2.2.31",
            "1.1.1",
            "1",
            "19.9",
            "19.12",
            "19.5.1",
            "3.9.1",
            "22.2",
            "4.4",
            "19.6",
            "19.13.1",
            "19.11"
        ]
    },
    "cpb-aacip-127-00ns1t6z.h264": {
        "videoID": "cpb-aacip-127-00ns1t6z.h264",
        "title": "Ackiar Nick Lupie - # 2",
        "time": "31:22",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Ackiar (Nick Lupie) Tuntutuliarmiu interview-ami qalartellruuq uksuarmi up'ngelallratnek. Qalarutekluki taluyat ayuqenrilngurnek, neqet qeciit teq'uciriyaraatnek, canegnek uptetullritnek, ayagaaqameng-llu inerquutnek uksuarmi."
                ],
                [
                    "Nick Lupie (Ackiar) of Tuntutuliak in the interview talked about how people got ready for the fall. He talked about the many types of fish traps, fish skins and aging urine, preparing grass, and admonishments for traveling in the fall."
                ]
            ],
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew"
            ]
        },
        "summary": {
            "12": [
                "01:09",
                "Uksuarmi up'ngelallrat; uksum atu'urkanek upcilallrat; uksuilleq",
                "How people got ready for the fall; how people got ready for what they would need to use for the winter; fall camp"
            ],
            "46": [
                "05:29",
                "Taluyarpiit (qamut)",
                "Large fish traps"
            ],
            "76": [
                "09:08",
                "Muragnek aklut",
                "Possessions made of wood"
            ],
            "91": [
                "11:29",
                "Amiragkiuryaraq neqet qeciit (neqairiluteng); teq'iciriluteng",
                "Preparing fish skins; aging urine"
            ],
            "114": [
                "14:18",
                "Taluyat can'giircuutet; caqut canegnek",
                "Fish traps for black fish; containers made of grass"
            ],
            "121": [
                "15:28",
                "Canegnek uptetullruut",
                "Preparing grass"
            ],
            "142": [
                "18:04",
                "Taluyat imarmiutarcuutet cuignilngurcuutet-llu",
                "Fish traps for mink and otter"
            ],
            "157": [
                "20:01",
                "Kass'artaat",
                "Store-bought items"
            ],
            "171": [
                "21:51",
                "Ayagaaqameng inerquutet ukusarmi; neplirasqevkenaki yuilqumi; qanerluteng tamatum nuniinun ayakatarniluteng; nunam qaingit atrit nalluvkenaki",
                "Admonishments for traveling in the fall; don't be noisy in the wilderness; telling others where they are traveling; knowledge of place names"
            ],
            "222": [
                "29:33",
                "\"Ca tamalkuan qanruyutek'lallruyaaqaput\"",
                "\"We use to talk about everything\""
            ]
        },
        "elderTags": [
            "23.4"
        ],
        "tags": [
            "2.2.30",
            "1.1.1",
            "3.1.2",
            "9.8",
            "17.1.6",
            "5.1.1",
            "5.3.2",
            "5.3.4",
            "17.6",
            "5.1",
            "7.4",
            "6.3",
            "19.13",
            "19.5"
        ]
    },
    "cpb-aacip-127-010p2r15.h264": {
        "videoID": "cpb-aacip-127-010p2r15.h264",
        "title": "Urutaq Lucy Beaver, Kelucaq Joe Andrew - # 3",
        "time": "22:27",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Urutaq (Lucy Beaver), Kelucaq-llu (Joe Andrew) Mamterillermi qalartellruuk mikelngurnek kenkiyaramek. Tua-llu Lucy-m qalarutekluki neryaraq, neryaram cimillra, irniam aulukellra, irnillrani-llu. Tua-llu Joe-am qalarutekluku irniam elicungcaralallra inerqulallra-llu."
                ],
                [
                    "Lucy Beaver (Urutaq) and Joe Andrew (Kelucaq) from Bethel talk about showing love to children. Lucy talks about eating habits, how eating habits have changed, child rearing, and giving birth. And Joe talks about teaching and admonishing children."
                ]
            ],
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Arnam mikelngurnek kenkiyaraa",
                "How women love children"
            ],
            "18": [
                "02:20",
                "Neryaraq; neqkaq anglanitekevkallrunritaa; neryaram cimillra",
                "Eating habits; not being frivilous with food; changing eating habits"
            ],
            "54": [
                "05:46",
                "Irniam aulukellra; qingaqerraalleq",
                "Child rearing; first pregnancy"
            ],
            "84": [
                "09:03",
                "\"Inerqulaqiu erinan tapirpek'naku\"; \"Ca tamalkuan qanruyutengqellrulria wangkutni\"",
                "\"Admonish him/her without raising your voice\"; \"Everything had traditional wisdom connected to it for us\""
            ],
            "105": [
                "11:31",
                "Neryaram piciryarallrem cimiutii",
                "Changing eating habits"
            ],
            "119": [
                "13:04",
                "Irnillermek qanemciq",
                "Story of giving birth"
            ],
            "152": [
                "16:31",
                "Irniani piqarraami elicungcaralaraa inerquulluki-llu",
                "Teaching and admonishing children from the beginning"
            ]
        },
        "elderTags": [
            "23.82",
            "23.43"
        ],
        "tags": [
            "2.2.38",
            "1.1.1",
            "19.10",
            "19.6.2",
            "15.2",
            "22.2",
            "22.1.2"
        ]
    },
    "cpb-aacip-127-03cz8zdq.h264": {
        "videoID": "cpb-aacip-127-03cz8zdq.h264",
        "title": "James Guy - # 5",
        "time": "22:23",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "James Guy Kuigglugmiu qalartellruuq ciumek qasgimi qanengssallernek tua-i-llu tegleksaitesqelluki yuut. Cali-llu Aavaa-m yuungcallranek angalkugmek qallalluni. Tua-llu tunciuryaramek tuntunek-llu maagillratnek Akiacuarmi qallatellruuq cali-llu keglunernek anguyagten̄ek-llu tuntut pitekluki. Tua-llu cali qallalluni ukunek: yuilqumi akiikangengnaqurallermek melqulegteggun muriuryaratgun-llu, ayagyuat Yugtun qalarcaraput cagmangluku, ayarum atullerkaa arcaqerluku."
                ],
                [
                    "James Guy from Kwethluk began by first talking about stories in the qasgiq and then admonishments against stealing from others. He also talked about Aavaaq being treated by a shaman. Then he talked about reindeer herding and marking in Akiachak and also about reindeer and wolves and the government. He then talked about these: trapping and getting lumber for money, teenagers losing our Yup'ik language, and the importance of using a walking stick/cane."
                ]
            ],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "3": [
                "00:10",
                "Qasgimi",
                "In the qasgiq"
            ],
            "19": [
                "01:46",
                "Teglegyaqunak; enulliskuni teguskuni camek at'ni igauskili",
                "Do not steal; if someone takes something because they are in need, they should write a note with their name"
            ],
            "54": [
                "05:51",
                "Aavaaq-am yuungcaraullra",
                "Aavaaq being treated by a shaman"
            ],
            "72": [
                "07:03",
                "Tuntunek maagilleq Akiacuarmi; Akulikutaq Corral",
                "Reindeer herding and marking in Akiachak; Akulikutaq Corral"
            ],
            "135": [
                "12:06",
                "Tuntut keglunret-llu; tuntut anguyagtet-llu",
                "Reindeer and wolves; reindeer and the governement"
            ],
            "166": [
                "15:09",
                "Akiikangengnaquralleq melqulegteggun muriuryaratgun-llu",
                "Trapping and getting lumber for money"
            ],
            "179": [
                "16:33",
                "Ayagyuat akusrartengut; Yugtun qalarcaraput cagmangluku; ayagayarateng cagmangluku",
                "Rowdy teenagers; losing our Yup'ik language; losing our knowledge of how to travel"
            ],
            "209": [
                "19:49",
                "Qanruyun angenqurrat; teglegyaqunak; ayaruq tegumiaqurluku",
                "The most important traditional wisdom; do not steal; keep a walking stick/cane with you at all times"
            ]
        },
        "elderTags": [
            "23.38"
        ],
        "tags": [
            "2.2.39",
            "1.1.1",
            "21.2",
            "19.13.1",
            "8.4",
            "5.3.1",
            "16.2.3",
            "5.3.3",
            "9.4",
            "1",
            "17.1.1"
        ]
    },
    "cpb-aacip-127-06g1jzz6.h264": {
        "videoID": "cpb-aacip-127-06g1jzz6.h264",
        "title": "Cingliaq Paul Gregory, Peter Isaac, Ayaprun James Peter Sr., Nanugaq Fred Evan, Paniguaq Peter Jacob - # 8",
        "time": "21:59",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Quyurtellratni ukut angutet qalartellruut: Cingliaq (Paul Gregory) quyurtellrat ayagnillrua tua-llu (Peter Isaac), yuartet pitekluki, quyavikellrua kevgaq ikayuutelallruan. Taum kinguani Ayaprun (James Peter Sr.) ayuqucirturillruuq kitellriamun alerquutnek allanek-llu qanruyutnek, tua-llu Nanugaq (Fred Evan) quyavikellrui yuartet. Nangnermek Paniguaq (Peter Jacob) qimugten̄ek qimugciryaramek-llu qalartellruuq qanemciluni-llu alangrullerminek iternerkun tua-llu Cingliaq (Paul Gregory) cali qimugten̄ek qalartenqigterraarluni quyurtellrat arulaircetaa."
                ],
                [
                    "In this conference, these men talked: Paul Gregory (Cingliaq) began the conference and then Peter Isaac, on behalf of the Search and Rescue team, thanked a helper that was always helping out. After that, James Peter Sr. (Ayaprun) instructed about what to do when someone falls into water and other words of wisdom, then Fred Evan (Nanugaq) thanked the searchers. Lastly Peter Jacob (Paniguaq) talked about dogs and dog mushing along with a story of when he had a supernatural experience with a cold draft, and then after Paul Gregory (Cingliaq) again talked about dogs, he adjourned the conference."
                ]
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Cingliaq Paul Gregory] Quyurtellrat ayagnirluni",
                "[Cingliaq Paul Gregory] Beginning the conference"
            ],
            "9": [
                "00:41",
                "[Peter Isaac] Yuartet quyavikaat kevgaq",
                "[Peter Isaac] Search and rescue thanks a helper"
            ],
            "36": [
                "03:55",
                "[Ayaprun James Peter Sr.] Yuk kiskan ayuqucirtuutet; \"Cacetulria-gguq arenqiallugtellerkaminun tau͡gaam tekitaatuuq.\"",
                "[Ayaprun James Peter Sr.] Instructions for when a person falls into the water; \"A self-confident person only comes upon misfortune.\""
            ],
            "78": [
                "08:11",
                "[Nanugaq Fred Evan] Quyavikluki yuartet",
                "[Nanugaq Fred Evan] Thanking the searchers"
            ],
            "91": [
                "10:05",
                "[Paniguaq Peter Jacob] Qimugtet qimugciryaraq-llu; alangru iternerkun",
                "[Paniguaq Peter Jacob] Dogs and dog mushing; supernatural experience with a cold draft"
            ],
            "203": [
                "19:48",
                "[Cingliaq Paul Gregory] Qimugtet; Quyurtellrat arulairluni",
                "[Cingliaq Paul Gregory] Dogs; adjourning the conference"
            ]
        },
        "elderTags": [
            "23.29",
            "23.70",
            "23.19",
            "23.57",
            "23.68"
        ],
        "tags": [
            "2.2.38",
            "2.2.32",
            "2.2.26",
            "1.1.1",
            "24.1",
            "11",
            "17.4.1",
            "17.4.1.1",
            "15.2",
            "8.5"
        ]
    },
    "cpb-aacip-127-06g1k008.h264": {
        "videoID": "cpb-aacip-127-06g1k008.h264",
        "title": "Kayirayuaq Eddie Bell Sr., Kelucaq Joe Andrew, Kamluq Kirt Bell, Mikngayaq Mik'aq Eliza Chase, Maqarualek Edward Wise, Ayagkaq Wassillie B. Evan, Phillip Moses, Urutaq Lucy Beaver - # 9",
        "time": "22:42",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Quyurtellratni ukut yuut qalartellruut: Kelucaq (Joe Andrew), Maqarualek (Edward Weiss)-llu qalartellruuk ciin taqukam tan'gerlim-llu nuaganek keggiinateng pit'ellriit minguuk'lallratnek. (Kurt Bell), Kelucaq (Joe Andrew), [Yuk Unidentified]-llu nakacugnek qalartellruut. Tua-llu Kurt Bell inerqullrui pissusqevkenaki piyagat tengmiat-llu piyagangqellriit. Ayagkaq (Wassillie B. Evan) pitamta kencikuciatnek qalarrluni tua-llu Mikngayam Mik'am (Eliza Chase), qaneryaraput nalluyagutesqevkenaku, KYUK-q cingumallrua tegganret qalarcet'laasqelluukii radio-mi. Maqarualek (Edward Weiss) ayarunek tan'gerlirnek-llu qalartellruuq. Nangnerani-llu Phillip Moses Nunakauyarmiu Urutaq-llu (Lucy Beaver) angalkugnek uqiquryaramek-llu qalartellruuk."
                ],
                [
                    "In the conference, these people talked: Joe Andrew (Kelucaq) and Edward Weiss talked about the custom of wiping the saliva of the brown or black bear on their faces. Kurt Bell, Joe Andrew (Kelucaq), and Person Unidentified talked about seal bladders. And then Kurt Bell admonished hunters not to shoot baby birds and birds with babies. Wassillie B. Evan (Ayagkaq) talked about respecting their catch and Eliza Chase (Mikngayaq Mik'aq) encouraged KYUK to have elders talk on the radio so that our traditional wisdom may not be forgotten. Edward Weiss talked about walking sticks and black bears. And finally, Phillip Moses of Tooksok Bay and Lucy Beaver (Urutaq) talked about shamans and seal parties."
                ]
            ],
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Kelucaq Joe Andrew] Taqukam tan'gerlim-llu nuaganek kegginateng mingugluku piciryarallrat",
                "[Kelucaq Joe Andrew] The custom of wiping the saliva of the brown or black bear on their faces"
            ],
            "15": [
                "01:23",
                "[Kurt Bell, Kelucaq Joe Andrew] Tan'gaurluq nakacuut ayautellrat; nakacuut",
                "[Kurt Bell, Kelucaq Joe Andrew] The boy who was taken away by the bladders; seal bladders"
            ],
            "94": [
                "08:19",
                "[Maqarualek Edward Weiss] Taqukam tan'gerlim-llu nuaganek kegginateng mingugluku piciryarallrat",
                "[Maqarualek Edward Weiss] The custom of wiping the saliva of the brown or black bear on their faces"
            ],
            "116": [
                "10:37",
                "[Kurt Bell] Inerqurluki tengmiat piyagat-llu piyagauluki pissusqevkenaki",
                "[Kurt Bell] Admonishment to not shoot baby birds and birds with babies"
            ],
            "141": [
                "13:56",
                "[Ayagkaq Wassillie B. Evan] Pitateng kencikluki",
                "[Ayagkaq Wassillie B. Evan] Reverence of their catch"
            ],
            "150": [
                "14:43",
                "[Mikngayaq Mik'aq Eliza Chase] \"Atawauyartuq qanercet'laquvciki ayuqucirturluta KYUK-mi\"",
                "[Mikngayaq Mik'aq Eliza Chase] \"It would be beneficial if you let them talk and teach us on KYUK\""
            ],
            "164": [
                "16:07",
                "[Maqarualek Edward Weiss] Ayaruq tegumiaqesqelluku tan'gerlim curukaqaku",
                "[Maqarualek Edward Weiss] Keep ahold of a walking stick for when a black bear attacks"
            ],
            "177": [
                "17:36",
                "[Phillip Moses, Urutaq Lucy Beaver] Angalkut; up'nerkami pitqerraarqan maklagmek uqiqurluteng",
                "[Phillip Moses, Urutaq Lucy Beaver] Shamans; seal parties in the spring for the first bearded seal"
            ]
        },
        "elderTags": [
            "23.42",
            "23.43",
            "23.40",
            "23.55",
            "23.51",
            "23.18",
            "23.71",
            "23.82"
        ],
        "tags": [
            "2.2.42",
            "2.2.38",
            "2.2.32",
            "2.2.17",
            "1.1.1",
            "1.1.2",
            "5.3.7",
            "5.3.6",
            "20.3.1",
            "5.5",
            "17.1.1",
            "8.4",
            "20.6"
        ]
    },
    "cpb-aacip-127-09w0vx3c.h264": {
        "videoID": "cpb-aacip-127-09w0vx3c.h264",
        "title": "Uliggaq Martha Oscar Sara, Kumangulria Matthew Bean - # 11",
        "time": "18:02",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Uliggaq (Martha Oscar Sara), Kumangulria (Matthew Bean)-llu Kuigpagmiunguluni Mamterillermiunguluni-llu qalartellruuk up'nerkamek up'nerkiyallerkamek-llu. Cali-llu cikunek qanikcamek ulerpagmek-llu up'nerkami, Avgarutaaryaramek, kumlillranek-llu qalarrlutek."
                ],
                [
                    "Martha Oscar Sara (Uliggaq), and Matthew Bean (Kumangulria) from the Yukon and Bethel talked about the spring time and preparing for spring camp. They also talked about the ice, snow, and floods of spring, Avgarutaaryaraq (Sharing Festival), and natural freezers."
                ]
            ],
            "interviewer": [
                "Atmak Lillian Michaels"
            ]
        },
        "summary": {
            "1": [
                "00:08",
                "[Uliggaq Martha Oscar Sara] Kituucia",
                "[Uliggaq Martha Oscar Sara] Self introduction"
            ],
            "8": [
                "00:35",
                "Up'nerkiyallerkaq; ciku qanikcaq ulerpak-llu up'nerkami; utertaqata",
                "Preparing for spring camp; ice, snow, and floods in the spring; returning home"
            ],
            "62": [
                "05:12",
                "Avgarutaaryaraq",
                "Avgarutaaryaraq (Sharing Festival)"
            ],
            "83": [
                "06:50",
                "[Kumangulria Matthew Bean] Kituucia",
                "[Kumangulria Matthew Bean] Self introduction"
            ],
            "101": [
                "08:16",
                "Up'nerkami Kuigpagmi; maqaruanek unguluteng; ciku qanikcaq ulerpak-llu up'nerkami",
                "Springtime in the Yukon; to drive rabbits; ice, snow, and floods in teh spring"
            ],
            "142": [
                "11:59",
                "Neqaitellrani Kuigpagmi; up'nerkiyallerkaq; kumlivililleq",
                "Time of no fish in the Yukon; preparing for spring camp; making a natural freezer"
            ],
            "171": [
                "14:40",
                "Ulenkacagallrani",
                "Extreme flooding"
            ],
            "197": [
                "17:14",
                "Arnaq *nepaunani*",
                "Woman *no sound*"
            ]
        },
        "elderTags": [
            "23.81",
            "23.46"
        ],
        "tags": [
            "2.2.67",
            "2.2.38",
            "2.2.9",
            "1.1.1",
            "3.1.1",
            "9.7",
            "3.4",
            "3.5",
            "3.10",
            "20.4",
            "10.5.1"
        ]
    },
    "cpb-aacip-127-10jsxpvr.h264": {
        "videoID": "cpb-aacip-127-10jsxpvr.h264",
        "title": "Cialuq Paul G. Nicolai, Neviar Qakvaralria Lucy Nicholai - # 12",
        "time": "22:23",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Cialuq (Paul G. Nicholai) and Neviar-llu (atpiara Qakvaralria ellangluni-llu Iigmi; Lucy Nicholai) Kuigglugmiungulutek (from Kwethluk) amllernek ayuqenrilngurnek qalartellruuk. Ayaruq wall'u cikuliurun up'nerkami nantesqevkenaku; inerquutet alerquutet-llu maliggluki; eyagyaram alerquutainek; qungumi akiutnek; ayagyuat akusrartellratnek; canek-llu allanek qalartellruuk."
                ],
                [
                    "Paul G. Nichoali (Cialuq) and Lucy Nicholai (Neviar; originally named Qakvaralria and raised in Eek) from Kwethluk (Kuiggluk) talked about many different things. They talked about having to always have a walking stick or ice spud/pick/chisel; to follow the admonishments and rules; the teachings of traditional abstinence practices; possessions on a grave; teenagers becoming mischievous; and other topics."
                ]
            ],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "11": [
                "00:59",
                "[Cialuq Paul G. Nicholai] Inerquun up'nerkami; \"Cikuliurutraq nantesqevkenaku iinguan.\"",
                "[Cialuq Paul G. Nicholai] Admonishment for the springtime; \"They would tell us to always have an ice spud because it's our eyes.\""
            ],
            "24": [
                "02:17",
                "[Qakvaralria Neviar Lucy Nicholai] Ayaruq; \"Nepaunata pilaasqelluta.\"",
                "[Qakvaralria Neviar Lucy Nicholai] Walking stick; \"They told us to be quiet.\""
            ],
            "40": [
                "03:50",
                "[Cialuq Paul G. Nicholai] Up'nerkiyalleq; qanganaat; taluyat kapkaanat-llu;",
                "[Cialuq Paul G. Nicholai] Spring time; ground squirrels; fish traps and steel traps"
            ],
            "57": [
                "05:33",
                "Merr'illuki unkumiutaat",
                "Giving water to seals"
            ],
            "71": [
                "06:48",
                "[Qakvaralria Neviar Lucy Nicholai] Aglenraraat irnicuallret-llu eyagyarait",
                "[Qakvaralria Neviar Lucy Nicholai] Traditional abstinence practices for girls who has recently menstruated for the first time and women who miscarried"
            ],
            "113": [
                "10:32",
                "[Cialuq Paul G. Nicholai] Iralut; qungumi akluit",
                "[Cialuq Paul G. Nicholai] Months; possessions on graves"
            ],
            "138": [
                "12:59",
                "[Qakvaralria Neviar Lucy Nicholai] Nasaurluut alerquutait; \"Arnaq-gguq tuquuguq.\"",
                "[Qakvaralria Neviar Lucy Nicholai] Rules for girls; \"A woman leads to death.\""
            ],
            "144": [
                "13:59",
                "[Cialuq Paul G. Nicholai] Cikuliurun; \"Uitayukuni-ll' tua-i camek piinani.\"",
                "[Cialuq Paul G. Nicholai] Ice spud/pick/chisel; \"And if he's sedentary, he won't have anything.\""
            ],
            "163": [
                "15:57",
                "Ayagyuat akusrarneruut; taangaq; ellminek tuqutellerkaq",
                "Teenagers becoming mischievous; alcohol; suicide"
            ],
            "187": [
                "18:03",
                "Nerangnaqsaraq; taluyat",
                "Subsistence; fish traps"
            ],
            "199": [
                "19:26",
                "Takaqluki tegganret; Yugcetun qaneryararput; Kuiggluum ayuqucillranek",
                "Respect for elders; Yup'ik language; how Kwethluk was back then"
            ]
        },
        "elderTags": [
            "23.26",
            "23.62"
        ],
        "tags": [
            "2.2.39",
            "2.2.29",
            "1.1.1",
            "3.1.1",
            "9.7",
            "17.1.1",
            "17.1.2",
            "5.3.8",
            "5.4",
            "5.4.3",
            "19.4.1",
            "19.7.1.1",
            "22.1.1",
            "19.7",
            "3.6",
            "13.1.1",
            "7",
            "9.6",
            "4.1",
            "22.5",
            "22.4",
            "9",
            "17.1.6",
            "19.14",
            "4.2",
            "1"
        ]
    },
    "cpb-aacip-127-10jsxpwg.h264": {
        "videoID": "cpb-aacip-127-10jsxpwg.h264",
        "title": "Kelucaq Joe Andrew, Urutaq Lucy Beaver, Kamluq Kirt Bell - # 13",
        "time": "22:27",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Joe Andrew (Kelucaq), Urutaq-llu (Lucy Beaver) qalartellruuk Mamterillermi alerquutnek yuilqurmiutarnek, kenciksaraanek nunam, cali-llu aulukiyaramek yaqulegnek kayangunek-llu. Kinguakun (Kurt Bell) merr'iciyaramek pitanek qalarrluni."
                ],
                [
                    "Joe Andrew (Kelucaq) and Lucy Beaver (Urutaq) talked in Bethel about instructions for animals of the wilderness, reverence of the land, and also about taking care of birds and bird eggs. After them, Kurt Bell talked about giving water to animals."
                ]
            ],
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "14": [
                "00:54",
                "[Kelucaq Joe Andrew] Alerquutet yuilqurmiutaat; qigcikluki caanguaqevkekenaki pitarkat; yuum allam pikenrilkiinek tegutevkenata",
                "[Kelucaq Joe Andrew] Instructions for animals of the wilderness; respect and don't waste their catch; do not take what isn't yours"
            ],
            "54": [
                "06:54",
                "[Kelucaq Joe Andrew] \"Meq taicingareskan qanlartukut, 'Iliit-gguq-am imarpigmi pitliniuq.'\"",
                "[Kelucaq Joe Andrew] \"When the water suddenly gets foggy, we say, 'So, someone has caught something in the ocean.'\""
            ],
            "60": [
                "07:45",
                "[Urutaq Lucy Beaver] Kencikluki nuna nunamiutaat-llu; \"sagtelriartaitellruuq nunam qainga tamarmi\"",
                "[Urutaq Lucy Beaver] Reverence of the land and land animals; \"There was no mess in all of the land.\""
            ],
            "86": [
                "10:32",
                "[Urutaq Lucy Beaver] \"Uniciyuunii wiinga iqvatuunga ilumun\"",
                "[Urutaq Lucy Beaver] \"Truly, I do not leave behind anything when I pick berries.\""
            ],
            "99": [
                "11:47",
                "[Kelucaq Joe Andrew] Yaqulget up'nerkami; kuvyallret; negarluki qangqiiret; kayangut; \"Uqlauskumteki-gguq wangkutnun cikiutekenrirciqai\"",
                "[Kelucaq Joe Andrew] Birds in the spring; old fish nets; snaring/trapping for ptarmigan; eggs; \"They said that if we pollute nature with them, they will not be given to us aymore.\""
            ],
            "129": [
                "15:41",
                "[Kelucaq Joe Andrew] Aulukiyaraq yaqulegnek; yaqulget piyagaat",
                "[Kelucaq Joe Andrew] Taking care of birds; baby birds"
            ],
            "151": [
                "18:38",
                "[Kelucaq Joe Andrew] Aulukiyaraq kayangunek",
                "[Kelucaq Joe Andrew] Taking care of bird eggs"
            ],
            "83": [
                "10:05",
                "[Kurt Bell] Merr'icaraq; pitaqeqarraaraqaku maklagmeng",
                "[Kurt Bell] Giving water to animals; when catching his first bearded seal"
            ]
        },
        "elderTags": [
            "23.43",
            "23.82",
            "23.40"
        ],
        "tags": [
            "2.2.38",
            "2.2.17",
            "1.1.1",
            "1.1.2",
            "19.6",
            "19.9",
            "3.9",
            "5.3",
            "9.5.1",
            "22.3",
            "5.2",
            "17.1.3",
            "5.2.1",
            "9.5.2.1",
            "5.5",
            "19.4.1"
        ]
    },
    "cpb-aacip-127-10jsxpx6.h264": {
        "videoID": "cpb-aacip-127-10jsxpx6.h264",
        "title": "Allranitailnguq Allran'aq Joe Chief Sr. - # 14",
        "time": "21:49",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Allranitailnguq Allran'aq (Joe Chief Sr.) Urucararmiungullruluni qalartellruuq Mamterillrem ayuqucianek anglillermini. Tua-i-llu amllernek qanruyutnek qalarrluni ukut ilakluki: nunavut kencikesqelluku, pisciigalnguut ikayuasqelluki, qanruyutvut-llu atauciuyaaqngatliniluni."
                ],
                [
                    "Joe Chief Sr. (Allranitailnguq Allran'aq), originally from Urucaraq, talked about what Bethel was like when he was growing up. Then he talked about a lot of traditional wisdom such as: to revere our land, to help ones who are unable, and how it seems our traditional wisdom is one."
                ]
            ],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Urucaram Mamterillrem-llu ayuquciak; qasgimi maqilleq; Luqinquq",
                "How Urucaraq and the area around Bethel was like; steam bath in the community house (qasgiq); Luqinquq"
            ],
            "66": [
                "05:30",
                "\"Nunavut meq-llu kencikesqelluku wangkuta qantamcetun pitarrluku.\"",
                "\"To revere our land and the water as much as our bowls.\""
            ],
            "86": [
                "07:19",
                "\"Wangkuta mat'um nalliini navguagukut wangkutnek.\"; aipirtuasqevkenaki aipamek tegupailgan; taangaq",
                "\"These days we are destroying ourselves.\"; to not have relations with another until taking a spouse; alcohol"
            ],
            "92": [
                "08:01",
                "\"Qasgimi-llu cali quyurcelluta iliini qanqautetullruitkut.\"",
                "\"They would also sometimes gather us in the community house and speak to us.\""
            ],
            "113": [
                "10:00",
                "\"Agu watqapiar tangnerrlugnarqengraan temciarautekqasqevkenaku. Tau͡gaam pisciigalnguq ikayuasqelluku.\"",
                "\"Never under any circumstances make fun of anyone struggling. Instead, he said to help someone who was unable.\""
            ],
            "135": [
                "12:00",
                "\"Arnaq-gguq tuquuguq\"",
                "\"They said that a woman is death.\""
            ],
            "166": [
                "15:03",
                "\"Nunami tamarmi qanruyutvut atauciuyaaqngatliniuq. Tau͡gaam yuum cali amllerem maa-i atunriraa.\"; qasgimi",
                "\"It seems that in all the land our traditional wisdom is one. But many people don't adhere to them anymore.\"; in the community house (qasgiq)"
            ],
            "183": [
                "16:49",
                "\"Ca tamalkuan anglanillrunrituq.\"; kass'artaat enurnarluteng; sun'at",
                "\"Nothing was taken lightly.\"; manufactured items were scarce; ships/barges"
            ],
            "216": [
                "20:05",
                "Agayuvigmi caliillerminek",
                "When he worked in the church"
            ]
        },
        "elderTags": [
            "23.7"
        ],
        "tags": [
            "2.2.65",
            "1.1.1",
            "2.2.38",
            "21.2",
            "19.9",
            "14.3",
            "22.5",
            "19.5",
            "7.2",
            "16.2.4"
        ]
    },
    "cpb-aacip-127-14nk9d19.h264": {
        "videoID": "cpb-aacip-127-14nk9d19.h264",
        "title": "Qavarliaq Johnny K. Guy - # 16",
        "time": "21:55",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Qavarliaq (Johnny K. Guy), Kuigglugmiu, qalartuq tuntunek, qasgimek Kuigglugmi, ayarunek, nukalpianek, Yugtun-llu qalarcaramek."
                ],
                [
                    "Johnny K. Guy (Qavarliaq), from Kwethluk, talks in the interview about reindeer, a community house (qasgiq) in Kwthluk, walking stick/canes, great hunters, and the Yup'ik langauge."
                ]
            ],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "8": [
                "00:35",
                "Tuntut tuntuciuryaraq-llu",
                "Reindeer and reindeer herding"
            ],
            "27": [
                "02:41",
                "Qasiq Kuigglugmi; yuraq; kalukaq",
                "The community house (qasgiq) in Kwethluk; dance; feast"
            ],
            "42": [
                "04:28",
                "Anguyalallratni; Aavaaq; Kuiggluum atra",
                "When they had war; Aavaaq; Kwethluk's name"
            ],
            "60": [
                "06:27",
                "Yuilqumi atu'urkat; ayaruq",
                "What to use in the wilderness; walking stick/cane"
            ],
            "74": [
                "08:37",
                "\"Ayagyuat inerciigalikaniirngat'lartut\"",
                "\"The young people look like they're getting more mischievous.\""
            ],
            "94": [
                "10:38",
                "\"Yugcetun cagmayunaituq qanelput.\"",
                "\"Our Yup'ik language should not be lost.\""
            ],
            "105": [
                "12:18",
                "Qanruyutet Qaneryaraqegtaar-llu",
                "Traditional wisdom and the Bible"
            ],
            "117": [
                "14:24",
                "Nukalpiat; nerangnaqsaraq Kass'am alerquutai-llu",
                "Great hunters; subsistence and Western rules"
            ],
            "138": [
                "17:23",
                "Elitnaurviit; Yugtun qalarcaraq",
                "Schools; Yup'ik language"
            ],
            "151": [
                "19:17",
                "\"Angayuqaita-wa yut'eng inerqurarkaukait tuaten pisqevkenaki.\"; Yugtun qalarcaraq",
                "\"Parents must admonsih their children against doing [bad] things.\"; Yup'ik language"
            ]
        },
        "elderTags": [
            "23.73"
        ],
        "tags": [
            "2.2.39",
            "1.1.1",
            "5.3.1",
            "16.2.3",
            "21.2",
            "20.2",
            "15.1.1",
            "17.1.1",
            "1",
            "8.1.3",
            "4.3",
            "9",
            "16.4"
        ]
    },
    "cpb-aacip-127-15p8d31m.h264": {
        "videoID": "cpb-aacip-127-15p8d31m.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip, Ingallak George Keene, Alciq Maxie Altsik - # 17",
        "time": "21:35",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Wani quyurrvigmi pingayun angutet qalartellruut. Ciumek Ingallaq (George Keene) niicugnilriit cingumallrui qalaruqu'uraasqelluuki ayagyuat qanruyutnek Yugtun-llu qalarcaramek. Tua-i-llu kinguani Alciq (Maxie Altsik) qalartellruuq waten, takaqluki ayuqucirtuutet teggutekngamteki. Nangnermi Maqista Ac'urunaq (Joshua Phillip) qalartellruuq qaillun akaarnun unguvamayugngacimten̄ek."
                ],
                [
                    "In this conference, three men talked. First, George Keene (Ingallaq) encouraged the people listening to keep talking to the youth about the traditional wisdom and the Yup'ik language. Next, Maxie Altsik (Alciq) talked about showing respect to our traditional teachings because they are our support. Lastly, Joshua Phillip (Maqista Ac'urunaq) talked about how we can live a long life."
                ]
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Ingallaq George Keene] Qalamciuq waten kangingqerrluni, \"Qalarucuilavteng waniw' kemgitut. Elpet elisngaluten uquriuten.\"",
                "[Ingallaq George Keene] He tells a story with this meaning, \"They're skinny because you don't instruct them. You are fat in your knowledge.\""
            ],
            "23": [
                "02:21",
                "[Ingallaq George Keene] \"Kass'arngariut, ilait-llu Yugtun taringesciigaliluteng.\"",
                "[Ingallaq George Keene] \"They're becoming Westernized, and some don't understand Yup'ik anymore.\""
            ],
            "62": [
                "06:24",
                "Kepqetaalria",
                "Cut out scenes"
            ],
            "80": [
                "08:26",
                "[Alciq Maxie Altsik] \"Ak'allarpall'ermek ayuqucirtuutmek teggutengqertukut.\"; atunem ilaliurutleq",
                "[Alciq Maxie Altsik] \"We have this extremely ancient instruction as our support.\"; welcoming each other"
            ],
            "111": [
                "13:14",
                "[Alciq Maxie Altsik] \"Una assilriim tungiinun caliarteng caliaqerkaugaat.\"",
                "[Alciq Maxie Altsik] \"They must work for the good [of our people].\""
            ],
            "124": [
                "15:24",
                "[Maqista Ac'urunaq Joshua Phillip] Arnassagat angukara'urluut-llu allrakungqellriit; \"Kenekngamegtekut qalarut'lallrukaitkut.\"",
                "[Maqista Ac'urunaq Joshua Phillip] Old men and women with long lives; \"They talked to us because they loved us.\""
            ],
            "140": [
                "17:10",
                "[Maqista Ac'urunaq Joshua Phillip] Aviukaqsaraq; Ellam Yua Agayun-llu",
                "[Maqista Ac'urunaq Joshua Phillip] Food and water offerings; the Spirit of the Universe and God"
            ],
            "155": [
                "18:56",
                "[Maqista Ac'urunaq Joshua Phillip] Uqlaneq; akaarnun yuuqerciquq / unguvamanaurtuq",
                "[Maqista Ac'urunaq Joshua Phillip] Pollution; living a long life"
            ]
        },
        "elderTags": [
            "23.52",
            "23.37",
            "23.6"
        ],
        "tags": [
            "2.2.42",
            "2.2.36",
            "2.2.31",
            "2.2.23",
            "1.1.1",
            "19.5",
            "1",
            "19.6",
            "8.6",
            "8.2",
            "3.9.1"
        ]
    },
    "cpb-aacip-127-16pzgr3f.h264": {
        "videoID": "cpb-aacip-127-16pzgr3f.h264",
        "title": "Ayagkaq Wassillie B. Evan - # 18",
        "time": "21:28",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Ayagkaq (Wassillie B. Evan) qalartellruuq nunamta ayuqucianek atanirtuucianek-llu. Cali-llu yuuyaramek ciulirnerteggun qanruyutetgun qalarrluni."
                ],
                [
                    "Wassillie B. Evan (Ayagkaq) talked about the condition and governance of our land. He also talked about the traditional way of life through the elders and traditional wisdom."
                ]
            ],
            "interviewer": [
                "Alexie Isaac"
            ]
        },
        "summary": {
            "4": [
                "00:40",
                "Nunavut; yuungnaqsaraq; Native Allotment; Yup'ik Nation",
                "Our land; subsistence; Native Allotment; Yup'ik Nation"
            ],
            "60": [
                "09:19",
                "Yuuyaraq ciulirnerteggun qanruyutetgun; \"Wangkutnek-gguq piurqumta qaillun-gguq yuullerput ayagciqa?\"",
                "The traditional way of life through the elders and tradtional wisdom; \"If we [govern] ourselves, how will our lives go?\""
            ],
            "110": [
                "17:04",
                "Kepqetaalria *nepaunani*",
                "Cut out scenes *silent*"
            ]
        },
        "elderTags": [
            "23.18"
        ],
        "tags": [
            "2.2.32",
            "1.1.1",
            "3.9",
            "9",
            "16.2.1",
            "24.2",
            "19.8",
            "19.5"
        ]
    },
    "cpb-aacip-127-18rbp380.h264": {
        "videoID": "cpb-aacip-127-18rbp380.h264",
        "title": "Urutaq Lucy Beaver, Kelucaq Joe Andrew, Mikngayaq Mik'aq Eliza Chase, Carl Flynn - # 19",
        "time": "22:30",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Quyurtellratni Urutaq (Lucy Beaver) qalartellruuq angutet akluita unakellrita-llu aulukellritnek uqlanermek-llu. Tua-i-llu Kelucaq (Joe Andrew) qalartellruuq neqkallernek inerquutnek cali-llu atsanek naunranek-llu."
                ],
                [
                    "At the conference, Lucy Beaver (Urutaq) talked about caring for men's clothes and catch and about pollution. Then Joe Andrew (Kelucaq) talked about admonishments for old food and about berries and plants."
                ]
            ],
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Urutaq Lucy Beaver] Angutet akluit allakarmeng iqailallruit; Angutet unakellrit qigcikluki uqlautevkenaki auluktullruit",
                "[Urutaq Lucy Beaver] They washed the men's clothes separately; \"They took care of what the men caught and did not pollute nature with them out of respect.\""
            ],
            "26": [
                "02:54",
                "[Urutaq Lucy Beaver] \"Qigcikluku yuum pivianun, yuum piyaraanun pisqumamayuitellruitkut.\"; \"Taluyam nuniini kuvyam-llu nuniini aruarkanek piyuitut.\"; uqlaneq",
                "[Urutaq Lucy Beaver] \"They told us not to go to people's gathering spots out of respect.\"; \"They didn't put what would spoil around fish trap or drift net areas.\"; pollution"
            ],
            "50": [
                "06:05",
                "[Kelucaq Joe Andrew] \"Mat'umun kuigmun kiagaqan kiagcetarnek allragnillarnek neqlernek egcivikesqevkanaku watqapik.\"",
                "[Kelucaq Joe Andrew] \"In the summer, we should never throw old food from last summer or last year into the river.\""
            ],
            "77": [
                "10:26",
                "[Kelucaq Joe Andrew] \"Inerquutauluteng piqertuutaq aturluku neqnun taukunun pisqevkenata.\"; Leftover-aat qimugtelegnun tuntuit",
                "[Kelucaq Joe Andrew] \"They admonished us against using axes on those fish.\"; They give the leftovers to people with dogs."
            ],
            "101": [
                "13:00",
                "[Kelucaq Joe Andrew, Urutaq Lucy Beaver] Atsat tutmarluki pisqevkenaki; napat iluatnek iqvatukait; tulukaruut neqait; naunraat; uquutvaguaq; ikiituk; cuassaaq; ciilqaaq; paparnaq; \"Amllerpagmek ciptarkamek avurcecuitellruitkut\"",
                "[Kelucaq Joe Andrew, Urutaq Lucy Beaver] Don't step on the berries; berries they picked among the trees; baneberries; plants; poison water hemlock; wild celery; wild greens; fireweed; yellow pond lily; \"They wouldn't let us gather more than we needed.\""
            ],
            "159": [
                "20:02",
                "[Mikngayaq Mik'aq Eliza Chase, Carl Flynn]  \"Nallukengaci amlleqapiartut.\"",
                "[Mikngayaq Mik'aq Eliza Chase, Carl Flynn]  \"There is so much that you all don't know.\""
            ],
            "170": [
                "21:19",
                "[Kelucaq Joe Andrew] Avelngaat neqait",
                "[Kelucaq Joe Andrew] Mouse food"
            ]
        },
        "elderTags": [
            "23.82",
            "23.43",
            "23.55",
            "23.25"
        ],
        "tags": [
            "2.2.38",
            "2.2.21",
            "1.1.1",
            "3.9.1",
            "9.10",
            "19.6.3",
            "9.5.1",
            "6.1",
            "9.5",
            "6.2",
            "9.5.3"
        ]
    },
    "cpb-aacip-127-20fttjr7.h264": {
        "videoID": "cpb-aacip-127-20fttjr7.h264",
        "title": "Nauciralrea Joseph Friday, Nirraralria Ulric Nayamin - # 20",
        "time": "22:33",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Nauciralrea (Joseph Friday) Yuk-llu (Unidentified) qanertuk ayagyugarnun elitnaurvigmi up'nerkameng qanruyutmeng. Cingumaakek ayagyugat qaneryaramegteggun. Tau͡ga-llu cali pingnatugyaramek imarpigmi, nerangnaqsaramek, pissunermek-llu narulkakun qanertuk."
                ],
                [
                    "Joseph Friday (Nauciralrea) and Person (Unidentified) speak to school kids about the springtime traditional wisdom. They encouraged the kids to follow the traditional wisdom. They talked about the providing in the ocean, subsistence, and seal hunting with spears."
                ]
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Up'nerkangaqan nayirtellriit; Tegganrurtellriit-llu cingumaluki ayagyugat qaneryaramegteggun.",
                "Seal hunters in the spring; Elders encourage (push) the youth with their traditional wisdom."
            ],
            "22": [
                "03:36",
                "Cellangellrani ayuqucia; Caliuratuluci ikayuqu'urluki allat yuut.",
                "How it was when he first became aware; Keep working hard and help others."
            ],
            "58": [
                "08:49",
                "Qaneryaraq yaaqvaneng taillruuq",
                "Traditional wisdom has come from a long time ago."
            ],
            "65": [
                "09:45",
                "\"Eglertarkauguci navenrilkurrluku. Ayagyugaam ilii ellmineng navgaquq. Qaneryaraq atungnatugluku, umyugarci imangarkauguq.\"",
                "\"You must travel, trying not to destroy [your future]. Some young people here destroy themselves. Keep trying to use the traditional wisdom, and your mind will be filled.\""
            ],
            "78": [
                "12:03",
                "Pingnatugyaraq imarpigmi (irumegteggun)",
                "Striving in the ocean (using their legs)"
            ],
            "88": [
                "13:56",
                "Nerangnaqsaraq",
                "Subsistence"
            ],
            "94": [
                "15:04",
                "Aipanglleq maklagneng-llu",
                "Getting a partner and bearded seals"
            ],
            "100": [
                "16:09",
                "Pissulleq narulkaquluteng nutegkun piyuitellermeggni",
                "Hunting with spears when they didn't use guns"
            ],
            "115": [
                "18:36",
                "Pingnatugyaraq imarpigmi (tallimegteggun)",
                "Striving in the ocean (using their arms)"
            ]
        },
        "elderTags": [
            "23.59",
            "23.64"
        ],
        "tags": [
            "2.2.18",
            "1.1.2",
            "19.5",
            "19.2",
            "9.2",
            "9",
            "9.1",
            "17.3.1",
            "12",
            "5.4.1",
            "5.4.2"
        ]
    },
    "cpb-aacip-127-25k98x78.h264": {
        "videoID": "cpb-aacip-127-25k98x78.h264",
        "title": "Apaqutaq Dick Andrew - # 25",
        "time": "21:23",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Apaqutaq (Dick Andrew) Kayalivigmiu interview-ami Aqumgacimek (John Active) qanemciuq irr'inarqelriamek cali-llu Kass'anek tangerqerraallerminek. Tua-i-llu qalarrluni yurarpatullratnek, kegginaqunek, yuarutnek, qasgirpagnek-llu Kayalivigmi. Cali-llu yuarutmek Qasgirpagmiutarnek aturpagluni."
                ],
                [
                    "Dick Andrew (Apaqutaq) from Kayalivik interviewed by John Active (Aqumgaciq) tells stories of strange things and when he first encountered Western people. The he talks about dance festivals, masks, Yup'ik songs, and the two large qasgiq (\"communiy houses\") at Kayalivik. He also sings a song about the Qasgirpagmiut."
                ]
            ],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciuq irr'inarqelriamek; \"yuum umyugaa qancurlaglua-llu qanrutesqevkenaku\"",
                "Tells a strange story; \"for a person's mindset, they told me not to speak harshly to him\""
            ],
            "44": [
                "04:40",
                "Kass'anek tangerqerraallra Kayalivigmi",
                "When he first encountered Western people at Kayalivik"
            ],
            "89": [
                "08:57",
                "Yuuyaraput nalluyagucaqunaku; \"Ellii Kass'atun ayuqsung'ermi ayuqesciigatuq akiutailkuni. Tau͡gken Yugcetun ayuqekuni akiutaileng'ermi kaigngaunani-ll' tua-i.\"",
                "Don't forget our way of life; \"Even if he wants to be Western, he cannot be without money. However, if he is traditionally Yup'ik, even without money, he will never be hungry.\""
            ],
            "102": [
                "10:02",
                "Yurarpatullratni; kegginaqut",
                "Dance festivals; masks"
            ],
            "141": [
                "13:48",
                "Ayagyuat cegganqepiarluteng",
                "The youth were very energetic"
            ],
            "155": [
                "15:09",
                "Yuarutet; qasgirpiik Kayalivigmi; yuarun Qasgirpagmiut",
                "Yup'ik songs; the two large qasgiq (\"community houses\") at Kayalivik; song about the Qasgirpagmiut"
            ]
        },
        "elderTags": [
            "23.15"
        ],
        "tags": [
            "2.2.38",
            "1.1.1",
            "2.2.20",
            "15.2",
            "16.2",
            "19.8",
            "20.2",
            "20.2.3",
            "4.1",
            "20.2.2",
            "21.2"
        ]
    },
    "cpb-aacip-127-25x69tk3.h264": {
        "videoID": "cpb-aacip-127-25x69tk3.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm, Kumangulria Matthew Bean, Allranitailnguq Allran'aq Joe Chief Sr. - # 26",
        "time": "22:26",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Quyurtellratni ciumek Aqesgirpak (Mary Worm) qanertuq assirluteng yuusqelluki maligtaquurautesqelluki. Tua-i-llu Kumangulria (Matthew Bean) qanertuq neqpiat nerlauciitnek, uqlautnek. Tua-i-llu Allranitailnguq Allran'aq (Joe Chief Sr.) qanerluni naullutnek yuunrillermek taangamek teglegesqenrilucimek-llu."
                ],
                [
                    "In the conference, Mary Worm (Aqesgirpak) first spoke about how people should live good lives and be obedient. Then Matthew Bean (Kumangulria) talked about how the fish are eating pollution. And then Joe Chief Sr. (Allranitailnguq Allran'aq) talked about sickness, death, alcohol, and how people should not steal."
                ]
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Aqesgirpak Mary Worm] \"Assircaarluci yuusqelluci, qanruyuteci-llu caunrilkevkenaki. Atam maligtaquuraulluci yuusqaqici.\"",
                "[Aqesgirpak Mary Worm] \"I want you to become good people, and do not disregard the wisdom passed to you. Become obedient people and see.\""
            ],
            "59": [
                "07:35",
                "[Kumangulria Matthew Bean] \"Nallumten̄i tamaani akemkut akissulriit uqlautiitnek wangkuta tamakut neqpiput nerlalliniameng.\"",
                "[Kumangulria Matthew Bean] \"Because our salmon are eating the pollution from those making profit unbeknownst to us.\""
            ],
            "152": [
                "18:09",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] Naulluun; yuunrilleq; taangaq; teglegyaqunak",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] Sickness; death; alcohol; do not steal"
            ]
        },
        "elderTags": [
            "23.16",
            "23.46",
            "23.7"
        ],
        "tags": [
            "2.2.67",
            "2.2.65",
            "2.2.38",
            "2.2.28",
            "2.2.9",
            "1.1.1",
            "19.6.1",
            "5.1",
            "3.9.1",
            "13",
            "8.3",
            "22.5",
            "19.13.1"
        ]
    },
    "cpb-aacip-127-26xwdh7k.h264": {
        "videoID": "cpb-aacip-127-26xwdh7k.h264",
        "title": "Qen'gauq Oscar F. Alexie, Nurataaq Nelson Angapak - # 27",
        "time": "21:17",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Ciumek Qen'gauq (Fred Ollie) qalarrluni tua-llu Yuk (Unidentified) mumiggluki qanellri piuk. Negeqlirmetlerminek qanellruuq tua-i-llu una quyurtellratni Mamterillermi ikirrluku. Kinguani Nurataaq Nelson Angapak qalartellruuq Yugcetun Kass'acetun-llu nunamta arcaqallranek tegganret-llu qalarutkarkaullratnek yuuyaramten̄ek."
                ],
                [
                    "First, Fred Ollie spoke with Person (Unidentified) translating what he said, and he talked about when he lived in St. Mary's and then opened up the conference in Bethel. Next, Nurataaq Nelson Angapak talked in both Yup'ik and English about the importance of our land and how elders should be speaking about our way of life."
                ]
            ],
            "interviewer": [
                "Qen'gauq Oscar F. Alexie (Naparyarraq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Qen'gauq Fred Ollie] Negeqlirmetlerminek",
                "[Qen'gauq Fred Ollie] When he lived in St. Mary's"
            ],
            "48": [
                "04:54",
                "[Nurataaq Nelson Angapak] Tegganret qalarutkarkaugaat yuuyaraput wall'u wangkuta piciryaraput ayagturallerkaa",
                "[Nurataaq Nelson Angapak] Elders should speak about how to continue our way of life or our culture"
            ],
            "109": [
                "13:20",
                "[Nurataaq Nelson Angapak] Nunaput arcaqerluni wangkutni; ciuliamta elitnaurciqakut yuuyaramek",
                "[Nurataaq Nelson Angapak] The importance of our land to us; our elders will teach us our way of life"
            ]
        },
        "elderTags": [
            "23.74",
            "23.65"
        ],
        "tags": [
            "2.2.68",
            "2.2.32",
            "2.2.30",
            "1.1.1",
            "2.2.38",
            "2.2.10",
            "19.8",
            "3.9"
        ]
    },
    "cpb-aacip-127-27zkh5wz.h264": {
        "videoID": "cpb-aacip-127-27zkh5wz.h264",
        "title": "Cuukvak Mary Neck - # 28",
        "time": "13:50",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Cuukvak (Mary Neck) Mamterillermiu cali-llu apqaurta qalarutellruuk iqvaryaramek akutanek-llu."
                ],
                [
                    "Mary Neck (Cuukvak) from Bethel and interviewer talked about picking berries and about akutaq (\"Eskimo ice cream\")."
                ]
            ],
            "interviewer": [
                "Inaanavr Carpenter"
            ]
        },
        "summary": {
            "16": [
                "01:32",
                "Iqvalallrani Mamterillermi",
                "Picking berries in Bethel"
            ],
            "41": [
                "04:07",
                "Akutaq; qasgimtelriit kelegluki",
                "Akutaq (\"Eskimo ice cream\"); inviting people in the qasgiq (community house)"
            ],
            "54": [
                "05:54",
                "Atsanek qemagciyarait; akutat ayuqenrilnguut: qerpertaq (kavirlit, luqruuyiit-llu meluit), passiaq, tenguggluk (neqpiat tenguit)",
                "Putting berries away; varities of akutaq (\"Eskimo ice cream\"): qerpertaq (red berries and pike eggs), passiaq, tenguggluk (fish livers)"
            ],
            "96": [
                "09:51",
                "Qanemciuq akutellermek",
                "Story of when she was making akutaq"
            ],
            "111": [
                "12:25",
                "Ingulagyagaq",
                "Ingulak Festival"
            ]
        },
        "elderTags": [
            "23.31"
        ],
        "tags": [
            "2.2.38",
            "1.1.1",
            "9.5.1",
            "6.1",
            "10.9",
            "21.2",
            "10.9.2",
            "10.9.1",
            "15.2",
            "20.5"
        ]
    },
    "cpb-aacip-127-28ncjzpp.h264": {
        "videoID": "cpb-aacip-127-28ncjzpp.h264",
        "title": "Ayagina'ar Nicholas Charles Sr., Nengqerralria Nengeq'aq Elena Charles, Mikngayaq Mik'aq Eliza Chase, Nauyaq Anna Andrew, Nauciralrea Joseph Friday, Allranitailnguq Allran'aq Joe Chief Sr., Ilanaq Theresa Moses, Kangrilnguq Paul John, Billy Lincoln Sr., Caingilnguq Albert Therchik, Uliggaq Martha Oscar Sara, Kumangulria Matthew Bean - # 29",
        "time": "50:28",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Una tangercetaaq amllernek tangercetaacuarnek imangqertuq yuut-llu qalarrluteng canek ayuqenrilngurnek. Ukut-llu tangercetaacuaraat tegumaut allanek tangercetaarnek assikekngaitnek."
                ],
                [
                    "This video is made of many clips and the people talk about various topics. These clips are taken from other videos that they liked."
                ]
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "[Ayagina'ar Nicholas Charles] Qercuakuni",
                "[Ayagina'ar Nicholas Charles] When getting a frostbite"
            ],
            "12": [
                "01:27",
                "[Ayagina'ar Nicholas Charles] Akerta ingrit-llu ellassuutekluki; qanganaat ellassutekluki",
                "[Ayagina'ar Nicholas Charles] Using the sun and mountains as weather devices; using ground squirrels as weather devices"
            ],
            "42": [
                "06:19",
                "[Nengqerralria Nengeq'aq Elena Charles] Yaaruin, airraq, inuguat",
                "[Nengqerralria Nengeq'aq Elena Charles] Storyknife, string games, dolls"
            ],
            "64": [
                "08:58",
                "[Nengqerralria Nengeq'aq Elena Charles] Angutet ayagaaqata pissuraqata",
                "[Nengqerralria Nengeq'aq Elena Charles] When men travel and hunt"
            ],
            "72": [
                "10:26",
                "[Nengqerralria Nengeq'aq Elena Charles] Allanret nernerrlugcetaarluki yuraraqata",
                "[Nengqerralria Nengeq'aq Elena Charles] Ridiculing visitors with a yuraq (\"Yup'ik dance\")"
            ],
            "93": [
                "13:14",
                "[Mikngayaq Mik'aq Eliza Chase] Uingellerminek; avvucaraq; taangaq nulirqellriik-llu; uikameggnek cucuklirluteng",
                "[Mikngayaq Mik'aq Eliza Chase] When she got a husband; divorce; alcohol and a married couple; choosing their own husband"
            ],
            "137": [
                "19:50",
                "[Nauyaq\tAnna Andrew] Neplirluta yuusqevkenata",
                "[Nauyaq\tAnna Andrew] They told us to not live loudly"
            ],
            "146": [
                "21:55",
                "[Nauyaq\tAnna Andrew] Eyallrani",
                "[Nauyaq\tAnna Andrew] When she followed abstinence practices"
            ],
            "152": [
                "23:15",
                "[Nauciralrea Joseph Friday] Qaygimi qaneryarameng egelracilriik",
                "[Nauciralrea Joseph Friday] The two who brought forth traditional wisdom in the community house"
            ],
            "161": [
                "24:49",
                "[Nauyaq\tAnna Andrew] Irniani anglicallerkaa inerquutet: eyuqsaunaki, yagiralaasqevkenaki, qatpagatesqevkenaki",
                "[Nauyaq\tAnna Andrew] Admonishments for child rearing: do not verbally defend them, do not raise your hand towards them, do not shout at them"
            ],
            "173": [
                "27:09",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] Maqilriit qasgimi Mamterillermi",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] Taking a steambath in the qasgiq (\"community house\") in Bethel"
            ],
            "180": [
                "28:38",
                "[Nauyaq\tAnna Andrew] Aipaqellriignun inerquutet: \"yuut assiinaku qanrutkengraatgu qanrut'laasqevkenaku\", \"kamakelaasqevkenaku iivkun tangenrrilkuvgu\", \"waten qanlaasqevkenii piiturlua\"",
                "[Nauyaq\tAnna Andrew] Admonishments for married couples: \"even if people say bad things about him, they told me not to tell him\", \"don't suspect him if you haven't seen it with your own eyes\", \"don't say that I have nothing\""
            ],
            "197": [
                "31:06",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] Mamterillrem ayuqucia kass'at amllerpek'nateng Aagurmiut Urucaram-llu akuliitni",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] How Bethel was like when there were few white people between Aagurmiut and Urucaraq"
            ],
            "214": [
                "33:48",
                "[Nauyaq\tAnna Andrew] Mikelnguut inerquutait: \"[allat] pingraatnga qialua utertelaasqevkenii\"",
                "[Nauyaq\tAnna Andrew] Admonishments for children: \"no matter what [others] do, she admonished me against coming home crying\""
            ],
            "227": [
                "36:20",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] \"Makut-llu tangnerrlugnarqellriit-wa tua-i makut pisciigalnguut-llu ikayuasqelluki pitullruitkut.\" Temciarautekesqevkenaki; teguqautesqevkenii",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] \"They also told us to help those who looked destitute and who were unable.\" And do not make fun of them; do not take anything"
            ],
            "237": [
                "37:56",
                "[Ilanaq\tTheresa Moses] \"Camek-ll' avaliciyunata nepaunata yuuluta\"",
                "[Ilanaq\tTheresa Moses] \"And we lived without making any excuses but were quiet.\""
            ],
            "247": [
                "39:25",
                "[Billy Lincoln Sr.] Ilakelriit nem iluani uitalriit",
                "[Billy Lincoln Sr.] A family living in a house"
            ],
            "257": [
                "41:18",
                "[Kangrilnguq Paul John, Caingilnguq Albert Therchik] Nepialillratni eneketullritnek; taluyat; naparcilluut",
                "[Kangrilnguq Paul John, Caingilnguq Albert Therchik] When they made a sod-house like they use to have; fish traps; grass baskets for fish"
            ],
            "279": [
                "45:13",
                "[Uliggaq Martha Oscar Sara, Kumangulria Matthew Bean] Qanikcarpatullrani up'nerkami; up'nerkiyaqata'arqameng",
                "[Uliggaq Martha Oscar Sara, Kumangulria Matthew Bean] When there was lots of snow in the spring; when they went to spring camp"
            ],
            "308": [
                "49:16",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] \"Man'a qanruyutvut: nunavut arcaqerluku meq-llu kencikesqumaluku pitullruitkut, wangkuta-gguq qantamcetun pitarrluku.\"",
                "[Allranitailnguq Allran'aq Joe Chief Sr.] \"This was the traditional wisdom passed to us: they told us to respect especially the land and water, and to treat it as if it were our dinner plate or soup bowl.\""
            ]
        },
        "elderTags": [
            "23.17",
            "23.61",
            "23.55",
            "23.60",
            "23.59",
            "23.7",
            "23.35",
            "23.41",
            "23.22",
            "23.23",
            "23.81",
            "23.46"
        ],
        "tags": [
            "2.2.67",
            "2.2.66",
            "2.2.65",
            "2.2.36",
            "2.2.30",
            "2.2.22",
            "2.2.18",
            "2.2.9",
            "1.1.1",
            "1.1.2",
            "11.1",
            "3",
            "3.2.1",
            "3.12.1",
            "2.3",
            "5.3.8",
            "18.3",
            "18.2",
            "18.1",
            "20.2",
            "14.3",
            "14",
            "14.4",
            "22.5",
            "19.7",
            "21.2",
            "21.2.1",
            "22.2",
            "2.2.38",
            "21.4",
            "21.3",
            "3.5",
            "9.7",
            "19.9",
            "19.8"
        ]
    },
    "cpb-aacip-127-33rv1b2m.h264": {
        "videoID": "cpb-aacip-127-33rv1b2m.h264",
        "title": "Ayagina'ar Nicholas Charles Sr. - # 32",
        "time": "10:11",
        "metadata": {
            "Date": "Unknown",
            "Short Summary:": [
                [
                    "Ayagina'ar (Nicholas Charles) interview-ami qalartuq uskumi ayagayaram alerquutiinek cikukun kiskuni, snukuukun ayagakuni, cali-llu pellaakuni."
                ],
                [
                    "Nicholas Charles (Ayagina'ar) in the interview talks about the rules of winter travel when falling through the ice, travelling by snowmachine, and getting lost."
                ]
            ],
            "interviewer": [
                "Atmak Lillian Michaels"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Ayaruq uksuarmi",
                "Walking stick in the fall"
            ],
            "18": [
                "01:48",
                "Cikukun kiskuni; canegnek ekiirluku qaini; qerruskuni teq'umek meq'uni qerrusngaituq",
                "Falling through the ice; lining his body with grass; if he is cold and he drinks urine, he will not freeze to death"
            ],
            "42": [
                "04:44",
                "\"Yuk cali natmun ayakataquni qanrucugngayaaqekai ilani tamaatmun ayagciqniluni\"",
                "\"If a person is going to travel somewhere, he can tell his family that he is going there.\""
            ],
            "51": [
                "05:39",
                "Kuigem alerquutii nalluvkenaki; ayaruq; snuukuukun ayagayaraq; cikum kianrem-llu ayuqucia; pellaakuni",
                "Do not forget the rules of the river; walking stick; travelling with snowmachine; the conditions of the ice and open holes; getting lost"
            ]
        },
        "elderTags": [
            "23.17"
        ],
        "tags": [
            "2.2.38",
            "1.1.1",
            "3.1.2",
            "17.1.1",
            "3.4",
            "11.2",
            "6.3",
            "22.12.2.1",
            "17.4.2",
            "3.4.1",
            "11.3"
        ]
    },
    "cpb-aacip-127-032282mq.h264": {
        "videoID": "cpb-aacip-127-032282mq.h264",
        "title": "Winifred Beans - # 4",
        "time": "12:53",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Out of state"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [
                "Interviewer"
            ],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "17": [
                "01:00",
                "Akmavet ayallermini irr’iklerminek, tangllerminek, umyuarteqlerminek-llu qalartuq.",
                "Talks about traveling out of state, what she was amazed by, saw, and thought."
            ],
            "55": [
                "04:29",
                "Alaska-mi nunamini ellamek, allrakumi ellalinqigcarainek, ayagayaramek (ayagcuutnek-llu), yuuyaramek-llu/pingnatugyaramek-llu qalarrluni, akmani piyaraitnun ayuqeltassiirluki.",
                "Talks about rural Alaskan climate, seasons, travel, subsistence compared to out of state."
            ],
            "78": [
                "07:41",
                "Akmavet ayallerminek, nengaumi-llu aaniin nuniinun piunriqatallrani quyurmeng ayallermeggnek qalarrluni.",
                "Talks about traveling out of state, and going to see son-in-law’s mother with family for her death."
            ],
            "104": [
                "11:00",
                "Akmavet ayallermini irr’illerminek qanemciluni: qunguturat mermiutaat [aquarium], ellicartaita-llu anglicetaallratnek [water show].",
                "Talks about what she was amazed at out of state: aquarium and water show."
            ]
        },
        "elderTags": [
            "23.85"
        ],
        "tags": [
            "2.2.10",
            "2.2.9",
            "11.6",
            "13",
            "3.1",
            "3",
            "5.4"
        ]
    },
    "cpb-aacip-127-0644j37r.h264": {
        "videoID": "cpb-aacip-127-0644j37r.h264",
        "title": "Tupagalria (?) Jacob Little (?) - # 7",
        "time": "10:06",
        "metadata": {
            "Date": [
                "1990*"
            ],
            "Short Summary:": [
                "Elder interview (Yup’ik Language)"
            ],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "cultural"
            ],
            "Quality:": [
                "Poor video"
            ],
            "Genre 4 (Location):": [
                "Bethel, AK"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "4": [
                "00:53",
                "Qalartuq ellangellerminek, pingnatugyaramek, calitullerminek, elluarluni-llu caliyaramek.",
                "Talks about early memories, subsistence, past work, and work ethic."
            ],
            "34": [
                "04:37",
                "Qalarrluni-llu qanruyutnek, qessayaram kaignarqucianek, caliamini-llu assikumaciminek.",
                "Talks about traditional wisdom, laziness leading to hunger, and being favored at his job."
            ],
            "50": [
                "06:46",
                "Mukaat, saarralat, saayut, kaassat, uqulkuut-llu imumi akikitellruciatnek maa-i-llu akituciatnek qalarrluni.",
                "Talks about past low and current high prices of pantry staples, gasoline, and motor oil."
            ],
            "66": [
                "08:11",
                "Piicagluni iqulirluku-llu.",
                "Prayer and last words."
            ]
        },
        "elderTags": [
            "23.79"
        ],
        "tags": [
            "2.2.34",
            "19.8.1",
            "9.2",
            "9",
            "9.6",
            "19.5",
            "19.6.4",
            "16.5",
            "16",
            "8.1.5"
        ]
    },
    "cpb-aacip-127-149p8hcz.h264": {
        "videoID": "cpb-aacip-127-149p8hcz.h264",
        "title": "Nauyaq Anna Andrew - # 15",
        "time": "22:02",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:01",
                "Qalartuq imumi yuullermeggnek, aipangyaram-llu qanruyutainek (nepaunatek aipaqlerkaak navguutiik-llu).",
                "Talks about the old way of life, and traditional wisdom about marriage (what makes it peaceful and what destroys it)."
            ],
            "20": [
                "02:59:134 - 00:07:51",
                "Ayagyuat qanruyutait ilateng mulngakesqelluki, neplingnaqevkenani yuullerkaq, neplitngulriit allamiuni nalluyuunaki, ilaminun tuss’arauyaraq, maa-i-llu akusrarrnarqellriit.",
                "Traditional wisdom for young people to treat each other well, not to start commotion, how word of mischievous people spread, to serve others, and current sources of mischief."
            ],
            "47": [
                "08:00",
                "Uimi aknirutekaanek qanlaasqevkenaku, irniateng mikelnguut qalarut’laasqelluki, irniateng eyurnaktukait yaggviktukait-llu ikiurtelauciat, nekayung’e’rmi-llu wall’u qiakuni tangercetesevkenani irniaminun.",
                "Do not say hurtful things to your husband, instruct their small children, how defending and raising a hand against children makes them bad, and not to slander or cry in front of your children."
            ],
            "79": [
                "12:41",
                "Uingqerrsaraq, arnassagarnek-llu inerquutet uimeng tungiitnun.",
                "How to live with a husband, and admonishments from old ladies about husbands."
            ],
            "93": [
                "15:27",
                "Angutet umyualinqigcarait arnat-llu umyualinqigcuiluciat.",
                "Men’s ability and women’s inability to change their ways."
            ],
            "104": [
                "17:22",
                "Arnaurtellerminek qalarrluni: cat tamalkuita eruusqelluki, angutet wall’u neqet amlliisqevkenaki, nuyavvlugtesqevkenani, angutet-llu mulngakesqelluki. Angutet arnat-llu caumacuunateng angutet qumaqitnayukluki, qantateng tuaten mumigucuunaki. Arnat ilait uinguangaqluteng.",
                "Talks about first menstruations: wash everything, not to step over men or food, keep hair neat, and be careful around men. Men and women were kept separate to prevent a sex crazed man, including separating bowls. Some women get imaginary husbands."
            ]
        },
        "elderTags": [
            "23.60"
        ],
        "tags": [
            "2.2.30",
            "14",
            "14.3.2",
            "19.3.2.1",
            "19.3.2",
            "19.10",
            "19.6.10",
            "19.7.1"
        ]
    },
    "cpb-aacip-127-225b014v.h264": {
        "videoID": "cpb-aacip-127-225b014v.h264",
        "title": "Mikngayaq Mik'aq Eliza Chase - # 21",
        "time": "22:05",
        "metadata": {
            "Date": [],
            "Short Summary:": [
                "Traditional wisdom for young people to treat each other well, not to start commotion, how word of mischievous people spread, to serve others, and current sources of mischief."
            ],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Qang’allugaq Hazel Lincoln"
            ]
        },
        "summary": {
            "8": [
                "00:23",
                "Qalartuq angayuqaagminun uikaminek cucukliucimallerminek, irniameng-llu aiparkiuryaraitnek.",
                "Talks about parents arranging for a husband, and the process of arranged marriage."
            ],
            "16": [
                "01:33",
                "Qalarrluni tan’gaurluut nasaurluut-llu aipaqucuiluciatnek",
                "Talks about how boys and girls wouldn’t play or get into relationships"
            ],
            "19": [
                "02:02",
                "Elluarluni nulirruyaraq (wall’u uingqerrsaraq), ayuqeltassiirluki arnat imumi maa-i-llu, (Yuut piciryaraicetun) takairutellrat elitnaurvigni eneni-llu, elitnauryallerminek-llu.",
                "How to be a good wife (or live with a husband), comparing women back then and now, loss of traditional social conduct at school and home, and when she went to school."
            ],
            "60": [
                "06:36",
                "Arnassagarnek elilluni elluarluni aipaullerkaminek aanaullerkaminek-llu, avvucaraq kassuusngayam-llu angtuarucia, Yuut-llu qanruyutait elitesqelluki.",
                "Learning from old women about how to be a good spouse and mother, divorce and the importance of marriage, and to learn from Yup’ik wisdom."
            ],
            "106": [
                "11:50",
                "Aiparkiutni-llu kassuusngallermegnek qalarrluni, maa-i avvuyutketukait, taangam iqui taqsaraa-llu, taqraarluteng ilateng-llu utumarcarait, imumi avvutellrianek tangyuitellerminek",
                "Talks about her arranged marriage, modern causes of divorce, effects of alcohol and recovery, healing from alcohol recovery, how she’s never seen divorce/separation back then"
            ],
            "166": [
                "19:25",
                "Qalarrluni angayuqaagminek niisngalleq elluarluni yuunaqniluku, aipateng qigcikesqelluki qaillun tangellrit ayuqengraata, mikelnguut-llu elitellrit elitnaurvigmun cimillrat.",
                "Talks about how obeying parents leads to a good life, respecting spouses no matter what they look like, and how children’s education is replaced with school."
            ]
        },
        "elderTags": [
            "23.55"
        ],
        "tags": [
            "2.2.38",
            "14.3.1",
            "14",
            "14.1",
            "14.4",
            "22.5",
            "19.14.1",
            "16.4"
        ]
    },
    "cpb-aacip-127-257d81kk.h264": {
        "videoID": "cpb-aacip-127-257d81kk.h264",
        "title": "Narullgiar Elena Nick - # 23",
        "time": "18:22",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Narull’aq, Elena"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Inaanavr Carpenter",
                "Anastasia Cooke Hoffman"
            ]
        },
        "summary": {
            "15": [
                "00:54",
                "Qanemciluni nasaurluullermini Nalqiglimi iqvaryatullerminek, atsat qemagcaraitnek, tunumek-llu akutetullermeggnek cimiucianek-llu saalamun.",
                "Talks about picking berries in her childhood in Nalqigliq, stories berries, and making Yup’ik ice cream with tallow and its replacement with shortening."
            ],
            "65": [
                "05:31",
                "Qalarrluni akutanek atsanek, avelngaat avutukaitnek, quagcinek-llu, Kuigpagmiutarnek akakiilegnek, mak’anek-llu qerpertanek-llu.",
                "Talks about Yup’ik ice cream with berries, mouse food, and sourdock, a Yukon variation with whitefish meat, and ones made with aged salmon roe and whitefish roe."
            ],
            "114": [
                "10:00",
                "Qalarrluni qayatgun iqvaryatullermeggnek, qavartatullermeggnek, tan’gerpiit-llu surat-llu qemagcaraitnek.",
                "Talks about going to pick berries by kayaking, camping, and storing crowberries and blueberries."
            ],
            "151": [
                "12:33",
                "Qalarrluni akucaramek kavirlinek/tumaglinek, qerpertanek-llu.",
                "She talks about making Yup’ik ice cream with low-bush cranberries, and with whitefish roe."
            ],
            "173": [
                "17:17",
                "Qalarrluni tan’gerpautminek, [apqaurtem] aanii-llu nasaurluullrani ayagatullermeggnek, mingqelriignek-llu.",
                "Talks about a store of crowberries, traveling with [interviewer’s] mom when she was a girl, and sewing."
            ]
        },
        "elderTags": [
            "23.58"
        ],
        "tags": [
            "2.2.35",
            "10.9",
            "6.1",
            "9.5.1",
            "10.9.3",
            "10.9.2",
            "17.4.3",
            "6.2.2"
        ]
    },
    "cpb-aacip-127-257d81m9.h264": {
        "videoID": "cpb-aacip-127-257d81m9.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm - # 24",
        "time": "22:06",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture"
            ],
            "Quality:": [
                "Good"
            ],
            "Genre 4 (Location):": [
                "Kangirnaq [Kongigonak]"
            ],
            "Name 1:": [
                "Mary Worm"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [
                "Kakianq [Adolph Lewis]"
            ],
            "Role 2:": [
                "Interviewer"
            ],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciuq angayuqaagmi uikarkiullragnun Kelliqucirmiuni aipangllerminek, Cevv’arnermiut yaaqsinrilkiitni Isrimiuni yuurtellerminek, Isrimiuni-llu up’nerkiyatullermeggnek.",
                "Talks about her arranged marriage in Kelliqucirmiut, being born in Isrimiut near Chefornak, and sping camp at Isrimiut."
            ],
            "32": [
                "03:41",
                "Qanemciluni ircenrraat angutet tekiskuneng ut’rutarkaitnek nasvatullratnek, apa’urluan uurcaq agiirtellria atuutetullranek, aturluku, angutet-llu pitarugameggnek ut’rutellratnek.",
                "Talks about legendary little people foretelling the men’s catch, his grandfather singing a welcoming song seeing the signaling gaff, singing the song, and the men bringing lots of catch."
            ],
            "63": [
                "07:37",
                "Qalarrluni kinguliaminek.",
                "Talks about his descendants."
            ],
            "76": [
                "09:27",
                "Qalarrluni nallmini angalkunek assilrianek assiilngurnek-llu, qinuciktullratnek, qanernailngurnek angalkunek, qavamini-llu angalkurtellerminek.",
                "Talks about good and bad shamans in her time, seeing them on the verge of death, peaceful shamans, and how she withstood a shaman in her dream."
            ],
            "122": [
                "15:18",
                "Qanemciluni angalkumek Cegg’amek au͡g’umek qavangurturcetesteminek.",
                "Talks about the shaman Cegg’aq who gave her those dreams."
            ],
            "152": [
                "18:32",
                "Qanemciluni Kuigilnguum [kuigem] paingani pelatekarugarnek angutet imarpigmiutarcullratni, Cegg’am-llu piunrillranek.",
                "Talks about many tents at the mouth of Kuigilnguq river as the men hunted in the ocean, and Cegg’aq passing away."
            ]
        },
        "elderTags": [
            "23.16"
        ],
        "tags": [
            "2.2.28",
            "14.3.1",
            "9.7",
            "15.3.1",
            "15.3.1.1",
            "15.1",
            "20.2.2",
            "8.4",
            "2.2.27",
            "9.1"
        ]
    },
    "cpb-aacip-127-2908kvc9.h264": {
        "videoID": "cpb-aacip-127-2908kvc9.h264",
        "title": "Narullgiar Elena Nick - # 30",
        "time": "22:12",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture"
            ],
            "Quality:": [
                "Good"
            ],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "7": [
                "00:32",
                "Qanemciluni Kass’ani uitatullerminek [Cakayiinkuni, John Samuelson] kipusvilegmek Nunapicuarmi, nunat ancitullratnek, Cakayiim-llu akusrarrluni irniaruciucianek.",
                "Story about how she stayed with Caucasians [Cakayak, John Samuelson, and family] with a trading post in Nunapitchuk, how villages exiled members, and how Cakayak fathered many children."
            ],
            "34": [
                "02:24",
                "Qanemciluni Qaluyaani yuurtellerminek, Kusquqvagmun upallermeggnek, elitnauryallerminek-llu.",
                "Stories of being born on Nelson Island, moving to the Kuskokwim, and going to school."
            ],
            "59": [
                "05:34",
                "Qalarrluni ciulirneret elitnauryallratnek, Yugtun-llu qalarcaaqaqata anucimirqecetaarumauciatnek.",
                "Talks about elders going to school, and being punished for speaking Yup’ik."
            ],
            "71": [
                "06:36",
                "Qalarrluni maa-i elitnaullermeggnun cumiguciatnek.",
                "Talks about more focus on school now."
            ],
            "82": [
                "07:42",
                "Qalarrluni maa-i tukuurtellratnek imumi-llu arrsauciatnek.",
                "Talking about how people have abundance today and how they didn’t have much back then."
            ],
            "106": [
                "09:52",
                "Qanemciluni Cakayiinkuni uitatullerminek, cat-llu tamalkuita erullerkaatnek carrirturallerkaatnek-llu elitellerminek.",
                "Story about how she stayed with Cakayak and family, and how she learned to clean everythign"
            ],
            "121": [
                "11:39",
                "Qalarrluni arnassagaam alerquutainek erurirturaasqelluku taqnerureskuni-llu, maa-i ayagyuat piyugngang’e’rmeng uitaurturauciatnek, arnassagaam-llu alerquutainek uingekuni aulukurarkaucianek.",
                "Talks about instruction from an older woman for cleaning and when she gets older, how modern teenagers know how to clean but don’t do anything, and how the old woman told her to work hard when she gets a husband."
            ],
            "158": [
                "15:16",
                "Qalarrluni arnat aanateng tangvagluki elitelauciatnek, panimini-llu mingqellri aulukumaciatnek.",
                "Talks about how daughters learn from watching their mothers, and how her daughters take care of what she sewed for them."
            ],
            "187": [
                "18:32",
                "Qalarrluni maa-i tukuurtellratnek, nuliameggnek-llu ikayurnarquciatnek, angutet arnat-llu caliarkait, maa-i-llu ayagyuat cayuilata naklekniluki.",
                "Talks about modern abundace, how men should help their wives, men’s and women’s work, and how she pities the youth who don’t do chores."
            ]
        },
        "elderTags": [
            "23.58"
        ],
        "tags": [
            "19.6.7",
            "2.2.35",
            "16.4",
            "16.3",
            "19.6.5",
            "14.2",
            "19.6.8",
            "21.7"
        ]
    },
    "cpb-aacip-127-322bvwfr.h264": {
        "videoID": "cpb-aacip-127-322bvwfr.h264",
        "title": "Nengqerralria Nengeq'aq Elena Charles - # 31",
        "time": "20:47",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:00",
                "Qalartuq imumi aklumeng neqkat-llu auluksaraitnek.",
                "Talks about taking care of clothes and food back then."
            ],
            "13": [
                "01:11",
                "Qalarrluni alerquutnek aipangvailegmi agturcetenritlerkaanek, imumi aipangvailegmeng aipaqsuilucimeggnek, aipangvailegmeng irniangellrem kasngunarqucianek, maa-i-llu ayagyuat aipangvailegmeng irnillrata tungiinun.",
                "Talks about traditional instructions about premarital relations, how they didn’t have relationships before marriage back then, how it was embarrassing to have illegitimate children, and her thoughts on youth having illegitimate children.s"
            ],
            "45": [
                "04:37",
                "Qalarrluni ayagyuat angayuqateng unilluki ayagalauciatnek, college-aaryartulauciatnek, ilaita-llu taangaryuuciatnek.",
                "Talks about youth travling without their parents, going to college, and some getting into alcohol."
            ],
            "60": [
                "06:27",
                "Qanemciluni elitnaullermini maurluni-llu uitatullerminek, maa-i-tun-llu yuut ayagavkenateng cangnatullratnek.",
                "Talks about staying with her grandmother during school, and how people didn’t travel around like now but worked hard."
            ],
            "75": [
                "08:09",
                "Qanemciluni Paingarmiunun yuraliyauciminek, imumi yuralgulauciatnek, Qaariitaaryaramek, Ingula[r]yaramek, Elciyaramek, Kevgiyaramek-llu.",
                "Talks about going to dance festivals in Paingarmiut, how there were many dance festivals back then, Qaariitaaq [Yup’ik Halloween], Ingula/Ingulaq dance festival, Elciq festival [precursor to the Bladder Festival], and Kevgiq [Messenger Feast]."
            ],
            "155": [
                "16:50",
                "Qanemciluni Kassiglumun upallermeggnek, agayulirtet-llu yuranermek taqevkallratnek.",
                "Talks about moving to Kassigluq [Kasigluk], and the missionaries stopping dance festivals."
            ],
            "167": [
                "18:11",
                "Qanemciluni Mamterillernun upallrucimegnek, up’nerkiyalaucimeggnek, irniangucimegnek elitnauryallritnek-llu, Mamterillrem nunakuarcuucingellranek, irniani-llu suuliyatullermeggnek.",
                "Talks about moving to Mamterilleq [Bethel], going to spring camp, having children and them going to school, increasing cars in Bethel, and going to the movies with her children."
            ]
        },
        "elderTags": [
            "23.61"
        ],
        "tags": [
            "2.2.66",
            "2.2.38",
            "2.2.36",
            "7",
            "10.10",
            "14",
            "11.6",
            "9.6",
            "20",
            "20.2.1",
            "20.1",
            "20.5",
            "16.2",
            "9.7",
            "19.13.17"
        ]
    },
    "cpb-aacip-127-35gb5sdj.h264": {
        "videoID": "cpb-aacip-127-35gb5sdj.h264",
        "title": "Carl Flynn - # 35",
        "time": "22:23",
        "metadata": {
            "Date": [
                "1985*"
            ],
            "Short Summary:": [
                "Cooking Eskimo fry-bread (Yup’ik Language)"
            ],
            "Genre 1:": [
                "Mini-Doc"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [
                "Edited video"
            ],
            "Location:": [
                "Bethel, AK [Mamterilleq]"
            ],
            "Name 1:": [
                "Elena Nick, Anna Cooke"
            ],
            "Role 1:": [
                "Subjects"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Sophie Evan"
            ]
        },
        "summary": {
            "1": [
                "00:07",
                "Qalartuq [Yugtun] ilaminek ayuqniarpek’nani nukalpiaruyuumilrianek, qalarrluni-llu [Kass’atun] apqaurluni elitellerkaanek, quliriluni-llu [Yugtun] kaigavikngani Agayun nekevraartumek naugivkallranek.",
                "Talks [YUP] about wanting to be good hunters without being jealous, talks [ENG] about asking questions to learn, tells [YUP] a legend about God helping a spruce tree to grow at request."
            ],
            "38": [
                "04:13",
                "Carl Flynn Tununermiu kituucini nalqiggluku, imumillarnek-llu quliriluni, quliriyaramek niicugniyaraitnek-llu.",
                "Carl Flynn of Tununak introduction, and tells a legend of long ago, how to make and listen to legends."
            ],
            "97": [
                "12:01",
                "Quliriluni angutmek cangayulriamek nuliaranek-llu canganarquciminek nallulriamek.",
                "Tells a legend about a man’s qualms with his wife who doesn’t know."
            ]
        },
        "elderTags": [
            "23.25"
        ],
        "tags": [
            "2.2.21",
            "15.3",
            "19.5.8",
            "19.6.7"
        ]
    },
    "cpb-aacip-127-35t76q2k.h264": {
        "videoID": "cpb-aacip-127-35t76q2k.h264",
        "title": "Angukarnaq Anissum Andrew Jacob - # 36",
        "time": "15:52",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal history"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Angukarnaq/Taluar/Allirkark [Anissum Andrew Jacob]"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:08",
                "Angukarnam/Taluaraam/Allirkaraam [Anissum Andrew Jacob] kituucini nalqigtaa, ilallerminek, upallerminek, kinguliaminek-llu.",
                "Angukarnaq/Taluar/Allirkar [Anissum Andrew Jacob] introduction, family history, moving, and descendants."
            ],
            "46": [
                "04:23",
                "Qanemciluni S’laavillerkameggnun agyalillerminek.",
                "Tells a story of making a Russian Christmas star."
            ],
            "87": [
                "08:08",
                "Qalarrluni S’laaviryarami imumi maa-i-llu cimillranek, ilakellerminek [?Zakhar] Levi-amek Ayimqeryararmiumek, S’laavirtarnek-llu yuarutnek elitellermeggnek.",
                "Talks about differences between past and current ways of Russian Christmas, his peer [?Zakhar] Levi from Kalskag, and learning Russian Christmas songs."
            ],
            "120": [
                "11:50",
                "Qanemciluni ayagyuallermini S’laavitullerminek, Kass’alugpiatun agayutullermeggnek, Nicky-mek-llu Tayarumiumek allgiliyam ikayurtiinek.",
                "Talks about Russian Christmas in his youth, church services in Russian, and the priest’s assistant Nicky from Unalaska."
            ]
        },
        "elderTags": [
            "23.11"
        ],
        "tags": [
            "2.2.33",
            "20.9.1",
            "8.1",
            "8.1.1.2",
            "8.1.2"
        ]
    },
    "cpb-aacip-127-37hqc4tk.h264": {
        "videoID": "cpb-aacip-127-37hqc4tk.h264",
        "title": "Angutevialuk Albert Beaver - # 37",
        "time": "21:15",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal history"
            ],
            "Quality:": [
                "Genre 4: (Location)"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Uquuviar Olinka Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:08",
                "Qanemciuq angalkumek Ississaayugmek Apruka’armiumek, sun’amek-llu kiagmi tekitetulimek.",
                "Tells a story about the shaman Ississaayuk from Apruka’ar, and a ship that comes in the summer."
            ],
            "30": [
                "03:34",
                "Qanemciluni Illugngalimek, sun’amek-llu tekitellriamek tuneniaryartutulimek.",
                "Tells the story of Illugngali, and a ship coming to trade."
            ],
            "66": [
                "08:06",
                "Qanemciluni ciuqlirmek sun’amek tuungrangayalegmek.",
                "Talks about the first ship and the devil coming with it."
            ],
            "74": [
                "09:09",
                "Qanemciluni Kass’artaat tekiteqerraallratnek.",
                "Talks about the first Western products."
            ],
            "116": [
                "14:10",
                "Qanemciluni Kass’artarteggun [neqetgun atuulriitgun-llu] yuungnaqlermeggnek. Kakianam/Mistussiikam-llu kiputetullranek aturcetaallranek-llu.",
                "Talks about utilizing Western things [food, materials] for survival, and Kakianeq/Mistussiikaq trading and playing instruments."
            ],
            "145": [
                "18:43",
                "Qanemciluni Kass’amek Parumek, Kass’at amlleriinallratnek sun’atgun aklunek tekiulluteng, Kass’amek Neqliyamek, Kass’artaat-llu paivngarillratnek.",
                "Talks about the Caucasian Paru, more Caucasians coming in ships with cargo, the Caucasian Neqliyaq, and increased use of Western things."
            ]
        },
        "elderTags": [
            "23.13"
        ],
        "tags": [
            "2.2.27",
            "8.4",
            "16",
            "16.2.4"
        ]
    },
    "cpb-aacip-127-37vmd1rq.h264": {
        "videoID": "cpb-aacip-127-37vmd1rq.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip - # 38",
        "time": "10:14",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:00",
                "Qalartuq kingkut angutngurtellrianek wall’u arnaurtellrianek aterpagtetukaitnek, alerquillerkam-llu arcaqaucianek.",
                "Talks about who they call old men or women, and the importance of passing on traditional instructions."
            ],
            "8": [
                "00:41",
                "Qalarrluni ilakuyucaramek, agayumacit cangallrunriluciatnek, kenekmek-llu.",
                "Talks about community, religions’ equality, and love."
            ],
            "20": [
                "02:28",
                "Qalarrluni nunam auluklerkaanek, qanruyutnek niiquratullermeggnek, ilakuyucaramek, Agayutem cakanirviirucianek, ayagyuat-llu elicungcallerkaitnek.",
                "Talks about taking care of the land, constant instruction of traditional wisdom, the sense of community, God’s unchanging nature, and teaching youth."
            ]
        },
        "elderTags": [
            "23.53"
        ],
        "tags": [
            "2.2.31",
            "2.2.30",
            "4.2",
            "19.5",
            "19.9.1",
            "21",
            "8",
            "19.10"
        ]
    },
    "cpb-aacip-127-386hdxkk.h264": {
        "videoID": "cpb-aacip-127-386hdxkk.h264",
        "title": "Fred Pavilla, Anguyaluk Taac'aq Olinka Pavilla - # 39",
        "time": "21:17",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [
                "Atmaulluaq (Atmauthluk)"
            ],
            "Name 1:": [
                "Fred Pavilla, Woman"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:01",
                "Fred Pavilla qanemciluni Atmaulluarmun upallermeggnek, Yuut-llu neq’legni nunangqetullratnek.",
                "Fred Pavilla alks about moving to Atmauthluk, and how Yupiit had settlements around food sources."
            ],
            "10": [
                "01:16",
                "Qalarrluni ayagatulriit alerquutaitnek, ayarunek, imarnitnek, ellalliurcuutnek, uksum-llu alerquutainek.",
                "Talks about traditional instructions for traveling, staffs, seal gut rain parkas, rain gear, and winter instructions,"
            ],
            "32": [
                "04:33",
                "Qanemciluni irniangellerkami tungiinun alerquuteminek, eyurutesqevkenaki, eyurnaktukait-llu qaillun ayuqlirilauciatnek.",
                "Talks about his insctruction on child-rearing, not to defend them, and how defended children become."
            ],
            "44": [
                "06:20",
                "Qalarrluni arenqiallugtellriit kangiitnek levaanek taangamek-llu.",
                "Talks about deaths increasing due to fast boat motors and alcohol."
            ],
            "54": [
                "07:57",
                "Qalarrluni yuum irniani qalarutlerkaanek, yuucurlagnarqellrianek, niicunrilnguut-llu mistuciatnek.",
                "Talks about instructing children, the causes of people not living well, and how those who misbehave are well known."
            ],
            "67": [
                "09:39",
                "Qalarrluni yuut qaillun ayuqengraata ilaliuresqelluki, ciuniuresqelluki, ikayuusqelluki-llu.",
                "Talks about socializing with people no matter what they’re like, be hospitable, and help them."
            ],
            "86": [
                "11:57",
                "Arnaq qalartuq arnat alerquutaitnek, tan’gaurluut-llu qanruyutait.",
                "Woman talks about traditional instructions for women, and traditional wisdom for boys."
            ],
            "93": [
                "12:47",
                "Qanemciluni anglluumaluteng ellangellerminek, qanruyutnek, unugmi anesqevkenaki, qalarucilriit ullaasqelluki, mulngakluki-llu yuusqelluki.",
                "Talks about being baptized in earliest memories, traditional wisdom, not to be out at night, going to listen to instruction, and to live carefully."
            ],
            "109": [
                "15:05",
                "Qalarrluni qanlerasqevkenaki, tan’gaurluut-llu qanleratevkenaki.",
                "Talks about not speaking harshly, and not speaking harshly to boys."
            ],
            "116": [
                "16:21",
                "Qalarrluni yuut alarteqatullratnek, cailkami qanrutestairutellratnek, inerquutet-llu niitenrilkunegteggu callerkaatnek.",
                "Talks about making miskates, not having instructors in random places, and consequences of not heeding admonishments."
            ],
            "128": [
                "18:08",
                "Qanemciluni aipangqatallermini qanrucimallerminek, talliirutlerminek, aipangllerkami tungiinun inerquutnek, irniangellerkami tungiinun qanruyutnek, maa-i irniangelrianek, angutet-llu aipangllerkaatnun alerquumallratnek.",
                "Talks about her instruction before marriage, losing her arm, admonishments about marriage, wisdom on having children, modern parents, and men being instructed on marriage."
            ]
        },
        "elderTags": [
            "23.33",
            "23.14"
        ],
        "tags": [
            "2.2.66",
            "2.2.36",
            "2.2.37",
            "19.13",
            "19.5",
            "14",
            "7",
            "19.13.14"
        ]
    },
    "cpb-aacip-127-386hdz1p.h264": {
        "videoID": "cpb-aacip-127-386hdz1p.h264",
        "title": "Kumkaq Noel Polty, Putyuk Puyuk Della Keats - # 40",
        "time": "1:01:44",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Edited Video"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Noel Polty [Kuigpak/Yukon]",
                "Dela Keetz [Iñupiuaq, Qikiqtaġruk/Kotzebue, orig. Nuataaq/Noatak]",
                "Marcelas Williams [Cree, out of state Native American]",
                "Joe Albright [translator]"
            ],
            "Role 1:": [
                "Subjects"
            ],
            "Name 2:": [
                "Mike Williams"
            ],
            "Role 2:": [
                "Host"
            ],
            "interviewer": [
                "Michael \"Mike\" Williams Sr. (Akiak)"
            ]
        },
        "summary": {
            "1": [
                "00:20",
                "Mike Williams-aam kituucini nalqiggluku, qalarrluni-llu Yugtarnek iinrunek, kap’itulinek, angukara’urluut-llu arnassagaat-llu aulukumallrata assirikanillerkaanek.",
                "Mike Williams introduction, talks of traditional medicine, acupuncturists, and improving elder care."
            ],
            "21": [
                "03:03",
                "Noel Polty apertuiguq Yugtarnek iinrunek [caiggluk/qanganaruaq, cuyaq, aluqatkaq, teptukuyak, enrilnguaq], Kass’artarnek iinrunek [kaputnek, iinrunek igtukaitnek], naumalriit-llu Agayutmek cikiutnguniluki.",
                "Noel Polty talks about traditional medicine [wormwood, tobacco leaf, beaver castor, beach greens, willow shoot], Western medicine [shots, pills], and plants being God’s gifts."
            ],
            "128": [
                "15:35",
                "Mike-am Dela Keetz-aaq Qikiqtaġrugmiu [Kotzebue] quyavikaa.",
                "Mike introduces Dela Keetz from Kotzebue."
            ],
            "131": [
                "15:55",
                "Dela Keetz-aam [Nuataarmiungulleq/Noatak] kituucini nalqigtaa, qanemciluni-llu ikayuayunqellerminek, atullermikun-llu naaqellermikun-llu yuungcariyaramek elitellerminek.",
                "Dela Keetz [orig. Nuataaq/Noatak] introduction, talks about helping people, and learning about medical treatment from experience and reading."
            ],
            "168": [
                "20:14",
                "Dela qanemciluni akngirtellerminek, mulngaksaramek, agluqugmi avqiqaarlutek kitugtellerminek, Cagtulegmun-llu kia agluquk kitugcartullerminek.",
                "Dela talks about getting injured, being careful, dislocating and relocating her jaw, and going to Shaktoolik to reset a jaw."
            ],
            "218": [
                "25:18",
                "Dela qanemciuq quyurtellriani tusgem avqitellrem eklerkaanek qalartellerminek.",
                "Dela talks about speaking at a conference about fixing a dislocated shoulder."
            ],
            "234": [
                "27:13",
                "Mike-am quyavikak Mercelas Williams [akemkumiu Ingqiliq], Joe Albright-aq-llu [mumigcistii].",
                "Mike introduces and thanks Mercelas Williams [out of state Native American], and Joe Albright [translator]."
            ],
            "236": [
                "27:33",
                "Marcelas Williams-aaq qanemciuq Cree-at Kass’anek tangerqerraallratnek, mikelnguut-llu tunuitni Cree-anun ilakuyuciata nallunailkutiinek.",
                "Marcelas Williams talks about Cree history, and a mark on children’s backs to show relation to Crees."
            ],
            "249": [
                "29:16",
                "Marcelas-aaq qalartuq yuut ayuqenrilengraata cangallrunriluciatnek, yuut nutem iinruitnek, nunat-llu elilluki yuungnaqsaramek.",
                "Marcelas talks about commonalities in all people, folk medicine, and adapting to and surviving in lands."
            ],
            "281": [
                "33:22",
                "Marcelas-aaq qalartuq eyagyarameggnek Yuut piicetun ayuqellrianek, yuut assilrianek assiilngurnek-llu ayuqucingqerruciatnek, yugnek tamaitnek caunriritulrianek, ellam-llu caunririlaucianek.",
                "Marcelas talks about similarities in spiritual Cree and Yup’ik practices, good and bad in people, common man-made destruction, and natural destruction."
            ],
            "317": [
                "38:06",
                "Marcelas-aaq qalartuq Ellamta kiimi unguvalriangqerrucianek, apqiitnek-llu Aanamta/Maurlumta Nunam aulukucianek.",
                "Marcelas talks about Earth being the only one with life, and Mother/Grandmother Earth providing."
            ],
            "349": [
                "42:27",
                "Marcelas-aaq qalarrluni arrsauyaramek [cautemegteggun, ciulirneritlermegteggun-llu].",
                "Marcelas talks about poverty [materially, and with elders]."
            ],
            "370": [
                "44:59",
                "Marcelas-aaq qanertuuq temaitgun, umyuaritgun, tarneritgun-llu calricaramek arrsaulriatun-llu ayuqsaraqmek.",
                "Marcelas talks about physical, mental, and soul health and poverty."
            ],
            "394": [
                "48:01",
                "Marcelas-aaq quliriuq tumyariurtem qetunraanek, piyunartacirramcetun ilaput kenkesqelluki, cikiutmeggnek-llu quyasqelluki.",
                "Marcelas tells a story of a railroad worker’s son, to give love in our own ways, and to be thankful for blessings."
            ],
            "433": [
                "52:26",
                "Marcelas-aaq qanemciluni ilairutminek.",
                "Marcelas talks about losing family."
            ],
            "456": [
                "54:59",
                "Mike-aq qalartuq quyurtellermeggni qaqitellermeggnek: tegganret niicugniyarturluki quyurtelangesqelluki, elitnaurvigmi imumi yuuciatnek elitnauresqelluki, taangayuirutlerkaatnun ikayuusqelluki, tegganret auluksaraitnek, quyurquraasqelluki. Mike-am quyavikekteng aperturai.",
                "Mike talks about the results of their gathering: elder teaching meetings, teaching the old way of life in school, alcohol rehabilitation, elder care, continue holding meetings. Mike gives aknowledgements."
            ]
        },
        "elderTags": [
            "23.47",
            "23.72"
        ],
        "tags": [
            "2.2.70",
            "2.2.69",
            "2.2.11",
            "22.12.2",
            "22.12.2.5",
            "22.12.1",
            "22",
            "8",
            "15.1"
        ]
    },
    "cpb-aacip-127-38w9gpk2.h264": {
        "videoID": "cpb-aacip-127-38w9gpk2.h264",
        "title": "Nevicuk \"Narr'aq\" Helen Nelson - # 41",
        "time": "18:55",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Narr’aq [Helen - Napakiak]"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Upay'aq Elena Miller Ulroan"
            ]
        },
        "summary": {
            "1": [
                "00:08",
                "Narr’am [Helen] kituucini nalqigtaa.",
                "Narr’aq [Helen] introduction."
            ],
            "19": [
                "01:17",
                "Qanemciluni pilianek neqsurcuutnek, ellangellerminek-llu.",
                "Talks about handmade fishing tools, and early childhood."
            ],
            "31": [
                "03:00",
                "Qalarrluni assirluni yuullerkaan qanruyutekainek, yuut cimillratnek, qanruyutet-llu kinguvallerkaatnek.",
                "Talks about traditional wisdom to live well, how people have changed, and the importance of passing down wisdom."
            ],
            "52": [
                "06:13",
                "Qalarrluni nasaurluut tan’gaurluut-llu qanruyutaitnek, nulirtuqsaingurmun tan’gaurlurmun nasaurluum mulngaklerkaanek, arnaq tuquuniluku, atailngurnek irniangesqevkenaki, tan’gaurluut nasaurlurnun pisqevkenaki, nulirrualrianek uingualrianek-llu, anglicarilriani-llu anglanilrianek.",
                "Talks about wisdom for girls and boys, for girls to be careful around unwedded boys, “a woman is death,” not to have illegitimate children, for boys not to approach girls, people with imaginary wives and husbands, and taking childrearing lightly."
            ],
            "81": [
                "09:53",
                "Qalarrluni qanengssangraata qanruyutnek qaruciarkaucimeggnek.",
                "Talks about passing down wisdom amongst gossip."
            ],
            "92": [
                "11:03",
                "Qalarrluni mikelngurnek akusrarutekumalrianek, marayanek enenek [enepianek] aklurugailngurnek, mikelnguut cimillratnek, Yuucimeggnek cimiyuilngurmek, mikelnguut-llu Yugtun qalarutesqelluki qanruyutet irnerquutet-llu taringyugnaniarait.",
                "Talks about child abuse, sod houses without much things, how children have changed, unchanging Yup’ik identity, and speaking to children in Yup’ik to understand wisdom and admonishments."
            ],
            "118": [
                "14:40",
                "Qanemciluni tengssuutnek tangerqerraallermeggnek, tengssuuciurteḿek-llu Taqay’amek Nangllermi.",
                "Talks about seeings planes for the first time, and the pilot Taqay’aq in Nanglleq."
            ],
            "130": [
                "16:18",
                "Qalarrluni qanruyutet arcaqauciatnek, cat tamarmeng makuggnarquciatnek akiliutiinek-llu, akusrarutetgun-llu yuut cimillratnek kinguinek-llu.",
                "Talks about the importance of traditional wisdom, how everything requires hard work and its reward, and how mischievous ways changed people and their consequences."
            ]
        },
        "elderTags": [
            "23.63"
        ],
        "tags": [
            "2.2.32",
            "19.8.1",
            "9.3",
            "19.5.4.4",
            "19.13.13",
            "21.3",
            "22.2",
            "16.2",
            "16.1.1",
            "9.6",
            "19.3.2"
        ]
    },
    "cpb-aacip-127-41mgqv1k.h264": {
        "videoID": "cpb-aacip-127-41mgqv1k.h264",
        "title": "Winifred Beans - # 42",
        "time": "22:01",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Winifred Beans"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:12",
                "Winifred Beans-aam kituucini nalqigtaa, taangamek arenqiallugtellrianek, iqlutun yuuyaranek, qanrucunailengraata-llu irniateng qalaruquraasqelluki.",
                "Winifred Beans introduction, alcohol abuse, various ways of living wrong, and instructing children despite being stubborn."
            ],
            "29": [
                "02:57",
                "Qanemciluni uumiyunge’rmi qanrucimallerminek, kia-llu allam neqkainek, mingqaarinek, aturainek-llu piusngailucianek.",
                "Talks about being instructed despite being infuriated, and how no one will else will work on your food, sewing, or clothes for you."
            ],
            "47": [
                "04:53",
                "Qalarrluni tan’gaurluut cimiryugngaciatnek nasaurluut-llu cimirciigaluciatnek, arnat-llu elluarluteng anglicaumanrilnguut uingekuneng ayuqucirrlullermegcetun ellirarkauciatnek.",
                "Talks about boys’ ability and girls’ inability to change, and how women who aren’t raised properly go back to their ways after getting married."
            ],
            "58": [
                "06:18",
                "Qalarrluni taangamek arenqiallugtellrianek ikayuryaraitnek-llu.",
                "Talks about alcohol abuse and support."
            ],
            "99": [
                "11:38",
                "Qalarrluni yuum irniani piicautellerkaanek, ukverkun [agayuvigmun wall’u Yuuyaramun] assiilngurnek taqsaramek, ciulirneret qanruyutnek aptellerkaitnek, Yuut-llu agayuviim-llu qaneryaraita cangallrunriluciatnek.",
                "Talks about praying for children, faith [church or Yup’ik way of life] as rehabilitation, asking elders for wisdom, and the similarity between Yup’ik wisdom and the Bible."
            ],
            "123": [
                "14:36",
                "Qanemciluni anglirilrianun irniaminun uluumanriluciminek, taangam avatiini irniaminun peng’garutailuciminek, taangarpek’nani anglicarillerminek, irniameggnek-llu nunuryaraatnek.",
                "Talks about her adult children keeping in touch with her, how she doesn’t fret over her children except about alcohol, how she raised them without drinking, and how to address children’s bad behavior."
            ],
            "156": [
                "18:19:020 - 00:22:00",
                "Qalarrluni maa-i mikelnguut Yuut Kass’at-llu piciraraita akiliitneluciatnek, kinguliat qitevqurallratnek, kenkekun qanrucimalarniluki, anglicariyaram-llu angtuarucianek cakviurutainek-llu.",
                "Talks about how modern children are between Yup’ik and Western, later generations only speaking English, how instruction comes from love, and the gravity of and struggles of childrearing."
            ]
        },
        "elderTags": [
            "23.85"
        ],
        "tags": [
            "2.2.10",
            "2.2.9",
            "22.5",
            "19.6",
            "19.6.4",
            "19.13.13",
            "8.1.5",
            "8",
            "19.5",
            "22.2"
        ]
    },
    "cpb-aacip-127-42n5thvk.h264": {
        "videoID": "cpb-aacip-127-42n5thvk.h264",
        "title": "Urutaq Lucy Beaver - # 43",
        "time": "20:13",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:02",
                "Qanemciluni nertullerminek, angalkunek nallullerminek, teq’um-llu aturyarainek.",
                "Talks about what she used to eat, how little she knows about shamans, and the uses of urine."
            ],
            "25": [
                "02:56",
                "Qalarrluni teq’um iinruucianek.",
                "Talks about medicinal uses of urine."
            ],
            "48": [
                "05:43",
                "Qalarrluni uqviit/enrilnguat neqkauciatnek.",
                "Talks about willows as food."
            ],
            "69": [
                "07:55",
                "Qalarrluni qercualriit auluklerkaitnek.",
                "Talks about caring for frostbites."
            ],
            "87": [
                "10:38",
                "Qanemciluni uimi kitumek yuallranek.",
                "Talks about her husband search for someone."
            ],
            "103": [
                "15:31",
                "Qanemciluni atsat quagcit-llu qemagcarallratnek.",
                "Talks about traditional berry and sourdock storage."
            ],
            "139": [
                "19:35",
                "Qanerluni-llu malkaanek nallullerminek.",
                "Talks about her lack of knowledge about seals."
            ]
        },
        "elderTags": [
            "23.82"
        ],
        "tags": [
            "2.2.38",
            "22.12.2.1",
            "19.6.2",
            "6.2.3",
            "11.1",
            "6.2.2"
        ]
    },
    "cpb-aacip-127-440rz436.h264": {
        "videoID": "cpb-aacip-127-440rz436.h264",
        "title": "Ayagina'ar Nicholas Charles Sr., Nauciralrea Joseph Friday, Miisaq Milton Lewis, Nirraralria Ulric Nayamin, Wasky Walters, Ketacik (?) Ket'aq Fannie Nicori, Kumkaq Noel Polty - # 44",
        "time": "31:25",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Edited video"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [
                "Genre 4:"
            ],
            "Name 1:": [
                "Ayagina’ar"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Martha Scott"
            ]
        },
        "summary": {
            "1": [
                "00:16",
                "Qalartuq uksuarmi cikum aarnarqucianek, ayarum nancunailucianek, mamkilngurmi-llu cikumi kiskuni callerkaanek.",
                "Talks about the danger of ice in the fall, the importance of having a staff, and what to do when falling through ice."
            ],
            "27": [
                "03:16",
                "Qalarrluni tegganret atullermeggnek niitellermeggnek-llu qalartelauciatnek, ayagyuat qalarutlerkaatnek, pellaakuni callerkaanek, ayakataquni-llu callerkaanek.",
                "Talks about how elders speak of their experiences and what they heard, instructing youth, what to do when stranded, and traveling protocol."
            ],
            "44": [
                "05:40",
                "Qalarrluni kiunritlerkaminek, arcayagutellriani-llu tau͡gaam kiullerkaminek.",
                "Talks about not talking back, and talking back when people are relentless."
            ],
            "53": [
                "07:24",
                "Qanemciluni Quyayararyaurtellermeggnek, quyayaram arcaqaucianek, naulluunrillerminek-llu quyatminek.",
                "Talks about how they started celebrating Thanksgiving, importance of gratitude, and his gratitude for not being sick anymore."
            ],
            "78": [
                "11:58",
                "Qalarrluni kiagmi neqsullerkaitnek, imarpiim cacetuqutngunrilucianek, up’nerkat ilaitni enurnarqellrianek, allrakut-llu ilaitni mikulrianek.",
                "Talks about fishing in the summer, how the ocean is not dependable, some things being scarce some springs, and abundance in some years."
            ],
            "91": [
                "14:10",
                "Qanemciluni nengaugitellrianek murilkelluteng-llu yuunarquciatnek.",
                "Talks about boys marrying into other village and to be careful when doing so."
            ],
            "106": [
                "16:34",
                "Qalarrluni qanruyutet kinguvallerkaatnek.",
                "Talks about passing on wisdom."
            ],
            "111": [
                "17:49",
                "Qalarrluni tegganret elicungcallermeggnek cimingarkauciatnek, angukara’urluut-llu arnassagaat-llu qanruyutait atauciuciatnek.",
                "Talks about elders being replaced with those they instructed, and how old men’s and women’s teachings are the same"
            ],
            "119": [
                "25:37",
                "Qanemciluni anglicaritullermeggnek, irniateng-llu yagirasqevkenaki qanpagatesqevkenaki-llu.",
                "Talks about caring for children in the past, and not to raise a hand or voice against children."
            ],
            "140": [
                "28:51",
                "Qanerluni nasaurluut anglicaryaraitnek, mikelnguut-llu elitnaungelriit cimilauciatnek.",
                "Talks about how to raise girls, and how school changes children."
            ],
            "149": [
                "30:19",
                "Qalarrluni elliraat aanameng caurallrit alaitevkalauciatnek, neqkat-llu elluarrluki aulukesqelluki.",
                "Talks about how orphans uphold what their mothers did, and taking good care of food."
            ]
        },
        "elderTags": [
            "23.17",
            "23.59",
            "23.54",
            "23.64",
            "23.83",
            "23.44",
            "23.47"
        ],
        "tags": [
            "2.2.39",
            "2.2.38",
            "2.2.27",
            "2.2.18",
            "2.2.11",
            "2.2.9",
            "17.1.2",
            "3.4",
            "11.3",
            "20.9.3",
            "19.13.12",
            "19.5",
            "22.2.2",
            "4.5",
            "9"
        ]
    },
    "cpb-aacip-127-46254fdx.h264": {
        "videoID": "cpb-aacip-127-46254fdx.h264",
        "title": "Ackiar Nick Lupie - # 45",
        "time": "21:04",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:06",
                "Qalartuq temem anirtuumangnaqlerkaanek, uksumi ellalliurcuutnek, pellaalriit callerkaatnek, ayarum-llu anirtuutngucianek.",
                "Talks about protecting the body, rain gear in the winter, what to do when stranded, and how a staff saves your life."
            ],
            "21": [
                "03:07",
                "Qalarrluni pirtunguskani callerkaanek, pirciqan-llu uqisvigkiullerkaanek.",
                "Talks about what to do if a blizzard sets during travels, and shelter in a blizzard."
            ],
            "31": [
                "04:30",
                "Qanemciluni qanikcaam aciani epsarpiallermeggnek, qanikcaam epsalngunarqucianek, aniguyat-llu alerquutaitnek.",
                "Talks about how they almost suffocated under snow, how suffocating snow is, and snow shelter advice."
            ],
            "50": [
                "07:03",
                "Qanemciluni ilameggnek nalluvkanrilucimeggnek, maa-i cakucimeggnek nalluciatnek, imumi-llu nepaitellratnek.",
                "Talks about strong familial knowledge in the past, modern lack of familial relations, and peace in the past."
            ],
            "73": [
                "10:07",
                "Qanemciluni yuut cimillratnek, Yuut assirillratnek [cautemteggun] tau͡gaam cali assiirutellratnek [qaneryaratgun], ilakutlermeggnek, imumi-llu nangteqellratnek.",
                "Talks about how people have changed, being better [materially] but worse [morally/spiritually], past sense of community, and past destitution."
            ],
            "90": [
                "12:43",
                "Qalarrluni kassuusngalriit caurcauciitnek.",
                "Talks about marital duties."
            ],
            "111": [
                "15:26",
                "Qalarrluni aipaqutellriik maligtaquyutarkauciagnek.",
                "Talks about spouses’ agreement."
            ],
            "127": [
                "17:44",
                "Qalarrluni tukangcaryaram qanruytainek, nallutailuciatnek, allat takuatni takairuyuciatnek nep’nguciatnek-llu, taangam aipaqellrianun navguutngucianek, taangam aturtainun ikayuqengnaquciatnek, imumi nepailuciatnek, assirlutek-llu aipaqucaramek.",
                "Talks about properly raising children, how they aren’t ignorant, how people aren’t respectful or quiet around others anymore, how alcohol destroys couples, working on alcohol abuse, how peaceful it was in the past, and how to be a good couple."
            ]
        },
        "elderTags": [
            "23.4"
        ],
        "tags": [
            "2.2.30",
            "17.1.2",
            "11.8",
            "11.8.1.2",
            "21.4",
            "14"
        ]
    },
    "cpb-aacip-127-47rn8x0g.h264": {
        "videoID": "cpb-aacip-127-47rn8x0g.h264",
        "title": "Tuunralek Jimmy Chimegalrea - # 46",
        "time": "20:34",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciuq ciuliamta nepailuciatnek, ciulirneret qanrutesteńguciatnek, akingellerkameggnek pivkenateng piilnguut ikayullerkaita alerquutngucianek, piilnguut-llu ikayullrata kingukeggucianek.",
                "Talks about peaceful ancestors, how elders were teachers, traditional instruction to help the needy without expecting payment, and how helping the needy has rewards in the future."
            ],
            "17": [
                "01:56",
                "Qanemciluni qaneryariurtet Alussistuam-llu tekiteqerraallratnek, neqnek Kass’artarnek-llu cikiqenglallratnek, ilameng-llu atrit cikiryaraitnek.",
                "Talks about the introduction of preachers and Christmas, giving food and Western things, and gifts for nameseakes."
            ],
            "49": [
                "05:32",
                "Qanemciluni tuyunek ayagcetanek, qasgimi-llu Qaneryariulrianek.",
                "Talks about traveling priests, and preaching in the community house"
            ],
            "70": [
                "07:49",
                "Qalarrluni Jesus-aam yuurtellranek.",
                "Talks about the birth of Jesus."
            ],
            "93": [
                "10:32",
                "Qalrrluni ukveryaramek.",
                "Talks about faith."
            ],
            "115": [
                "13:14",
                "Qalarrluni [Agayumayarakun] Alussistuam kangianek, pakmani-llu tanqigmek camani-llu tan’germek.",
                "Talks about the [Christian] origin of Christmas, and light above and darkness below."
            ]
        },
        "elderTags": [
            "23.80"
        ],
        "tags": [
            "2.2.32",
            "2.2.31",
            "19.6.12",
            "20.9.2",
            "8.1.2",
            "8.1",
            "19.11.1"
        ]
    },
    "cpb-aacip-127-48ffbpfx.h264": {
        "videoID": "cpb-aacip-127-48ffbpfx.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip, Panigkaq Freda Beaver, Wassillie J. Andrew, Emma Phillip (?), Caller'kuaq William Lomack, Aacungaq Willie Kasayulie - # 47",
        "time": "1:01:42",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview compilation"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew",
                "John MacDonald",
                "Kakianeq Adolph Lewis"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qalarrluni angutngurtellrianek arnaurtellrianek angukara’urlurnek arnassagarnek-llu, alerquutet kinguvararkauciatnek, ilakuyucaramek, ukvelriit allakaunriluciatnek, kenkekun-llu anirtuumayaramek.",
                "Talks about the difference between older men and women and old men and women, passing down traditional instructions, cooperation, religious unity, and salvation and through love."
            ],
            "25": [
                "02:41",
                "Qanemciluni qasgimi eneni-llu qalartellrianek, tuatnayuiruyuciatnek, ilakuyucarakun-llu anirtuumayaramek.",
                "Talks about instruction in the community house and the women’s houses, how that’s not done anymore, and salvation through cooperation."
            ],
            "42": [
                "04:53",
                "Qanemciluni ayagyuat Kassaurtellratnek Yugtarnek-llu nalluciatnek, Yugtarnek-llu elicungcallerkaatnek.",
                "Talks about youth being Westernized and not knowing Yup’ik things, and teaching youth about Yup’ik things."
            ],
            "48": [
                "10:26",
                "Qanemciluni Kass’anek tangerqerraallerminek, elitnaurvingqerraallermeggnek, elitnaurviit akusrarrnarquciatnek, yaaqvaarni-llu elitnaurvigteggun usviirutarkauciatnek.",
                "Talks about seeing Caucasians for the first time, first schools, how schools breed mischief, and how people predicted that schools will make people foolish in the future."
            ],
            "75": [
                "13:00",
                "Qanemciluni angalkunek ciknaameng umyuarrliqellrianek, tan’geriaqan anyuiluciminek, qessamkat kaigasteńgurtarkauciatnek, ellatuluteng-llu alerquumallermeggnek.",
                "Talks about shamans abusing their power because of jealousy, how she wouldn’t go out after dark, how lazy people become beggars, and instruction to be sensible."
            ],
            "90": [
                "15:05",
                "Qanemciluni irniateng inerqurluki qalartellrianek, ellangeqerraallermeggni niitellermeggnek kinguvalauciatnek, aipaqucaramek, niitellermeggenk atullermeggnek-llu qalartelauciatnek, irniateng-llu ceńirutesqevkenaki.",
                "Talks about instruction about admonishing children, how elders passed on wisom from their early childhoods, how to be good spouses, how wisdom is from what they heard and experienced, and not to take children to others’ houses too much."
            ],
            "111": [
                "17:30",
                "Qalarrluni pitat auluklerkaitnek, uimeng akingutarraitnek quyasqelluki, akiuteteng elluarrluki atuusqelluki, eneteng-llu uitanqegcinarqesqelluki.",
                "Talks about taking care of catch, being grateful for whatever money earned, to spend money responsibly, and to make one’s house hospitable."
            ],
            "132": [
                "20:03:612 - 00:22:50",
                "Qalarrluni qanrutestekairutellrianek, maa-i qanrucilrianek, aipamikun kiingan irniangesqelluku, aipangvailegmeng irniangesqevkenaki, inerquutet atuusqevkenaki, Kass’artaat-llu maligtaqussiyaagesqevkenaki.",
                "Talks about the lack of traditional instructors, modern instruction, to have children with one person, warnings against premarital pregnancy, not to go against admonishments, and not to do too many Western things."
            ],
            "155": [
                "22:50",
                "Qalarrluni yuullerkaq ikgelan yuuluaqaasqelluki, akingengnaqluteng-llu elluarrluki atuusqelluki.",
                "Talks about how to live right because life is short, and to make money and spend it wisely."
            ],
            "167": [
                "24:25",
                "Qanemciluni ingrini pissuryaranek, imumi-llu tamakuni pissutullratnek.",
                "Talks about hunting grounds in the mountains, and hunting in those areas in the past."
            ],
            "196": [
                "27:49",
                "Qanemciluni akingaluviatnek, allanek-llu pissuryaranek.",
                "Talks about the legend of Ulurrugnaq, and more hunting grounds."
            ],
            "241": [
                "32:13",
                "Qanemciluni enernek nataqellermek, neqsuryaranek-llu.",
                "Talks about someone finding bones, and fishing."
            ],
            "330": [
                "38:10",
                "Qanemciluni [?Ircaqurrnami] Heart Lake-ami catangqerrucianek.",
                "Talks about a creature in Heart Lake [?Ircaqurrnaq]."
            ],
            "349": [
                "39:45",
                "Callerkuam kituucini nalqigutaa, qanemciluni-llu agayuvigmi calillerminek, council-aameggni calillerminek, anguyagtet-llu Alaska-m-llu pisqutainek elitellerminek.",
                "Callerkuaq self introduction, talks about working in the church, working with the tribal council, and learning about federal and state laws."
            ],
            "375": [
                "42:11",
                "Qalarrluni taangakun arenqiallugtellrianek, murilkellermini Mamterillerni taangamek, helping those with alcohol addiction, taangatulit nangruusqevkenaki, nunamini-llu taangatulit ikayurluki caliaminek.",
                "Talks about negative impacts of alcohol, history of alcohol in Bethel, taangiqtulit ikayullerkaatnek, not to discriminate against addicts, and working locally with alcohol addiction."
            ],
            "412": [
                "46:56",
                "Qalarrluni qanruyutnek, angayuqaagminek niisngallerkaanek, unugmi anesqevkenaki, qasgim qaneryariurviucia, qanrinanratni-llu anelria iquggliqciqnilallratnek.",
                "Talks about traditional wisdom, obeying parents, not to go out at night, the community as an instructional base, and bad futures for those who go out during instruction."
            ],
            "430": [
                "49:12",
                "Qanemciluni maa-i alerquinanriuciatnek, nepaitnamek inerquiyaramek, Yuut piciryarait state-amek qaingiumaciatnek, kinguliameggnek-llu elicungcarillranek.",
                "Talks about the current lack of instruction, to admonish people to be peaceful, how their Yup’ik ways are being taken over by the state, and how he’s teaching one of the younger generations."
            ],
            "453": [
                "52:05",
                "Qalarrluni anuqet ciunerkaita nallunailuciatnek, malrunlegteggun agyatgun sassiuryaramek, agyat anuqmun ataciatnek, Yuut kangingyaraitnek/kangiliryaraitnek, iqulirluku-llu quyatminek.",
                "Talks about the foretellings of wind directions, telling time with seven stars, how the stars are connected to the wind, Yup’ik knowledge systems, and final thanks."
            ],
            "480": [
                "55:02",
                "Willie qalarrluni AVCP-tgun nunacuaraat ataciurcecugluki caliameggnek, tamatum tungiinun kangiliryuucimeggnek ciutmurcuucimeggnek-llu, AFN-aat-llu callrucimeggnek.",
                "Willie talks about AVCP’s unification issue, plans on education and progress on this issue, and what happened with AFN."
            ]
        },
        "elderTags": [
            "23.53",
            "23.67",
            "23.84",
            "23.32",
            "23.24",
            "23.1"
        ],
        "tags": [
            "2.2.42",
            "2.2.40",
            "2.2.39",
            "2.2.31",
            "2.2.30",
            "2.2.27",
            "19.5",
            "21.2",
            "16.2.2",
            "19.6.4",
            "8.4",
            "10.10",
            "9.1",
            "22.5",
            "3.8",
            "19.6"
        ]
    },
    "cpb-aacip-127-53wstz0s.h264": {
        "videoID": "cpb-aacip-127-53wstz0s.h264",
        "title": "Imguuq Martha H. Jackson - # 49",
        "time": "22:25",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [
                "Kuiggluk [Kwethluk]"
            ],
            "Name 1:": [
                "Marth H. Jackson"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [
                "John Active"
            ],
            "Role 2:": [
                "Interviewer"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Martha Jackson-aaq Tuulkessaarmiu [Kuigglugmiungurtelleq] qanemciuq qasginek angullerminek, allakarmeng qantangqetullermeggnek, qaneryaranek-llu qalartellrianun tupalallerminek.",
                "Martha Jackson from Tuluksak [now Kwethluk] talks about growing up with community houses, personal bowls, and waking up to traditional instruction."
            ],
            "32": [
                "03:42",
                "Qalarrluni ayagyuat aanameggnek qanrutestailuciatnek, aatailngurnek irnilrianek, tan’gaurlurmun quuyurnillerkam inerquutngucia, Kass’artarnek-llu elitnaurata Yugtaat asguraknayukuciminek.",
                "Talks about how youth aren’t taught by their mothers, having illegitimate children, warning of smiling at boys, and how she things their Western education will make them doubt Yup’ik knowledge."
            ],
            "45": [
                "05:55",
                "Qalarrluni au͡g’utun irniaqata kiaruciitnarqucianek, naken anuqli’rqan qaillun tan’gaurluut pairtellerkaita alerquutaitnek, teglegyaram inerquutngucianek, taangam-llu kinguinek.",
                "Talks about how embarrassing it is to have illegitimate children, instructions on how to pass boys when the wind is from certain directions, admonishments against stealing, and the effects of alcohol."
            ],
            "61": [
                "08:14",
                "Qalarrluni Yugtun qalartessiyaayuiruyuciatnek, qalartellrianek niicugniyaramek, inerquutet cakenrirniluki, qanruyutet-llu maligtaqukuniki atawaugarkaucianek.",
                "Talks about declining use of the Yup’ik language, how to listen to instruction, modern disregard of admonishments, and how adhering to wisdom is good."
            ],
            "74": [
                "10:09",
                "Qanemciluni agayuviit tekiteqerraallratnek, agayuviim Yuut-llu qaneryarait allaunriluciatnek, qaneryaranek ircaqumeggnun qemagcitulrianek, nukalpiartairuyucianek-llu.",
                "Talks about the first churches, similarities between the Bible and Yup’ik wisdom, how some store wisdom in their hearts, and the loss of great hunters."
            ],
            "90": [
                "12:26",
                "Qanemciluni imumi ilaliutullermeggnek, allanernek-llu ciuniuryaramek.",
                "Talks about past social interactions, and hospitality."
            ],
            "99": [
                "14:10",
                "Qalarrluni ayagyuat umyugairuyuciatnek, imumi qigcigtallruciatnek, imumi yuullrata caperrnarqucianek, niisngayaramek, aipangvailegmi-llu kitumek agtuusqevkenaku.",
                "Talks about youth becoming insensible, how people used to be respectful, difficult lives in the past, obedience, and premarital chastity."
            ],
            "118": [
                "16:52",
                "Qanemciluni imumi ellmeggnek tuqucuitellermeggnek, unguvam-llu ciumurutarkaucianek.",
                "Talks about the scarcity of suicide in the past, and to fight to live."
            ],
            "133": [
                "18:46",
                "Qalarrluni piicagyaramek, qatpalriatun qalartellrianek, assilrianek-llu qalartellriit ircaqumeggnun qemagtesqelluki.",
                "Talks about prayer, speaking as if shouting, and storing good instruction into your heart."
            ],
            "148": [
                "21:13",
                "Qanemciluni pisciigaliinallerminek, maa-i-llu qaneryaranek niicugnillerminek.",
                "Talks about her deteriorating body, and listening to instruction now."
            ]
        },
        "elderTags": [
            "23.36"
        ],
        "tags": [
            "2.2.42",
            "2.2.39",
            "16.1.1",
            "19.5",
            "19.13.17",
            "19.13.13",
            "1",
            "8.1",
            "22.5",
            "21.6",
            "4.1",
            "19.6.1",
            "22.4",
            "8.1.5"
        ]
    },
    "cpb-aacip-127-54kkwqvx.h264": {
        "videoID": "cpb-aacip-127-54kkwqvx.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm - # 50",
        "time": "22:07",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Culture, personal history"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:04",
                "Qanemciluni Cevv’arnermi ellangellerminek, kinguqlimeggnek yuut ayuqucirkaatnek ayagniriarkanek, ayagyuat qimugkara’urlurtun ellirarkauciatnek, ayagyuat-llu qanruyuteteng maligtaqunrirarkauniluki.",
                "Talks about growing up in Cevv’arneq [Chefornak], prediction on how people will become, how the youth will become like puppies, and how the youth doesn’t adhere to wisdom anymore."
            ],
            "21": [
                "02:34",
                "Qanemciluni ap’aminek Elegtamek [Allauguullermi Iigem yaaqsinrilkiini yuurrluni Cevv’arnermiungurtelleq], Aluskam Arnaanek [Allauguullermek, Qaluyaarmiungurtelleq], qanruyutet-llu aturrlainanrilng’e’rmiki ukvertaucianek.",
                "Talks about her grandfather Elegtaq [Allauguulleq (near Eek), moved to Chefornak], Aluskaq’s Mother [Allauguulleq, moved to Nelson Island], and how she didn’t always obey wisdom but believed them."
            ],
            "31": [
                "04:14",
                "Qalarrluni akinauresqumanritlerminek, ilalciarluni yuuyaramek, ayagcianek-llu tangllerminek nunakegtaarmi.",
                "Talks about not retaliating, living in harmony with other people, and seeing the departed in paradise."
            ],
            "80": [
                "11:48",
                "Qanemciluni Jesus-aaq tangerrluku aqvaqataumayuklerminek, nunakegtaarmek/ellakegtaarmek-llu.",
                "Talks about seeing Jesus and expecting to be whisked away, and paradise."
            ],
            "107": [
                "16:00",
                "Qalarrluni ayagyuat nunakegtaarmurtesqumaniluki, Kuigilngurni Qaneryaranek elitnaullermeggnek, irniani-llu assiisqeńiluki.",
                "Talks about wantint paradise for the youth, learning about the Bible in Kuigilnguq [Kwigillingok], and wishing her children would be good."
            ],
            "130": [
                "19:46",
                "Qalarrluni ilaminek kenkutmek umyuangqerruciminek, qanruyutet niisngaluki yuunertullratnek, calrianek niicuitellermeggnek, aipaan Qinarmiuni uitangevkallranek, ayagyuat-llu elluaresqumaniluki.",
                "Talks about loving thoughts to people around, how people used to obey wisdom and live long lives, how there was no misfortune, how her husband moved her to Qinaq/Qinarmiut, and wishing youth well."
            ]
        },
        "elderTags": [
            "23.16"
        ],
        "tags": [
            "2.2.28",
            "4.1",
            "19.6.1",
            "19.5",
            "19.13.4",
            "8.3",
            "8.1.3"
        ]
    },
    "cpb-aacip-127-54kkwrd6.h264": {
        "videoID": "cpb-aacip-127-54kkwrd6.h264",
        "title": "Narullgiar Elena Nick, Ackiar Nick Lupie, Tamarqalria Tam'aq Elizabeth Andrew, Taulan Paul Agimuk, Paningayaq Guy Mann - # 51",
        "time": "1:01:16",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Compilation"
            ],
            "Genre 2:": [
                "Cultural, personal history"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)",
                "Uquviar Olinka Andrew",
                "Sophie Kusak"
            ]
        },
        "summary": {
            "1": [
                "00:14",
                "Qanemciuq aipangllerminek, takaryupiallerminek, angutet nulirkateng [ilait-llu] akiliyuiruyuciatnek, aipangyuumiicaaquciminek-llu.",
                "Talks about getting married, being very reserved, how men don’t give bride prices anymore, and her initial reluctance to get married"
            ],
            "34": [
                "03:26",
                "Qanemciluni uimi ilaminun upallerminek, uini-llu assirluku pilangellerminek.",
                "Talks about moving in with her in-laws, and warming up to her husband."
            ],
            "45": [
                "04:58",
                "Qanemciluni uini assirluku pisqelluku aaniin qanruyutainek, aipateng yagtesqevkenaki, qingangeqerraallerminek, uimi ukveqeqapigtellranek, ciin angayuqaagmi cucukellragnek, agayulirteńgurtellranek, qulngunrita’arnek-llu irniangellermegnek.",
                "Talks about her mother’s advice on how to treat her husband, not to raise a hand against spouses, her first pregnancy, her husband’s devout faith, why her parents chose him, her husband becoming a pastor, and having nine children."
            ],
            "75": [
                "07:48",
                "Qanemciluni uimi kipusvianek.",
                "Talks about her husband’s trading post."
            ],
            "81": [
                "09:03",
                "Qanemciluni irniamegnek anglicallermegnek, Kass’artelallermegnek, taangayuitellermegnek-llu.",
                "Talks about raising their children, traveling to the city, and how they stood away from alcohol."
            ],
            "94": [
                "11:04",
                "Qanemciluni Kialirmi tan’gaurluullermeggnek, upagatullermeggnek, qayatgun equgtatullermeggnek, upagyarallermeggnek, uksumi-llu muriit caliluki upcarallermeggnek.",
                "Talks about being boys in Kialiq, past nomadic lifestyle, gathering wood with kayaks, moving process, and preparing wooden tools in the fall."
            ],
            "112": [
                "14:44",
                "Qanemciluni muragnek taluyitullermeggnek wagg’uq qamunek, taluyat-llu ayuquciatnek.",
                "Talks about making wood into fish traps called qamut, and description of fish traps."
            ],
            "132": [
                "17:36",
                "Qalarrluni ciuliamta muragnek aklungqetullratnek.",
                "Talks about ancestors’ wooden possessions."
            ],
            "137": [
                "18:42",
                "Qanemciluni qanruyutnek ellangutkellerminek, kiagmi neqlillernetetullermeggnek, uksumi Tagyarametetullermeggnek, maurluminek arnagnek-llu ilaluni anglillerminek, tupagaqameng inerquumalallermeggnek, akinauresqumanritlerminek, ilani-llu kenkesqelluki.",
                "Talks about wisdom she grew up with, staying at fish camp in the summer, staying at Tagyaraq in the winter, growing up with her grandmother and two other women, being admonished in the morning, not to retaliate, and to treat everyone with love."
            ],
            "151": [
                "20:50",
                "Qanemciluni ernerpak qaillun ayuqesqumallermeggnek, qanruyutet maligtaqurrlainaasqumallermeggnek, kenkulluteng-llu alerquumallermeggnek.",
                "Talks about being taught how to behave during the day, being told to strictly adhere to traditional wisdom, and instruction to love."
            ],
            "157": [
                "22:03",
                "Qanemciluni caliqcaaraaqumallermeggnek, ullagtaaresqenritlermeggnek, neqkameng caqukaitnek tupitullermeggnek, cumercuilnguut iliirasteńgurtelauciatnek, anglillermini-llu maa-i-tun ayuqenrilucianek.",
                "Talks about being instructed to be hard working, not to go to people too much, weaving grass for food storage, how those who don’t prepare will become beggars, and how different it was growing up."
            ],
            "175": [
                "24:59",
                "Qalarrluni neqalleruaraat ciuniuresqelluki, angussaagtait unangliqengraata amrukesqevkenaki, neqallret tutmallernun pisqevkenaki, kaignaq apqucimi tamarmi atuyunaillrucia, neqalleruar-llu caassikesqevkenaku.",
                "Talks about accepting all food, not to be overwhelmed by large catches, proper disposal of scraps, that hunger is the worst experience, and not to disregard any piece of food."
            ],
            "199": [
                "28:13",
                "Qanemciluni yuut piunriqatarqata catullermeggnek, piunrillret temait cayaraitnek, piunrillret-llu payuggluki nerutetullermeggnek.",
                "Talks about people on their deathbeds in the past, what they did with the bodies of the deceased, and food offerings for the deceased."
            ],
            "212": [
                "30:41",
                "Qalarrluni tukercaryaramek, irniateng uimeggnun cingutesqevkenaki, inerciigalengraata anagulluki taqusuqutesqevkenaki, yagutesqevkenaki, qanpagatesqevkenaki-llu.",
                "Talks about raising children, not to push children to their husbands, not to be exasperated when they’re mischievous, not to raise a hand against them, and not to shout at them."
            ],
            "233": [
                "33:30",
                "Qalarrluni eqnayukuni callerkaanek, engelallagatesqevkenaki, avani anglicarilriani makugtetullermeggnek, tukercaryaram-llu qanruyuterugainek.",
                "Talks about what to do when angry at children, not to laugh at them, how difficult it was to raise children in the past, and many pieces of wisdom about child-rearing."
            ],
            "258": [
                "36:23",
                "Qalarrluni kenkem qanruyutngucianek, allanret ilaliuresqelluki, akinauresqevkenaki, angayuqaagni qigcikesqellukek, cam-llu tamarmi qanruyutengqerrucianek.",
                "Talks about wisdom concerning love, to socialize with guests from other places, not to retaliate, to respect one’s parents, and how there’s wisdom for everything."
            ],
            "286": [
                "39:57",
                "Qalarrluni qanruyutmek paiciryuuteminek, tamalkuita kenkesqelluki, akinauresqevkenaki, qanteng-llu murilkesqelluki.",
                "Talks about passing down wisdom, to treat everyone with love, not to retaliate, and to be careful with words,"
            ],
            "302": [
                "42:17",
                "Qanemciluni cikuvailgan arnat angutet-llu upcaraitnek, mingqellrianek, neqet qeciitnek, teq’iciramek-llu atutullermeggnek.",
                "Talks about women and men preparing before winter freeze, sewing, fish skins, and using aged urine."
            ],
            "320": [
                "45:06",
                "Qanemciluni angutet upcaraitnek, taluyilrianek, can’giiret-llu caquketullratnek.",
                "Talks about men preparing, making blackfish traps, and blackfish storage in the past."
            ],
            "327": [
                "46:40",
                "Qanemciluni tupiganek neqet caqukaitnek, kelugkarcutullermeggnek, ciunerkarteng upyuquratullermeggnek, canegnek avullermeggnek kinercirillermeggnek-llu, imumi yuullret umyuaqaqamiki caperrsuuciminek.",
                "Talks about woven grass fish containers, gathering grass used for stitching, how people used to always prepare for the future, gathering and drying grass, and how thinking back on the past makes it look like a hard like"
            ],
            "346": [
                "49:47",
                "Qanemciluni angutet cassuutelitullratnek, taluyat ayuquciatnek, cuignilngurcuutnek-llu taluyanek.",
                "Talks about men preparing tools, description of fish traps, and making land otter traps."
            ],
            "358": [
                "52:11",
                "Qalarrluni yuilqumi nepaicaramek, arenqiallugtellriit-llu kiimeng neplituniluki.",
                "Talks about being quiet in the wilderness, and only to make noise when in danger."
            ],
            "367": [
                "54:18",
                "Qalarrluni ayagpailegmeng nallunaitesqelluki, ilateng-llu qanrucuirucamegteki utertenritaqata nallulangniluki.",
                "Talks about informing family before traveling, and how not telling of travels anymore has their families not know what happened."
            ],
            "378": [
                "56:34",
                "Qanemciluni maa-i ayagyuat anglillerminek uniurteqapiguciatnek, canek tamalkuitnek enuqetullermeggnek, imumillartun yuullermeggnek [qayatgun, enepianek], Kass’at tekicata ayagyuat cimiuciatnek, taangam-llu tekiyucianek.",
                "Talks about the complete change between past and modern youth, how they had to work hard for everything, living a traditional lifestyle [kayaks, sod houses], how youth were changed with Westernization, and the introduction of alcohol."
            ],
            "396": [
                "59:08",
                "Qalarrluni agayutmun piliqumacimeggnek, yuk-llu ellminek picurlatmun ayalaucianek, imumi yuk’egtaaraullratnek, elliqalriani catairut’languciatnek, elluarluki-llu yuusqelluki.",
                "Talks about divine origin, how one goes down his own path of destruction, how people were good in the past, how people started stealing more, and telling them to live right."
            ]
        },
        "elderTags": [
            "23.58",
            "23.4",
            "23.76",
            "23.77",
            "23.69"
        ],
        "tags": [
            "2.2.35",
            "2.2.30",
            "2.2.22",
            "2.2.17",
            "14",
            "14.1",
            "14.2.2",
            "22.1",
            "22.2",
            "22.5",
            "9.11",
            "17.6.2",
            "17.4.3",
            "17.1",
            "17.1.6",
            "9.9",
            "19.5",
            "19.13.4",
            "9.6",
            "17.5",
            "10",
            "10.12",
            "13",
            "22.2.1",
            "9.13",
            "17.8",
            "5.1.1",
            "17.1.6.3",
            "19.13.18",
            "11.6.1",
            "4.1",
            "16.1",
            "16.2",
            "22.5"
        ]
    },
    "cpb-aacip-127-558czhn9.h264": {
        "videoID": "cpb-aacip-127-558czhn9.h264",
        "title": "Mikngayaq Mik'aq Eliza Chase - # 52",
        "time": "10:33",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Elizabeth Chase"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "interviewer": [
                "Qang’allugaq Hazel Lincoln"
            ]
        },
        "summary": {
            "1": [
                "00:02",
                "Qalarrluni kenkurauciq kinguqvaarni assilriamek akiliutengqerrucianek, kinguqvaarni uitanqegcillerkamek, ciuqvaq umyuaqluku ayagyuat naklektuniluki, aanauluni-llu assirluni yuuyuuciminek.",
                "Talks about how loving everyone has a good reward in the future, having peace in the future, how she looks to the past and pities youth, and wanting to live well as a mother."
            ],
            "29": [
                "02:39",
                "Qanemciluni ayagyuat qanruyutnek qanrutkumayuiluciatnek, qanruyutet KYUK-tgun qanrutkumaciatnek, yuullgutkenrilngurnek kassuusngalrianek, Yuut-llu qanruyutait tamaitnun qanrutkesqelluki.",
                "Talks about how youth aren’t taught wisdom, wisdom being shared through KYUK, inter-racial marriage, and sharing Yup’ik wisdom with all."
            ],
            "41": [
                "04:12",
                "Qalarrluni angutet arnat-llu cayaraitnek, aanaulriit tukercatuniluki, mikelnguut angayuqateng niisngasqelluki, elliraungami tegganernek qanrutesqengqellerminek, elliraat tegganret apqauryartuusqelluki, quyavikullutek-llu.",
                "Talks about traditional gender roles, mothers taking care of children, how children should obey their parents, listening to elders because she was an orphan, how orphans should go to elders to learn, and closing."
            ],
            "82": [
                "08:33",
                "Qanemciluni anglicaragminek, kinguveminek-llu.",
                "Talks about her foster children, and her descendants."
            ]
        },
        "elderTags": [
            "23.55"
        ],
        "tags": [
            "2.2.38"
        ]
    },
    "cpb-aacip-127-57np5s39.h264": {
        "videoID": "cpb-aacip-127-57np5s39.h264",
        "title": "Nauciralrea Joseph Friday - # 53",
        "time": "18:40",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview, exhibit"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Peter Tuluk"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciluni mikelnguut taqneret-llu qantaitnek, uqniyaramek, imumi yuurqaaliat maa-i-tun ayuqenriluciatnek, pakissaatullermeggnek-llu.",
                "Talks about bowls for children and adults, cooking horsetails, how soups/stews were different in the past, and gathering from vole caches."
            ],
            "14": [
                "01:54",
                "Qanemciluni angalkut kegginaquitnek, yura’arqameng kegginaqurtulaucimeggnek, kegginaqut unguvalriaruarit unguvalrianun yukniluki, angalkut-llu yuraqata’arqameng kegginaqulisqetullratnek.",
                "Talks about shamanistic masks, using masks for Yup’ik dancing, how masks with certain animals represent their spirits, and shamans commissioning masks for dances."
            ],
            "35": [
                "04:23",
                "Qalarrluni kegginaqunek maniviatni, angalkut tuunraqenrilkait tangnircautnguciatnek, unguvalriaruat-llu unatnguatgun neryugngaciatnek.",
                "Talks about masks in the exhibit, how shamans’ non-familiars were for decorations, and the meaning of hands and prey of depicted animals,"
            ],
            "62": [
                "08:40",
                "Qanemciluni ak’a kegginaqunek niitetullerminek tau͡gaam tangerrssuunaki, imarpigmiutaat ilait tangerrnauqerciigaliciatnek, kegginaqut nataita kangiitnek, angenqat cauciatnek, kegginaquni-llu cauyuklerminek.",
                "Talks about hearing about but not seeing masks back then, how some sea animals aren’t commonly seen anymore, the meanings of parts of the masks, describes angenqat as ice floes coming to shore, and guesses on depictions on masks."
            ],
            "87": [
                "11:57",
                "Qalarrluni yuilqumi mermek canimeggnun ellilaasqelluki, cam-llu mer’iqani yuusciigaciiqniluku.",
                "Talks about putting water beside you in the wilderness, and how a being sucks water out and kills a person."
            ],
            "98": [
                "13:31",
                "Qalarrluni kegginaqumek pamyuilngurmek pingqerrarkaunrilkeminek-llu pilegmek, angalkut neqnek kegginaqungqerraqameng pamyuicuiluciatnek, kegginaqut iliit Kuigpagmiumun angalkumun pikniluku, kegginaqut-llu iingitnek qanritnek-llu.",
                "Talks about a mask with no tail and part it’s not supposed to have, how shamans always had tails on fish masks, how one mask belonged to a Yukon shaman, and eyes and mouths on masks."
            ],
            "124": [
                "17:08",
                "Qalarrluni qununinek kegginaqunek.",
                "Talks about half seal mermaid depictions."
            ]
        },
        "elderTags": [
            "23.59"
        ],
        "tags": [
            "2.2.18",
            "10.1",
            "8.4",
            "20.2.3",
            "8.6"
        ]
    },
    "cpb-aacip-127-59c5b6f6.h264": {
        "videoID": "cpb-aacip-127-59c5b6f6.h264",
        "title": "Angut'aq Olinka Nickolai, Quriciq Nickolai K. Nicolai - # 54",
        "time": "19:05",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Raw video"
            ],
            "Genre 2:": [
                "Cultural, personal history"
            ],
            "Quality:": [
                "Good video"
            ],
            "Genre 4 (Location):": [
                "Mt. Village, AK"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:06",
                "Qalarrluni Yupiit agayuviim-llu qanruyutait cangallrunriluciatnek, angutet alingnarqellratnek, aipangvailegmi qingangesqumanritlerminek, umyuaqenrilkemeggnek-llu uingelallermeggnek.",
                "Talks about the similarities between Yup’ik wisdom and the Bible, being intimidated of men, being warned of premarital pregnancy, and being arranged to marry unexpected men."
            ],
            "17": [
                "01:55",
                "Qalarrluni aglenrraat eyagyaraitnek, arnat tuquuciatnek, aqumgayaramek wagg’uq agleqerraarqameng qulni ernerni eyagluteng, tan’gaurluut-llu uqritgun kituusqelluki.",
                "Talks about abstinence practice surrounding first menstruations, how premarital relations with a woman lead to death, “sitting” - abstaining for ten days after first menstruations, and to pass boys downwind."
            ],
            "45": [
                "04:48",
                "Qanemciluni nunat akluteng nallunailngurnek qaralilitullratnek.",
                "Talks about villages’ specific clothing decorations."
            ],
            "51": [
                "05:45",
                "Qanemciluni qikertami elliramek tekitellratnek, elliraat kenkesqelluki inerquutngucianek, elliraat-llu tungelqumeggnun tegumatullratnek.",
                "Talks about an orphan found on an island, admonishments on treating ophans well, and orphans being taken in by relatives."
            ],
            "65": [
                "07:48",
                "Qanemciluni inuguarturatullerminek, yaaruitullermeggnek, yaqulget-llu tekitaqata kiingan inuguateng irniaruateng-llu antetullermeggnek.",
                "Talks about how she always played with dolls, storyknife stories, and dolls only coming out when birds arrived."
            ],
            "78": [
                "09:15",
                "Qalarrluni aglenrraat wall’u irnicuanerraraat manaryaraqata neqet tamarcet’lauciatnek, mikelnguut kitumun irniaqniluteng ellmeggnek nalqigtelallruciatnek, agayuvigmi angllurcelluki acituciatnek, Qinarmi agayuvingqetullermeggnek, mission-aami-llu qasgimi-llu agayutullermeggnek.",
                "Talk about how those with first menstruations or miscarriages jig and drive fish away, how children introduced themselves as “child of” someone, receiving names through Christian baptism, having a mission in Qinaq, and attending church in a mission house and the community house."
            ],
            "99": [
                "12:01",
                "Qanemciluni tuvqakuralallermeggnek, ayagyuat qaneryararteng qaneruyuteteng-llu nalluyaguyuciatnek, Yugtun-llu qaneryaram tamaryunailucianek.",
                "Talks about how they used to share food with everyone, youth forgetting Yup’ik language and wisdom, and the importance of keeping the Yup’ik language."
            ],
            "109": [
                "13:42",
                "Qanemciluni angutngurtellriim tan’gaurluut quyurrluki qalarutetullranek, yuum-llu tamarmi kenka aturarkauniluku.",
                "Talks about an old man who would gather boys to share wisdom, and how everyone is to exhibit love."
            ],
            "125": [
                "16:47",
                "Qanemciluni angutngurtellriim qaneryarainek, piitenritengnaqesqelluki, imumi neqkameggnek anglanisciigatellratnek, pissuutnek anglanillrunriluciatnek, iliini-llu kaitullratnek.",
                "Talks about the old man’s wisdom, to try to keep running out of food and things, how they couldn’t afford to waste any food back then, how they had to work hard for tools, and occasional famines."
            ]
        },
        "elderTags": [
            "23.12",
            "23.75"
        ],
        "tags": [
            "2.2.39",
            "14.3.1",
            "19.3.3",
            "19.7.1",
            "18.1",
            "9.12",
            "19.5"
        ]
    },
    "cpb-aacip-127-59c5b6gx.h264": {
        "videoID": "cpb-aacip-127-59c5b6gx.h264",
        "title": "Caller'kuaq William Lomack, Aacungaq Willie Kasayulie - # 55",
        "time": "21:44",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Callerkuaq [William], Willie"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "4": [
                "00:17",
                "Callerkuam [William] kituucini yuurtellni-llu nalqigutak, qanemciluni-llu cav’urluteng ayagatullermeggnek, agayuvigmi calitullerminek, IRA Council-aani calitullerminek, elitnaullrunrilnge’rmi-llu anguyagtet state-am-llu pisqutainek elitellerminek.",
                "Callerkuaq [William] introduction, speaks about traveling by rowing in the past, working in the church, working with the IRA Council, and learning about federal and state laws without going to school."
            ],
            "23": [
                "02:21",
                "Qanemciluni taangakun arenqiallugtellrianek, taangakun-llu arenqialluggnerturiciatnek.",
                "Talks about alcohol related accidents, and increased alcohol related accidents."
            ],
            "38": [
                "04:10",
                "Qalarrluni taangiqtulit kenkekun ikayuryugnganiluki, yuullemteńi arenqiallugutet perriqapiarciigaluciatnek, tribal court-ameggni-llu tangaryulriit ikayulauciminek.",
                "Talks about healing alcohol addiction through love, how we can’t eradicate all bad things in life, and working with alcohol rehabilitation with his tribal court."
            ],
            "61": [
                "07:06",
                "Qalarrluni angayuqaagni niisngaskellukek, inarrnarikan anumasqevkenaki, qasgimi eneni-llu qaneryarat cangallrunriluciatnek, qanelriani cigyagnek caniqerrilitnek-llu, piyuiruyuciatnek-llu.",
                "Talks about obeying parents, not to stay out after it’s time to go to bed, similarity between instruction in the community house and the women’s houses, exits being blocked [stick or grass cord] during instruction, and how they don’t do that anymore."
            ],
            "84": [
                "09:44",
                "Qalarrluni Yuut qaneryarait nepaitnaqniluki, nunarraat tamarmeng angayuqangqerruciatnek, qanruyutet qanrutkenanriatki Yugtaat patumaniluki, Yup’ik Nation-aam-llu piurtellranek.",
                "Talks about how Yup’ik wisdom leads to peace, how each village had a leader, how the lack of sharing wisdom is making them become eclipsed, and the establishement of the Yup’ik Nation."
            ],
            "98": [
                "11:33",
                "Qanemciluni ayagyuanek elitnaurillerminek, agyat murilkelluki mikurarkauciatnek kangingyugngaciatnek, anuqet neqnun ataciatnek, malrunlegnegun agyatgun sass’angqerrucillratnek, qilagkun-llu ellaliuryarallermeggnek.",
                "Talks about teaching youth, how stargazing can foretell fish abundancy, how wind is connected to fish, using seven stars to tell time, and weather predictions using the skies."
            ],
            "127": [
                "14:33",
                "Qalarrluni ellam murilkerllerkaanek, KYUK-ni-llu qalarcugngaciminek quyaluni.",
                "Talks about oberving everything, and being thankful for being able to share on KYUK."
            ],
            "136": [
                "15:20",
                "Willie qalarrluni AVCP-t nunait atauciurcuucimeggnek, AVCP-t nalqigutarkaitnek, atauciureskata-llu kinguinek.",
                "Willie talks about the AVCP unification issue, AVCP outreach, and the effects of unification."
            ],
            "160": [
                "19:34",
                "Qanemciluni AFN-aat-llu callrucimeggnek, ciunerkameggni-llu piyuutemeggnek.",
                "Talks about AVCP and AFN, and hopes for the future."
            ]
        },
        "elderTags": [
            "23.24",
            "23.1"
        ],
        "tags": [
            "2.2.40",
            "9.6",
            "22.5",
            "19.13",
            "3.8",
            "19.10.1"
        ]
    },
    "cpb-aacip-127-59q2c3zn.h264": {
        "videoID": "cpb-aacip-127-59q2c3zn.h264",
        "title": "Cungauyar Wassllie Andrew, Emma Phillip (?) - # 56",
        "time": "15:16",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "John MacDonald"
            ]
        },
        "summary": {
            "1": [
                "00:02",
                "Qanemciuq ungungssimek nerellratnek, ingrini-llu pissuryaranek.",
                "Talks about eating an animal, and hunting grounds in the mountains."
            ],
            "27": [
                "03:27",
                "Qanemciluni Ulurrugnam ingrianek, yugmek mayullermek, allanek-llu pissuryaranek.",
                "Talks about the mountain Ulurrugnaq, a man that climbed there, and more hunting grounds."
            ],
            "65": [
                "07:51",
                "Qanemciluni carayagnek, Kiillaraliitmi enernek natuqutlermeggnek, nunanguami-llu Kiillaraliitem nanlucianek avatiinek-llu.",
                "Talks about strange creatures, finding bones in Kiillaraliin [Heart Lake], and showing a map of Kiillaraliin and the surrounding area."
            ],
            "102": [
                "10:46",
                "Qanemciluni Evon Qugg’amek yuuyaramek elitnaurluni, Kiillaraliitetlermeggnek, talaariliucianek, kitumek-llu mermi qallatellriamek tangllermek.",
                "Talks about Evon Qugg’aq teaching subsistence, going to Kiillaraliin, abundant rainbow trout, and someone seeing something bubbling in the water."
            ],
            "135": [
                "13:29",
                "Qanemciluni tamaavet ayagluni neqkameggnek peng’gartellermeggnek, Old Man Reed-am Kiillaraliitetetullranek, Kiillaraliitmi-llu carayagmek.",
                "Talks about a trip there worried about food, Old Man Reed going to Kiillaraliin, and a creature at Kiillaraliin."
            ]
        },
        "elderTags": [
            "23.30",
            "23.32"
        ],
        "tags": [
            "2.2.42",
            "2.2.39",
            "2.2.27",
            "2.1.3",
            "9.1",
            "15.4",
            "9"
        ]
    },
    "cpb-aacip-127-60qrfsqn.h264": {
        "videoID": "cpb-aacip-127-60qrfsqn.h264",
        "title": "James Guy, Kukuyar Henry Frank, Lucy Frank - # 57",
        "time": "22:06",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Henry, Lucy"
            ],
            "Role 1:": [
                "Interviewees"
            ],
            "Name 2:": [
                "John Active"
            ],
            "Role 2:": [
                "Interviewer"
            ],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:14",
                "Henry qalartuq Yugtun qaneryaram cagmarnarqenrilucianek, mumigcitulit ikayuutnguarkauciatnek, tutgarai Kass’amek atalget Yugtun Kass’atun-llu qalarcugngaciatnek, Kass’atun-llu Yugtun-llu pitateklukek piluaqerciqucianek.",
                "Henry talks about how the Yup’ik language shouldn’t be lost, how translators would be helpful, her half-white grandchildren being bilingual, and how bilingualism would be beneficial."
            ],
            "18": [
                "02:18",
                "Qalarrluni Yugtun qaneryaramteggun Yuuguraucimteńek, ayagyuat-llu kalikantenrilnguut qaneryarat ukvenriluciatnek.",
                "Talks about how speaking Yup’ik keeps us Yup’ik, and youth not believing Yup’ik wisdom that aren’t in textbooks."
            ],
            "35": [
                "05:01",
                "Qalarrluni Yuut agayuviim-llu qaneryaraita cangallrunriluciatnek, qasgimi qanruyun ellanguteklerminek, nasaurluut-llu enemi.",
                "Talks about Yupiit discovering similarities between traditional wisdom and the Bible, growing up listening to wisdom in the community house, and the girls in the home"
            ],
            "51": [
                "07:15",
                "Qanemciluni qasgimi qavatullermeggnek, ellirauluni anglillerminek, angukara’urluut qanruyutiitnek elliraq anglirikuni yuungnaqsugngacianek, arnassagaat ikayullni ciunerkaqegciciqnillratnek, qalarut’larciqniluki-llu ayagyuat qanrucimallerminek.",
                "Talks about sleeping in the community house, growing up as an orphan, elders’ advice on how an orphan can make his own living as an adult, the old women he helped promising him a good future, and being told he would grow up to pass down knowledge."
            ],
            "64": [
                "09:01",
                "Qanemciluni tuaten ellinge’rmi qanruyutet igvauciatnek, Yuut ataucimek qanruyutengqerruciatnek, up’nerkami ayaruitesqevkenaki kiagmi-llu, anagulluki-llu kinguqliit pisqevkenaki.",
                "Talks about experiencing wisdom he heard even at his age, how Yupiit have one body of wisdom, never to be without a staff in the spring or summer, and not to treat children too excessively."
            ],
            "80": [
                "11:13",
                "Lucy qanemciuq Evan-am aaniinek qalarutestengqellermeggnek, muragnek iralurcuutnek kapucaranek, aatiita inerqutullrucianek qaneryaranek-llu qalartetullrucianek, qanruyutet-llu nalluyagutnarqenriluciatnek.",
                "Lucy talks about Evan’s mother instructing them, wooden calanders with holes and sticks, her father teaching them admonishments and wisdom, and how wisdom shouldn’t be forgotten"
            ],
            "99": [
                "13:31",
                "Henry qalartuq ciin Yuut qanruyutait nalluyagutnarqenrilucianek, ayainanermini qanruyutet umyuaqelauciminek, qalarutesqeńguciqnillerminek ciumuruyuciminek-llu, qanruskeminek-llu ikayurtengqerruciminek.",
                "Henry talks about why Yup’ik wisdom shouldn’t be forgotten, recalling wisdom throughout his life, how he was told he’d be an instructor and follows through with it, and how the youth he instructs help him out."
            ],
            "112": [
                "15:41",
                "Qanemciluni elitnaurani taangamek qalarutellruciminek, taangayuiruqaanerminek yuuciminek, kinguliat apyutait kiugarkauciatnek, elitnaurvigmi qalartelauciminek aipaqucaramek tuaten, akluuteteng qelkesqelluki, qemagcilriani-llu assinrucianek.",
                "Talks about speaking of alcohol with one of his pupils, his life after quitting alcohol, to always answer youth’s questions, speaking to youth at school including getting married, to take care of possessions, and how it’s better to store/save things."
            ],
            "132": [
                "18:06",
                "Lucy qalarrluni ayagyuat qalarucimang’e’rmeng akusrarrniluki, tegganret-llu qaneryaranek qalarcuiruyuciatnek.",
                "Lucy talks about how youth are getting mischievous despite instruction, and how elders don’t pass on wisdom anymore."
            ],
            "141": [
                "19:26",
                "Henry qanarrluni qitevqurangellratnek, alerquutairut’ngellratnek, irniateng Yuuyaramek qalarutesqelluki, ayagyuat-llu Kass’at piyarait Yuut piitni piciunruniluki.",
                "Henry talks about English replacing Yup’ik, loss of traditional Yup’ik instructions, that they should teach their children the Yup’ik way of life, and that youth believe the Western way over the Yup’ik way."
            ]
        },
        "elderTags": [
            "23.38",
            "23.45",
            "23.50"
        ],
        "tags": [
            "2.2.39",
            "16.4.1",
            "1",
            "21.2",
            "17.1.1",
            "19.5",
            "22.5"
        ]
    },
    "cpb-aacip-127-6341p189.h264": {
        "videoID": "cpb-aacip-127-6341p189.h264",
        "title": "Kumluilnguq Matthew Frye - # 60",
        "time": "9:44",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciluni kit’ellrianek niiqurangelaucimeggnek, qayatkun ayagtullermeggnek, irnerrlugnek qaspernek, kinguqamegteggun qayat paingit meq iteryailkucitullratnek wagg’uq ket’garluki, angyat-llu kicuitellruciatnek.",
                "Talks about hearing about more drownings, traveling by kayak in the past, having seal intestine pullovers, using their hems to prevent water from entering the opening [ket’garluki], and how boats would rarely sink."
            ],
            "18": [
                "02:01",
                "Qalarrluni taangamek picurlalrianek, taanga kanevtellriatun pivkalaucianek, taangartangvailgan-llu camek nallullrucimeggnek.",
                "Talks about the negative effects of alcohol, how alcohol is claiming many lives, and no misfortune before alcohol."
            ],
            "31": [
                "03:47",
                "Qalarrluni ciin qanruyutet qanruteknanriuciatnek ilait nallunrilengraitki, qalaruyutet kitumek kingunengqeng’e’rmeng cimiyuiluciatnek, qalarutkestek’lallrin-llu nangenguciatnek.",
                "Talks about why they don’t hear traditional wisdom anymore though some know, how traditional wisdom didn’t change from any source, and how there are no more traditional instructors."
            ],
            "44": [
                "05:45",
                "Qanemciluni tegganret ayagyuat qanrucunairutniluki, qanrutketullrat atungniluki, ciuqvaar umyuaqetullruniluku, qanruyutet atunrirciqnitullruniluki, tekitarkaq-llu nallunrilnganaku qalartetullratnek.",
                "Talks about how elders say that youth don’t heed advice anymore, how they’re fulfilling the predictions, how they used to keep the future in mind, that they used to say that people won’t adhere to wisdom anymore, and how they used to speak as if they knew the future."
            ],
            "59": [
                "07:48",
                "Qalarrluni ayagyuanun paiciutekaminek, kenkutesqelluki, ilateng cangayugcetaaresqevkenaki, iqlutmun-llu ayagarcukaaranguciatnek.",
                "Talks about leaving behind advice for youth, how people should treat each other with love, not to affront each other, and how people easily go astray."
            ]
        },
        "elderTags": [
            "23.48"
        ],
        "tags": [
            "2.2.32",
            "7",
            "7.5",
            "7.5.1",
            "17",
            "17.4",
            "17.4.3",
            "19.5",
            "19.6",
            "19.10",
            "19.13",
            "22",
            "22.5"
        ]
    },
    "cpb-aacip-127-63fxpxg0.h264": {
        "videoID": "cpb-aacip-127-63fxpxg0.h264",
        "title": "Ackiar Nick Lupie - # 61",
        "time": "31:26",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Uquviar Olinka Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:09",
                "Qanemciuq tan’gaurluullermini niitellerminek, nunam qaingani imarpigmi-llu neqkanek, nanguciatnek enurnariciatnek-llu, tan’gaurluullermini up’nerkami yaquliltullranek, yuilquum nepaitetullranek, up’nerkami-llu Akulmi kanaqlagculrianek.",
                "Talks about hearing of things when he was a boy, subsistence on land and the sea, how they’re depleting and scarce, many birds in the spring when he was a boy, how the wilderness used to be quiet, and spring muskrat hunters in the Akula region."
            ],
            "16": [
                "02:45",
                "Qanemciluni tan’gaurluut yaquleyagarcurluteng pitegluki elitnautullratnek, nasaurluut-llu meqtarluki keniraqluki, neqteng qigcikluki kenciktullermeggnek, yuit yaquleyagarcuyuiruyuciatnek, pissutullrit-llu tangrrunanrirniluki.",
                "Talks about how boys would learn by hunting little birds with arrows, girls would pluck and cook them, how they respected and revered food, how their children don’t hunt little birds anymore, and how things they used to hunt aren’t seen anymore,"
            ],
            "26": [
                "04:14",
                "Qanemciluni kiagmi tukellret amllepiatullruniluki, pitegluki kinercitullermeggnek wagg’uq nakaculiluki, cetunatkameggnun yaquleyagaat kayangut-llu neqektullermeggnek, ikeliyuitellratnek, allamiaquaqan cat amlleriqetaarluteng ikegliqetaatullratnek, neq’ngellerkaanun-llu yaqulegtutullermeggnek.",
                "Talks about many newly hatched birds in the summer, hunting them and drying them [nakaculiluki], how they’d eat little birds and eggs until they went downriver, how animals wouldn’t deplete, how animals fluctuated each year, and how they ate birds until the fish came."
            ],
            "41": [
                "06:10",
                "Qanemciluni neqsurnarian imarpigmun kuigmun-llu upatullermeggnek, kencikngaceteng amllerturatullruniluki, neqrateng mulngakluteng murilketullratnek, kencikenriamceteng nangenguciatnek, neqput-llu yugnun ataciatnek.",
                "Talks about moving to rivers during fishing season, how reverence kept them in high numbers, how they carefully kept every piece of food they had, the lack of reverence leading to depletion, and how food sources are connected to people."
            ],
            "51": [
                "07:43",
                "Qanemciluni cetuarculallermeggnek, cetuarcuraqata ivraasqumanritlermeggnek, pissunanriamceteng unguvalriit nangniluki, Neq’liurtet kellutestet inerquutaitnek, pissulriit neqsulriit-llu arulaircecuitellratnek, neqsurraarluteng ingtellrianek, ingtarcutullermeggnek-llu.",
                "Talks about beluga hunting season, not to wade when they’re hunting belugas, how animals are depleting due to not being hunted, Fish and Game/Wildlife restrictions, how they never used to be told to stop hunting or fishing, birds molting after fishing season, and hunting molted birds."
            ],
            "65": [
                "09:48",
                "Qalarrluni yuilqumi pellaalriit anangnaqsaraitnek, neqkailkuni uugnarturyugnganiluku, qangqiiret anaita neqnguciatnek, nerailkuni qassaasqevkenaki, akaurrluku-llu nereksaitellrukuni alungyartuusqevkenaku.",
                "Talks about survival when lost in the wilderness, eating voles if one has no food, being able to eat ptarmigan feces, not to have raw meat after not eating for a while, and not to eat blackfish fries after not eating for a while."
            ],
            "83": [
                "12:39",
                "Qalarrluni pellakuni meqsukan cayaramek, watqapik qanikcartuusqevkenaki, qanikcaq plastic-aakun urugcirluku merkiuresqelluki, imarpigmi maklaarem qilua maqeqaarluku qanikcarmek imirluku merkiuresqelluki, taryurtuusqevkenaki-llu.",
                "Talks about being thirsty when lost, never to eat snow, to put snow in a plastic bag and melt it for water, empty out a seal intestine and fill it with snow at the ocean, and never to drink seawater."
            ],
            "102": [
                "15:35",
                "Qalarrluni yuilqumi kiskuni callerkaanek, ciurluki canegnek ekiiresqelluki, talligni irugni-llu taptaaresqelluki, nunam-llu qaingani aerqiallugcaraq amllerniluku.",
                "Talks about sinking into water in the wilderness, to wring clothes and line inside with grass, to continue flexing arms and legs, and how there are many ways to come to misfortune on the land."
            ],
            "114": [
                "17:35",
                "Qalarrluni nengelvagmi kiskuneng callerkaatnek, arenqiallugcaram qanruyutai amllerrniluki, tavesqevkenaki wall’u pilaagesqevkenaki, meq-llu murilkuraasqelluku.",
                "Talks about falling into the water when it’s very cold, how there’s a lot of wisdom about getting into misfortune, not to panic or too hasty, and to always observe the water."
            ],
            "127": [
                "19:39",
                "Qalarrluni aklumi qecia elegqaarluku neryugngacianek, tan’gaurluullermeggni-llu alerquumacimegcetun qangqiiret anait naspaatullermeggnek.",
                "Talks about charring and eating skin from clothing, and eating ptarmigan feces as a boy as instructed."
            ],
            "147": [
                "21:56",
                "Qalarrluni akertem pit’eqarraallranek, Kusquqviim-llu natiikun akertem pit’elaucianek.",
                "Talks about when the sun first comes up, and where the sun rises in relation to Kusquqvak [the Kuskokwim River]."
            ],
            "154": [
                "23:13",
                "Qalarrluni Kusquqviim nuniini pellaakuni callerkaanek, Negteḿun ayallermeggni atullermeggnek, Kusquqviim natiikun akertem ayagyaraanek, Erenret-llu Iquata Tunturyak [“Qaluurin”] eniumacianek.",
                "Talks about what to do when getting lost around Kusquqvak, their experience getting lost when going to Negteḿiut [Newtok], the path of the sun throughout the day in relation to Kusquqvak, and how Erenret Iquat [constellation] always point to Tunturyak [“Qaluurin,” the Big Dipper]."
            ],
            "171": [
                "25:51",
                "Qalarrluni Erenret Iquata ayagyaraatnek, cuqyutnguciatnek, Negteḿek utertellermeggni pellaallermeggnek, iralum-llu nanluciakun nanlucimeggnek taringellermeggnek.",
                "Talks about the path of Erenret Iquat, how they’re used to find one’s bearings, getting lost on their way from Negteḿiut, and realizing where they were based on the moon’s position."
            ],
            "188": [
                "28:19",
                "Qalarrluni nunami elitaqlermeggnek, nuna murilku’rnaqniluku, agyat murilkelaasqelluki, iralukun nunakun-llu cuqlukek nanlucimeggnek taringellermeggnek, Kusquqvaggnginanermeggni tekiskuneng-llu callerkiullermeggnek.",
                "Talks about recognizing land features, to always observe the land, to observe the stars, using the moon and the land to get their bearings, and their plans while going to Kusquqvak."
            ]
        },
        "elderTags": [
            "23.4"
        ],
        "tags": [
            "2.2.30",
            "2.1.2",
            "3.1.1",
            "3.1.3",
            "3.5",
            "3.6",
            "3.12.1",
            "3.8",
            "5.1.1",
            "5.2.1",
            "5.2.2",
            "5.4.1",
            "5.4.4",
            "5.5",
            "9.1",
            "9.3",
            "9.5.2.1",
            "10.1",
            "10.3",
            "11.2",
            "11.3",
            "11.4",
            "11.5",
            "12.1",
            "19.6.2",
            "19.9",
            "24.3"
        ]
    },
    "cpb-aacip-127-65h9w88k.h264": {
        "videoID": "cpb-aacip-127-65h9w88k.h264",
        "title": "Nauciralrea Joseph Friday, Winifred Beans, Tavkaralria Jonathan Johnson, Anesia Hoover (?), Arnaaquq Aqesgirpak Mary Worm, Tuunralek Jimmy Chimegalrea, Nauyaq Anna Andrew, Nauyaq Anna Andrew - # 62",
        "time": "1:00:49",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Compilation"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Mary Worm [Kangirnaq - Kongigonak]"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:17",
                "Qalartuq yuut ayuqenrilameng ilait taringyuitniluki niicuitniluki-llu, qaneryaram maligtaqustai ak’anun anerteqtuniluki, ilameggnek-llu acivartesqevkenaki uputesqevkenaki-llu.",
                "Talks about how some don’t understand or hear because people are different, that those who follow wisdom live for a long time, and not to put down or gossip about others."
            ],
            "10": [
                "02:14",
                "Qalarrluni yurrluuvakaqaluneng aipaita unitelarciqniluki.",
                "Talks about how their spouses will leave if they’re bad people."
            ],
            "16": [
                "03:36",
                "Qalarrluni neqkaitnek wall’u aklunek mingqerkanek kia picisngaitniluki, irniateng ellmeggnek anglicararkauniluki, tan’gaurluut assiiqaarluteng cimiryugngaciatnek, arnat-llu cimillerkaat caperrnarqenruniluku.",
                "Talks about how one must take care of their own food and sewing clothes, how people have to raise their own children, boys ability to change their bad ways, and how it’s harder for women to change their ways."
            ],
            "29": [
                "06:00",
                "Qalarrluni niicuilnguut taangaryulriit-llu piqaasqelluki, taangaryulriit uumikevkenaki tau͡gaam kenkesqelluki, enemeggni-llu taangangraata qimaasqevkenaki qaillun pinayukluki.",
                "Talks about advising disobedient and/or alcohol people, not to treat alcoholics badly but show them love, and not to run away from children drinking at home lest something happen to them."
            ],
            "39": [
                "08:12",
                "Qalarrluni irniani mellrukan unuaquani qarutelauciminek, yuussunriqata-llu tau͡gaam qalarutesqelluki.",
                "Talks about comforting her children they day after they drink, and to speak to them after they recover."
            ],
            "52": [
                "10:41",
                "Qalarrluni imarpigtellriani elegcingqerrlainaasqelluki ayarutun, aatami atii imarpimi nacecartullranek, nacessvini uscan elegcimikun anagyugngallranek, elegcigkun-llu malrurqugnek anirtuumallerminek.",
                "Talks about always having a gaff when going to the ocean like a staff, his paternal grandfather going up to a vantage point at sea, how he survived crumbling ice with his gaff, and how a gaff saved him twice."
            ],
            "65": [
                "13:16",
                "Qalarrluni atu’urkanun aki quyurtesqelluki, kemninarqellrianun akilluuqertellrianek, picurlagnarqucianek-llu.",
                "Talks about saving money for useful things, wasting money on mind-altering things, and how it leads to misfortune."
            ],
            "71": [
                "14:55",
                "Qalarrluni qavam qessam-llu pikairutnarquciagnek, qaneryaram maligtestii cakaituravakayuitniluku, pitqayuciatnek, pitameggnek cangengnaqtullermeggnek, pitqayungnaqesqelluki-llu.",
                "Talks about how sleep and laziness lead to destitution, that those who follow wisdom don’t lack much, how they were good hunters, how they made things out of what they caught, and to try to be good hunters."
            ],
            "81": [
                "16:55",
                "Qalarrluni ukverkun caarrlugmek atunriryugngaciatnek, ukverilkuni kayungqerrngailucianek, agayuviim wall’u Yuut piciryarait ukveresqelluki, Yuk ak’allaurteqalria ayuqucirtuutmek apeskani quyaluni kiuciqniluku, arnangiaraurcan Yugtaat kayuriluteng tailauciatnek, Yuut-llu agayuviim-llu qaneryarait cangallrunritniluki.",
                "Talks about how faith can heal addiction, how one will have no strength without faith, to belive either in the church’s or Yup’ik ways, how an older Yup’ik will be happy to answer questions about traditional instructions, how the wisdom she learned comes to her stronger now that she’s older, and how Yup’ik wisdom is no different from the Bible."
            ],
            "94": [
                "19:30",
                "Qanemciluni irniani kenekngamiki taangayuitellerminek, ilameng angayuqrit meraaqata neryartuutetullratnek, taangayuitellruami-llu akinanauresqelluni taangaasqevkenaki irniani.",
                "Talks about how she never drank alcohol out of love for her children, how they would bring in friends to eat when their parents were drinking, and how she wants her children to repay her by not drinking."
            ],
            "101": [
                "20:59",
                "Qalarrluni kinguliat Yuut Kass’at-llu piciryarata akuliitni uitiimeng caperrnariniluki, ilait qitevterrlainarniluki, Yugtarnek niicugniyuumiilngaluciatnek, cam iliini qaneryarat umyuaqeciqniluki, kenkekun-llu tau͡gaam qanrutetuniluki.",
                "Talks about how younger generations have it harder in between Yup’ik and Western ways, how some only speak English, how they don’t seem to want to listen to Yup’ik instruction, how they will remember it in the future, and how instruction comes from love."
            ],
            "114": [
                "23:13",
                "Qalarrluni ayagyuat ellmeggnek tuqutellrianek wall’u callualuteng tuqucilrianek, ellmeggnek pilriit assiilngurmun ellangarkauciantnek, irniateng-llu qaillun ayuqengraata qaruquraasqelluki.",
                "Talks about suicide among the youth or fighting and killing each other, how those who commit suicide have a bad afterlife, and for parents to encourage their children no matter what they’re like."
            ],
            "126": [
                "25:45",
                "Qanemciluni ircenrrarugarnek iliitnek-llu uurcamek, unani-llu yuut qaillun pitalrianek pitellritnek ircenrraat nallunaitullratnek.",
                "Talks about a legendary little person coming from shore with a signaling gaff, and how the little people would tell of how much the people at sea caught."
            ],
            "133": [
                "27:12",
                "Qanemciluni ircenrraat kinguatni yugmek uurcamek, Elngum atii qasgimun aqumluni aturpagluni uurcaq ciuniutullruniluku, uurcaq tekicami negcikcuarani kapuarrluku qanemcitullranek, ciumeggni-llu ircenrraat amllertaciacetun tekitetullratnek.",
                "Talks about a human coming with a signaling gaff after the little people, how Elnguq’s father would go sit on the community house and sing a welcoming song, when the one with the signaling gaff stuck the gaff to the ground and told of their hunt when he arrived, and how they would come with the exact number as the little people before them."
            ],
            "148": [
                "29:45",
                "Mary Worm-aq qanemciluni qavamikun angalkurtellerminek, pinirkamek inguliurutkaanek-llu piicallerminek, uluakun-llu angalkum ayagcetai unatet [temailnguut] ingluklerminek.",
                "Mary Worm talks about besting a shaman in her dreams, how she prayed for strength and a means of opposition, and using an uluaq to fight the disembodied hands sent by the shaman."
            ],
            "171": [
                "33:27",
                "Qalarrluni cetuum nuugatun umyuangniluki, nekayugnayuksuunaki qalarutenqegcaaratullratnek, taangarturalriarunritlermeggni qaruyutesqelluki, kenkekun-llu tau͡gaam qalarutetuniluki.",
                "Talks about how people now have the mindfulness the breath of the tip of a fingernail, how they used to be strictly instructed without fear they would take offense, to encourage each other while sober not to drink alcohol, and how they give instruction out of love."
            ],
            "180": [
                "35:17",
                "Qanemciluni taangaq enurnarqellrani ellangellerminek, taangam picurlautai naulluutmi arcaqanruniluki, cangerlak taangamek cimingniluku, taangaq-llu callugnaluku quyurtelaucimeggnek.",
                "Talks about how [s]he grew up will scarcly any alcohol around, how misfortune from alcohol is worse than sickness, how epidemics were replaced by alcoholism, and how they would meet to combat alcohol."
            ],
            "197": [
                "37:32",
                "Qanemciluni ellam iqulitarkaanek niitetullerminek, cam iliiniku piitnamek qantullratnek, umyuaqelgurikeni pitekluku ellam iquklitlerkaanek aaryuuciminek, angukara’urluut arnassagaat-llu  ciisquteng ayaperluki piyuayaurtellratnek, tegganernek-llu taklartellrianek.",
                "Talks about what he used to hear about the end of the world, how they talked about a time of need in the future, how he’s wary of the world’s end based off of something he remembers most, how old people would start walking by supporting themselves on their knees, and bedridden elders."
            ],
            "206": [
                "38:54",
                "Qanemciluni tegganret ciunerkiullratnek yuunerturraarluteng aipirngaitniluku, iliita amci pisqelluku tungenqegturanratni qantullratnek, yuut-llu ilaciqanricuitniluki.",
                "Talks about how elders predicted that people would never live long again, how one would hope it would happen already during their good time, and how people are always hopeful."
            ],
            "217": [
                "40:43",
                "Qanemciluni Ernernek [agyat wall’u ella qallun piluni?], angutet Erneruaryaurrniluku, ella qaillun piarkaurtaqami nallunaitetuniluku qantullratnek, ellam iquklitlerkaanek neryuniurraarluteng neryuniunrirciqnillratnek, qanikcangqerrnanrirkaucianek-llu qantullratnek.",
                "Talks about Erenret [“days,” constellation or natural phenomenon?], how men said that Erenret don’t herald what they used to, how the world/nature gives signs when something is going to happen, how people will stop expecting the end of the world, and how there will be no more snow."
            ],
            "238": [
                "43:37",
                "Qalarrluni meluk allrakurtaaryaaqeng’e’rmi cangaringailucianek, elluarrluni taryuumakun sulunaq allrakurtaaryaaqeng’e’rmi cangaringailucianek, nenglliyuicaaqellret qanikcalanguciatnek, allamiut unguvaseng tunulluku Alaska yui arcakngaitniluki, mallguskan-llu Erneruarciqniluku kinguinek-llu.",
                "Talks about how fish roe can keep for years, how salted fish can keep for years if properly salted, how previously warm places started getting snow, how people of other places will not help Alaska over themselves, and how Erneruaq [False Day] will happen near the end and what that entails."
            ],
            "262": [
                "46:58",
                "Qalarrluni maurluulriit apa’urluulriit-llu qanerteńgunrirniluki, mallguskan piitnaq cakucinek neq’lirtuutengciqniluku qanllermek tamakunek-llu nernge’rmeng kemgiuciiqnilukis, neqpiit-llu kuimarqata qaategtevkenateng teguterrlainaasqelluki.",
                "Talks about how grandparents don’t instruct anymore, how certain fish will be populous before famine and how they will still thin out despite eating them, and to always gather salmon whenever they’re available."
            ],
            "284": [
                "50:06",
                "Qanemciluni qanrutesteḿinek qavangurtullermek enerrlainarmek pektellriamek kuvyakun cangluni, allrakut amllenrilnguut piitnaq tut’eqatarniluku neqem qanellranek, qanqautestiin kinguani allamiaquaqan arcaringatniluku, aqsamegteggun-llu mayiteqkuneng qaillun piarkauciatnek umyuartequciminek.",
                "Talks about an elder who spoke to him of a dream of catching an animated fish skeleton in his net, how it said that famine was coming in a few years and that the spirit of theft would, how it seems worse every since the elder said that, and how he wonders how far people with empty stomachs will go."
            ],
            "299": [
                "52:37",
                "Qanemciluni ayagyuanek qanrucunailngurnek niitenrilngurnek-llu tangllerminek, niicuilnguut ilameggnek ayuqniatuniluki, umyuarteng aturluku yuulriit ak’anun unguvayuitniluki, nalluungualukarluteng-llu yuunriqerniaqluki.",
                "Talks about seeing youth rejecting advice and being disobiedent, how disobedient people covet what their peers have, how those who follow their minds do not live long, and how they would pass away with minor sicknesses."
            ],
            "311": [
                "54:25",
                "Qalarrluni aliayullni maliggluku yuukuni ayagciani nangciiqniluki, umyuamegteggnek utumalrianun nugtesqelluku, aliayullni maligtaquurpakarluku yuulria egilrallra cukalarniluku, ayagyuaq-llu napangucini uurutkesqevkenaku qanrutlerminek.",
                "Talks about how living according to loneliness hurts those who have departed, to seek support from mentally healthy people, how living with constant loneliness makes for a short live, and telling a young man never to [?regret] standing [alive]."
            ],
            "327": [
                "57:07",
                "Qalarrluni qanruyutmeggnek asgurtalriit canun enurniluki, akusrarun atu’urkaatnek allurqengelriatun ayuqniluku, taangaq kuingill’er-llu ayuquciqsagutnilukek, anernerteng-llu kep’larniluku.",
                "Talks about how people who doubt wisdom are in need of things, how mischief steals what people need, how people have turned to alcohol and marijuana, and how they take their own lives."
            ],
            "339": [
                "59:18",
                "Qanemciluni ellminek atrartessiyaatullerminek, nasaurlullgutni ilalillrunritlerminek, akusrartellrianun ilautellruniluciminek, yuilqumi ellu’urtatullerminek equgtatullerminek-llu, assiitellriit atuusqevkenaki.",
                "Talks about putting herself down too much, not playing with the other girls, not joining in on mischeif, sliding and doing work out in the wilderness, and not to be temped by bad things."
            ]
        },
        "elderTags": [
            "23.59",
            "23.85",
            "23.78",
            "23.8",
            "23.16",
            "23.80",
            "23.60",
            "23.60"
        ],
        "tags": [
            "2.2.36",
            "2.2.32",
            "2.2.31",
            "2.2.30",
            "2.2.28",
            "2.2.18",
            "2.2.17",
            "2.2.10",
            "2.2.9",
            "3.8",
            "4.2",
            "5.1.3",
            "8.1.3",
            "8.4",
            "9.1.1.1",
            "9.2",
            "9.3",
            "10.5.1",
            "10.7",
            "12.1.1",
            "13.3",
            "15.3.1",
            "19.3.1",
            "19.3.2",
            "19.6.1",
            "19.8",
            "19.13.1",
            "19.14",
            "19.15.1",
            "22.2",
            "22.4",
            "22.5",
            "22.7",
            "22.8.1"
        ]
    },
    "cpb-aacip-127-65v6x4wh.h264": {
        "videoID": "cpb-aacip-127-65v6x4wh.h264",
        "title": "Angutevialuk Albert Beaver - # 63",
        "time": "19:48",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "7": [
                "00:56",
                "Qanemciluni Cakayagtun [Johnny Samuelson] allrakungqerrniluni, Ceńaqlirni yuurrluni Qipnermi-llu anglillerminek, Anuuraamun-llu aipangyartullerminek.",
                "Talks about being the same age as Cakayak [Johnny Samuelson], being born in Ceńaqliit and growing up Qipneq [Kipnuk], and moving to Anuuraaq to marry."
            ],
            "19": [
                "02:26",
                "Qanemciluni usvituluni yuusqumatullerminek, amirkaq atauciq qemangqauraasqelluku qayangellerkaminun, akirrauteni qemangqaurluku akitunrulrianun atuusqelluku, tan’gaurluullermini-llu Kass’artarnek aklungqerrsullerminek.",
                "Talks about being instructed to live wisely, saving up furs one by one until he gets a kayak, to save money to afford more expensive things, and growing up wanting Western clothes."
            ],
            "34": [
                "04:59",
                "Qanemciluni pilugutuyaaqerraarluni sap’akilanguciminek, umyugailkuni ilani ayuqniarciqnillerminek, irniami-llu iliita akiuteni quyurqurkuniki cangyugngacianek.",
                "Talks about switching from skin boots to Western shoes, how being mindless leads to coveting peers, and how one of his children could afford things if he saved."
            ],
            "55": [
                "08:00",
                "Qalarrluni tegganret atullermeggnek picurlallermeggnek-llu qalartelauciatnek, Min’garalriim qanemcianek Aassitugaankunek, Aassitugaq picuileng’e’rmi qemagciuratuami caicuitellranek, angayuqrit-llu yuungnaqkata neqkautengqerciqniluki cautengqerciqniluki-llu.",
                "Talks about how elders give advice based on their experiences and mistakes, how Min’garalria [Qinaq] told a story of Aassitugaq and family, how Aassitugaq was a bad hunter but always saved and had things, and how a family could have food and things if their parents strive."
            ],
            "76": [
                "11:21",
                "Qalarrluni qetunralget arrsaunritniluki, pissulriim-llu atauciunge’rmi talliman nukalpiat nepliryulriit anagcugngacianek.",
                "Talks about how those with sons are not poor, and how a single hunter can catch more than five quarreling great hunters."
            ],
            "90": [
                "13:43",
                "Qanemciluni neviarcaraat uingeksailnguut ayuqucirtuumallratnek, unugmi angutet wall’u arnat ullaasqevkenaki, aglenrraat-llu inerquutaitnek",
                "Talks about how unmarried girls would be instructed, not to meet young men or women at night, and admonishments for first-year menstruations."
            ],
            "103": [
                "15:26",
                "Qanemciluni ayuqucirtullerkarteng kingurautniluku, ayagyuat Kass’at yuungnaquciatnun ekuciatnek, Yugtun-llu qaneryaraat temciqutekuciatnek, niicugnirraarluteng-llu qanellri pegtelauciatnek.",
                "Talks about how late it is to speak of traditional instructions, youth getting into the Western way of life and making fun of the Yup’ik language, and how some listen to him then forget what he says."
            ],
            "113": [
                "16:57",
                "Qanemciluni melqulguteteng qemanqatullermeggnek, maklaaret kiturceterrlainarpek’naki apa’urlumi qanellranek, ciuliartarmek qalartellerkani tengrukenriuciminek, irniaminek-llu alerquutet maligtaqunrilngurnek.",
                "Talks about how they saved whatever fur they got, how his grandfather told him to catch after seal he sees, how he has no more motivation to talk about the ancestors’ ways, and how his children don’t follow traditional teachings."
            ]
        },
        "elderTags": [
            "23.13"
        ],
        "tags": [
            "2.2.27",
            "1",
            "5.4",
            "7.4",
            "9.2",
            "9.4",
            "7",
            "17.4.3",
            "19.3.3",
            "19.5",
            "19.6",
            "19.7.1.1"
        ]
    },
    "cpb-aacip-127-66vx0v02.h264": {
        "videoID": "cpb-aacip-127-66vx0v02.h264",
        "title": "Nengqerralria Nengeq'aq Elena Charles - # 64",
        "time": "21:52",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Elena Charles"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Qang’allugaq Hazel Lincoln"
            ]
        },
        "summary": {
            "1": [
                "01:03",
                "Qanemciluni Yugtarnek Kass’artarnek-llu naanguanek, nasaurluullgutni-llu yaaruitullermeggnek, airratullermeggnek, kiagmi-llu inuguatullermeggnek/irniaruatullermeggnek.",
                "Talks about Yup’ik and Western toys, how she and the other girls would tell storyknife stories, playing string games, and playing with dolls in the summer."
            ],
            "40": [
                "05:31",
                "Qanemciluni canegnek enelitullermeggnek irniaruanek-llu, naanguarkameggnek quagcinek aturalinguatullermeggnek, kiagmi angualgutullerminek egelrutkun, irniaminek irniarualrianek yaaruilrianek-llu, mikelnguut-llu Kass’artarnek naanguaryaurciatnek.",
                "Talks about making grass houses and people, making sourdock clothes to play with, how she always traveled in the summer by paddling a canoe, her children playing with dolls and telling storyknife stories, and children now playing with Western toys."
            ],
            "64": [
                "07:49",
                "Qanemciluni anguteteng ayakata’arqata upyutetullermeggnek, aatiin kuvyatullranek taluyalitullranek-llu, aipani-llu uksuiyatullermegnek up’nerkiyatullermegnek-llu, angutet-llu tangvallmi kapkaanatullratnek.",
                "Talks about helping the men of their family prepare for travels, her father using nets and making fish traps, going to winter and spring camp with her husband, and how the men she watched set steel traps."
            ],
            "76": [
                "09:24",
                "Qanemciluni angayuqaagni-llu up’nerkiyatullermeggnek, ella-llu qaillun pingraan pelatekani qerrucuitellratnek.",
                "Talks about going to spring camp with her parents, and not being cold in tents despite the weather,"
            ],
            "93": [
                "10:51",
                "Qanemciluni up’nerkami equgtatullerminek, atami atu’urkai aaniin upyut’lallranek, tuntuvagnek ivrucingqellermeggnek, amllerraarluteng-llu tuntut 1941-aami amllerrluteng tuqullratnek.",
                "Talks about how she would gather wood in the spring, her mother preparing clothes for her [speaker] father, how they had waterproof moose skin boots, and many caribou dying in 1941 after being plentiful."
            ],
            "116": [
                "12:49",
                "Qalarrluni aarcirtuutnek qessayaraq caitnaqniluku, yuut cayarait tangrresqumallerminek, caliuraasqumallerminek, pistekami ungangkengai aulukesqumallerminek, angayuqaagmi neqkat kenciktullragnek, alerquutet maligtaquluki neqet neqkat-llu uqlaucuiluciminek.",
                "Talks about warnings that laziness leads to destitution, to watch what people do, to work diligently, to take care of what a provider catches, how her parents revered food, and how she never makes a mess with food according to traditional instructions."
            ],
            "136": [
                "15:19",
                "Qanemciluni neqet akerciurcecuitellratnek, qerrullret [assiirulluteng] qimugteńun neqkiutullratnek, ilussaqertellrianek tangyuitellranek, anglillermini amlleret piunriyuitellratnek naulluussiyaayuunateng-llu, taangartaitellranek, arnaurtellerminek, angayuqaagmi-llu cucukekiignek aipangllerminek.",
                "Talks about how they wouldn’t let fish stay in the sun, how inflated [spoiled] fish were for dogs, how she never say anyone get food poisoning, fewer death and sickness when she was growing up, how there was no alcohol, how she became a woman, and her arranged marriage."
            ],
            "149": [
                "16:51",
                "Qanemciluni mingqiilrianun ellangellrunritlerminek tau͡gaam tupilrianun, arnassagaat kelugkatgun curulitullratnek, pingayunlegnek allrakungqellermini maurlumi piunrillranek, arnassagaat-llu ilagarluki elitellerminek.",
                "Talks about how she didn’t grow up around grass basket making but grass weaving, old women making mats out of course grass, her grandmother’s death when she was eight, and how she learned from being around old ladies."
            ],
            "156": [
                "17:43",
                "Qanemciluni aanii qessallrani Mikelnguut Elitnaurviatni ak’allartarteggun elitnaurillerminek, tupigyarami aanami alerquutainek, Mikelnguut Elitnaurviatni ikaraliitii, elitnaurvigmi issrat’lillerminek, kalngalitullratnek-llu.",
                "Talks about teaching Yup’ik ways of making things at Mikelnguut Elitnaurviat when her mother refused, her mother’s instruction on weaving, her grass mat at Mikelnguut Elitnaurviat, making a grass backpack for the school, and making grass bags for fish."
            ],
            "186": [
                "21:05",
                "Qanemciluni yuut tamarmeng ellivingqetullratnek, kinercilriit-llu neqet assiirucuitellratnek.",
                "Talks about how every family had a cache, and how drying fish wouldn’t go bad."
            ]
        },
        "elderTags": [
            "23.61"
        ],
        "tags": [
            "2.2.66",
            "2.2.38",
            "2.2.36",
            "5.3.1",
            "5.3.9",
            "5.3.10",
            "17.5",
            "17.7",
            "6.3.5",
            "6.3.6",
            "6.3.7",
            "7.4.1",
            "9.3.1",
            "9.3.2",
            "9.6",
            "9.7",
            "9.8",
            "9.10",
            "10.2.1",
            "10.5.2",
            "10.10",
            "11.6.1.1",
            "14.3.1",
            "15.3.2",
            "17.1.5",
            "17.5",
            "17.6.2",
            "17.7",
            "17.4",
            "17.4.4",
            "18.1",
            "18.2",
            "18.3",
            "18.4",
            "19.3.1",
            "19.6",
            "19.7.1.1",
            "19.9",
            "22.5",
            "22.9.1",
            "22.10"
        ]
    },
    "cpb-aacip-127-68kd59ft.h264": {
        "videoID": "cpb-aacip-127-68kd59ft.h264",
        "title": "Betty Guy - # 66",
        "time": "22:22",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview",
                "Gener 2:",
                "Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [
                "Kuiggluk [Kwethluk]"
            ],
            "Name 1:": [
                "Betty"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:39",
                "Betty qanemciuq iinriurteńgurteqarraallerminek, iinriurtek-llu tekitellriik mumigut’lallerminek.",
                "Betty talks about becoming the first nurse, and translating for nurses that came."
            ],
            "19": [
                "02:47",
                "Qanemciluni naulluulriit ayuquciit igauqaarluki iinriurteńek iinrukaitnek alerqutullerminek, elitnauristeḿek-llu ikayurterluni iinruliutullermegnek.",
                "Talks about relaying between patient check-ups and the nurses’ prescriptions, and working with teachers for prescriptions."
            ],
            "39": [
                "05:10",
                "Qanemciluni tekitellriit yuungcaristet ikayuusqelluki 1960-mi council-aanek caliarkangllerminek, ellminek Kass’atun emutellriit qanrutkesqelluki elitnauristeḿun qanrucimallerminek, ellminek-llu qanercuuteliuryaurtellerminek.",
                "Talks about being taken in by the tribal council in 1960 to officially help the arriving nurses, a teacher telling her to start reporting in English by herself, and learning to operate the radio by herself."
            ],
            "90": [
                "11:32",
                "Qanemciluni ellminek qanercuutengllerminek, iinrukaitnek upyut’lallerminek, elitnauristeḿek-llu ikayurtaileng’e’rmi caliyaurtellerminek.",
                "Talks about starting to report through the radio by herself, preparing prescriptions, and starting to work independantly without a teacher’s help."
            ],
            "120": [
                "14:59",
                "Qanemciluni elitnauqeryartullerminek, calillguterluni-llu Kuigglugmi calillermegnek.",
                "Talks about going to training, and working with another in Kuiggluk [Kwethluk]."
            ],
            "139": [
                "17:24",
                "Qanemciluni yuungcaristet ellimeratni elitellerminek, yuungcaryaramek elitellerminek, Kass’atun elitellerminek, Yugtun-llu qalartesciigatlermeggnek.",
                "Talks about learning healthcare by by invitation from nurses, learning about health care, learning English for her work, and not being allowed to speak Yup’ik."
            ],
            "161": [
                "20:02",
                "Qanemciluni Kass’atun elitellerminek, kinguveminek-llu.",
                "Talks about learning English, and her descendants."
            ]
        },
        "elderTags": [
            "23.21"
        ],
        "tags": [
            "2.2.41",
            "22.11"
        ]
    },
    "cpb-aacip-127-69m37zr9.h264": {
        "videoID": "cpb-aacip-127-69m37zr9.h264",
        "title": "Tamarqalria Tam'aq Elizabeth Andrew - # 67",
        "time": "26:53",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Uquviar Olinka Andrew"
            ]
        },
        "summary": {
            "3": [
                "00:36",
                "Qanemciuq ellangellermini qanruyutellerminek, Tagyaram paingani ellangellerminek, neqlillerni kiingan yugnek tangtullermeggnek, maurluugminek anglicartegminek, unuakumi maurlumi inerqulallranek, caliqcaarluteng-llu ullagtaarutesqumanritlermeggnek.",
                "Talks about traditional wisdom when she was growing up, growing up at the mouth of Tagyaraq, only seeing people at fish camp, being raised by her grandparents, her grandmother admonishing them in the morning, and to keep busy instead of always visiting each other."
            ],
            "26": [
                "04:06",
                "Qanemciluni cakameggnun tupitullermeggnek, tupiganek neqkameng caqukaitnek, iitanek taryaqviit caqukaitnek, cumercuilkuneng iliiraarkauciatnek, Kass’artartaunani ellangellerminek, ellangellratni mat’um nalliinitun ayuqellrunrilucianek, qanruyutet-llu qigcignarquciatnek.",
                "Talks about weaving grass for things, woves grass food containers, tall cottongrass containers for king salmon, how they would be beggars if they don’t work hard, growing with nothing Western, how different things were when she was growing up, and how wisdom deserves respect."
            ],
            "41": [
                "06:02",
                "Qanemciluni neqalleruar ikgelkevkenaku ciuniuresqumallerminek, segluki kinerciryaraitnek, ikgelkelluki-llu ilangcimanrilnguut caunrirarkauciatnek.",
                "Talks about accepting any fish without saying it is not enough, cutting and drying fish, and how neglected food that is considered not enough will go to waste."
            ],
            "50": [
                "07:16",
                "Qalarrluni unangkengait tamalkuita amrukevkenaki aulukesqelluki, neqallret ciqicaraitnek, anrutaq piinani nangteqnarqucianek, neqa sagtesqevkenaku, assiilkiluteng-llu qessakiluteng-llu neresqevkenaki.",
                "Talks about taking care of all catch no matter how much it is, proper disposal of fish scraps, how an empty stomach is unbearable, not to scatter food into a mess, and not to dislike or reject food."
            ],
            "68": [
                "09:05",
                "Qalarrluni irniaminek anglicaryaraanek, uimeggnun cingutesqevkenaki, enemi nayuusqelluki, anagulluku inerciigaluciat pivkenaki, yagiraasqevkenaki, qanpautesqevkenaki, qavaryunqegkuneng-llu irniayagaita qurciqniluki.",
                "Talks about child rearing, not to push their children to their husbands, to stay with them in the house, not to react too excessively to their misbehavior, never to raise a hand against them, not to shout at them, and that their babies will pee on them if they sleep too much."
            ],
            "107": [
                "14:01",
                "Qanemciluni iqairyaranek terr’ilitatullermeggnek, caunrilketalriit caitelauciatnek, qemangqauralriit atullerkameggnun tekitelauciatnek, kenkem qanruyutngucianek, akinauresqevkenaki, allanret-llu ilaliuresqelluki.",
                "Talks about using washable diapers, those who disparage things will have nothing, how things kept available eventually get used, how love is a part of wisdom, not to retaliate, and be hospitable to guests from other villages,"
            ],
            "130": [
                "16:47",
                "Qalarrluni ilait cangraata pillruniluteng, angayuqateng qigcikesqelluki, cam tamarmi qanruyutengqerrucianek, ilateng kenkesqellukik, qanruyun-llu paitaqesqeńiluku.",
                "Talks about treating peers well no matter what they do to you, respect your parents, how there’s wisdom for everything, to love one another, and to continue to pass down wisdom."
            ],
            "157": [
                "20:29",
                "Qalarrluni yuut tamarmeng qessatuciatnek, qessailngurnek qessanqunek-llu, qessailnguut ayuquciatnek, qessanqut-llu ayuquciatnek.",
                "Talks about how every person has laziness, not lazy people and lazy people, how people who aren’t lazy are, and how lazy people are."
            ],
            "180": [
                "23:38",
                "Qalarrluni yuk qenngailngurmek ilaitniluku, piunriquneng-llu nunkagketnek.",
                "Talks about how every person feels anger, and afterlife destinations."
            ],
            "193": [
                "25:33",
                "Qalarrluni qessange’rmi piuraasqelluku, neqet amllengraata aulukesqelluki, aklut sagtesqevkenaki, paralqerpaigata-llu neq’liuresqelluki.",
                "Talks about ignoring laziness, to work on fish even if there are a lot, to keep clothes neat, and to work on food before they get worms."
            ]
        },
        "elderTags": [
            "23.76"
        ],
        "tags": [
            "2.2.30",
            "17.5",
            "6.3.4",
            "7",
            "8.3",
            "9.3",
            "9.6",
            "9.9",
            "10.2",
            "10.3",
            "10.10",
            "10.11",
            "10.12.1",
            "16.1",
            "17.5",
            "19.3.1",
            "19.5",
            "19.6.4",
            "19.10.1",
            "19.13.2",
            "19.13.3",
            "19.13.4",
            "19.13.5",
            "21.1",
            "22.2.1",
            "22.2.2"
        ]
    },
    "cpb-aacip-127-719kdf8m.h264": {
        "videoID": "cpb-aacip-127-719kdf8m.h264",
        "title": "Uliggaq Martha Oscar Sara - # 68",
        "time": "10:37",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [
                "Mamterilleq [Bethel]"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciluni Kass’alillranek.",
                "Talks about how there were a lot of Caucasians among them."
            ],
            "8": [
                "00:26",
                "Qanemciuq Mamterillermun upakarraallerminek, anglillermini Mamterillermiunek, enepiangqetullermeggnek qasgimek-llu, muragnek-llu enenek.",
                "Talks about first moving to Mamterilleq [Bethel], the early inhabitants of Mamterilleq, how they had mud houses and a community house [sod], and log houses."
            ],
            "25": [
                "02:09",
                "Qanemciluni yuut neqnek cumigtetullratnek, meluit qamiqurrit-llu kinercitullratnek, nanilngurnek kuvyangqetullratnek, angyameng cavyarauciatnek, qusuurnek-llu qalutullermeggnek.",
                "Talks about how people focused on food, drying fish roe and heads, how they had short drift nets, how boats required rowing, and dipnetting for rainbow smelt."
            ],
            "39": [
                "03:34",
                "Qanemciluni kencikngamegteki neqet sagcuitellratnek, cailkamtevkarpek’naki neqet qamagtelallratnek, neqkat kencikenrilkaceteng enurnarilauciatnek, kipusvigtangucianek, ellirauluteng anglillermeggnek, aulukestemeng-llu piliarinek cikiutengtullermeggnek.",
                "Talks about how they would not scatter fish out of reverence, storing food away instead of leaving it, how food sources that aren’t revered become scarce, there now being stores, growing up as orphans, and getting handmade gifts from their caretaker."
            ],
            "58": [
                "05:30",
                "Qanemciluni yuut elliraat takumcuktullratnek, yuut naklegyugngairuciatnek, eyagyaram-llu tungiinun nalluciminek.",
                "Talks about how people took pity on orphans, how people will not have pity now, and not knowing much about abstinence."
            ],
            "69": [
                "06:37",
                "Qalarrluni yuut ilakutenriuciatnek, ilakuyuteqapigtetullermeggnek, ilameggnek-llu tegleganguciatnek.",
                "Talks about people losing a sense of community, how they used to have a strong sense of community, and how they have started stealing from each other."
            ],
            "90": [
                "08:39",
                "Qalarrluni ayagyuat kenkutesqumaniluki, taangam-llu arenqiallugutainek.",
                "Talks about how youth should treat each other with love, and negative effects of alcohol."
            ]
        },
        "elderTags": [
            "23.81"
        ],
        "tags": [
            "2.2.38",
            "4.5",
            "9.3.1",
            "9.3.3",
            "10.5",
            "16.1.1",
            "16.5",
            "17.4.5",
            "19.6",
            "19.10.1",
            "19.13.1",
            "21.2",
            "22.5"
        ]
    },
    "cpb-aacip-127-719kdfjd.h264": {
        "videoID": "cpb-aacip-127-719kdfjd.h264",
        "title": "Allranitailnguq Allran'aq Joe Chief Sr., Arnaaquq Aqesgirpak Mary Worm, Nauyaq Anna Andrew, Winifred Beans, Joseph Evans (?), Kumluilnguq Matthew Frye, Nauyaq Anna Andrew, Narullgiar Elena Nick - # 69",
        "time": "1:02:28",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Compilation"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)",
                "Anastasia Cooke Hoffman"
            ]
        },
        "summary": {
            "1": [
                "00:17",
                "Qanemciuq piunrilrianek niitaqameng nepliatullratnek, yuut kanvellrat cukariciqniluku ciunerkiullermek, nepliananrirarkauciatnek, taangatullerminek-llu.",
                "Talks about how villages used to mourn, a prediction of people dying off more quickly in the future, how people will stop mourning, and past use of alcohol."
            ],
            "19": [
                "02:32",
                "Qalarrluni Yullret Yuugarkat-llu cimillerkaatnek, ciunerkiullrit tangvauciminek, nunat tamarmeng ciunerkiullertun elliuciatnek, ayagyuat-llu qanruyuteteng cakenrirniluki.",
                "Talks about a shift in past and modern Yupiit, seeing the predictions come true, how every village have become as predicted, and how youth don’t adhere to wisdom anymore"
            ],
            "34": [
                "04:40",
                "Qanemciluni yuilqumi anglillerminek, up’nerkami naugaaralrianek nertullerminek, anglillermini naumalrianek nerurarraarluni taqnerurcami taqsuqsuitellerminek wall’u qerrucuunani, naumalriit-llu tememun ikayuutnguciatnek.",
                "Talks about growing up in the wilderness, eating plants in the spring when they grew, never feeling tired or too cold as an adult after a childhood of eating plants, and how beneficial plants are for the body."
            ],
            "46": [
                "06:17",
                "Qalarrluni ellminek atanqerkaunritniluku, temirteńgurrnge’rmi umyuangqerrkauniluku, Agayutem-llu wall’u Yuut alerquutaitnek ukvengqerrarkauniluki.",
                "Talks about not to preside over oneself, to be mindful even as an adult, and the need for belief in in God’s or Yup’ik commandments."
            ],
            "52": [
                "07:41",
                "Qalarrluni ellakegtaaraungraan ellarrlugnilallratnek, naulriit pikaitnek ellallinriraqan ellakegtaar ellarrluuniluku, naucetaanek neqelget Kass’at ellallinritaqan ellarrlukuciatnek, nauginritaqameng kaituniluki, mermek-llu enuqitellrianek.",
                "Talks about “bad weather” when the weather is good, how bad “good weather” is no rain for plants to grow, how agricultural Westerners consider no rain to be bad weather, crop failures leading to starvation, and water shortages."
            ],
            "64": [
                "09:52",
                "Qalarrluni cat enurnarilauciatnek, Agayun-llu cangayugaqami neqkaugarkat catairucet’laucianek.",
                "Talks about how some things become scarce, and how God takes away food sources when taking offense."
            ],
            "68": [
                "10:46",
                "Qalarrluni naucetaamegteggun piitnalrianek, kuigteggun piitnalrianek, nengla puqla-llu pitatekenrilkagnek naumalriit naungailuciatnek, mermiutaat tuaten puqlamun nengelmun-llu agtuumaciatnek, piitnam-llu nallunailkutengqerrucianek.",
                "Talks about shortage of crops, shortage for river subsisters, how plants will not grow if cold and warm are not in harmony, how marine animals are also affected by warm and cold, and that famine is preceded by signs."
            ],
            "78": [
                "12:36",
                "Qalarrluni piitnam malruucianek, angucalum piitnam kiagnacialaucianek, arnacalum piitnam kiagyararalaucianek, tamakuk nalliigni nunat tamarmeng ellarrlutuciatnek, tunglimi arnacalumi piitnami yugugaat palullratnek, anakuneng ilait nugtartetullratnek, kaignami nunat qaillun ellilauciatnek, ellarrluum nallunailkutiinek, ellam-llu qupsaraanek.",
                "Talks about two types of times of need, how a male time of need has late summers, how a female time of need has early summers, how bad weather presides all villages over during those times, how they spoke of the last female time of need where many starved, how some survivors would move, how a village progesses during starvation, the sign of bad weather, and the world or universe cracking."
            ],
            "96": [
                "15:17",
                "Qalarrluni ellarrlugmek tekitarkamek, ciulirnellernek elitellret kinguvararkaunge’rmegteki piyuiluciatnek, ellarrlukatangraan neqaitqapigcuilucianek, pirtuum nalliinek, piitnam-llu nalliini carvanrem kanermek ilangqerrucianek.",
                "Talks about the impending bad weather, how those who heard from elders must pass them on but don’t, how there’s still some food even with impending bad weather, blizzard seasons, and how there’s frost on the currents during times of need."
            ],
            "118": [
                "19:23",
                "Qanemciluni can’giirmek ut’rulluni kenillranek, meluutaitellerkameggnek nangyaryullratnek, meluut kenircirat cangariyuiluciatnek, qangqiiret-llu anaitnek neryugngaciatnek.",
                "Talks about bringing home a blackfish and cooking it, how they used to be scared of having no fish roe, how dried roe lasts long, and how ptarmigan feces is edible."
            ],
            "130": [
                "21:43",
                "Qalarrluni ak’anun nereksailngurnek alungyaraat qassarluki tuqunarquciatnek, kemgillillret-llu angungnaqlernek.",
                "Talks about how eating blackfish fries raw is deadly after a long period of not eating, and gaunt people going out to try to find food."
            ],
            "137": [
                "23:13",
                "Qalarrluni taangakun picurlalrianek, maa-i taangaryulrianek, taangam-llu navguutngucia ayagyuanun umyuaqesqumaniluku.",
                "Talks about alcohol-related accidents, modern alcohol addiction, and how he wants youth to remember how destructive alcohol is."
            ],
            "164": [
                "27:32",
                "Qalarrluni kenekngamegteki irniateng auluk’lauciatnek, irniarit angliameng qigcigtanriuciatnek, ilait-llu ayainanermeggni taangayuiruyuciatnek.",
                "Talks about parents taking care of their children out of love, children being disrespectful when they’re older, and how some people quit drinking when they’re older."
            ],
            "181": [
                "30:24",
                "Qalarrluni qayatgun ayagatullermeggnek, imarnitnek, qayalriani ket’garyaramek, taangam picurlagnarqucianek, taangakun-llu kanevtellriatun ayuquciatnek.",
                "Talks about traveling by kayak, seal gut rain parkas, waterproofing kayak holes in the water, alcohol causing accidents, and many people dying from alcohol."
            ],
            "203": [
                "33:43",
                "Qalarrluni pugtautet piicunailuciatnek, qayatullermeggnek maa-i-llu levaatgun ayagaluaciatnek, yuum-llu picurliin ciuqerrani uitacianek.",
                "Talks about the importance of floatation devices, traveling by kayak before and by boat motors now, and how misfortune is always waiting to happen."
            ],
            "217": [
                "36:11",
                "Qalarrluni qanruyutet qanrutkestairu, ayuqenrilnguut-llu qalarrnge’rmeng ataucimek qanruyutmek qalartellratnek.",
                "Talks about how there are no more elders to pass on wisdom, and how he used to hear the same wisdom from different elders."
            ],
            "227": [
                "38:05",
                "Qanemciluni natret carrirturaasqelluki alerquumallermegnek, enemi cauralriit naulluuyuunateng yuunertuniluki, caarrluum-llu menuurrnarqenrilucianek.",
                "Talks about being instructed to always clean the floor, how people who keep the house clean live long without sickness, and how debris does not make one unclean"
            ],
            "244": [
                "40:43",
                "Qalarrluni maa-i enet anagutniluki, Cakayiinkuni [Johnny Samson] uitavallutullerminek carirturallerminek-llu, elitnaurvigtangellranek, cat-llu tamalkuita perrirturaasqelluki alerquumallerminek.",
                "Talks about how superfluous modern homes are, staying with Cakayak’s family [Johnny Samson] a lot and always tidying their house, and schools and colleges appearing, being told to always clean everything."
            ],
            "277": [
                "44:45",
                "Qalarrluni arnat aanateng caurallrit murilkelauciatnek, qulngunritaraat irniami ayuqenriluciatnek, ilaita sagtelauciatnek ilaita-llu sagtenriluciatnek, melqut-llu aklut qelleksaraitnek.",
                "Talks about how daughters watch their mother working, how different her nine children are, how some keep their homes tidy and some don’t, and storing fur clothes well."
            ],
            "304": [
                "48:16",
                "Qalarrluni maa-i enemeggni tukuurrniluki, arnam ena aulukarkaucianek, angutet ilaita ikayuutelauciatnek, maa-i-llu. ayagyuat enemi catussiyaanriuciatnek.",
                "Talks about modern people having abundance in homes, how women should take care of the home, how some men help, and how modern teenagers do not do much around the house."
            ],
            "334": [
                "51:50",
                "Qalarrluni aanaulriit irniateng tangvagcelluki elicungcaryugngaciatnek, callerkateng peggluki elitnaurvigmun caugarkauciatnek, irniami elitnauryaram cauryaram-llu tungiignun ayuquciatnek, irniarit-llu tangvagturluteng elitelauciatnek.",
                "Talks about how mothers teach their children through having them observe, how they are made to go to school instead of doing chores, her children’s attitudes on school and chores, and how children learn by observation."
            ],
            "366": [
                "55:47",
                "Qanemciluni carrarmek elitnaullerminek, ayagyuarluni aipangllerminek, maa-i ilaita kassuutnaciryauruciatnek, imumi aipangyaraq pirkaktullruniluku, qaillun angayuqrulriit irniateng aiparkiuryaraitnek, angayuqaagken angutekegtaarmek aiparkiullruaciagnek, aipangqerraallermini-llu ilain alerquutaitnek.",
                "Talks about going to school for a short time, getting married young, how some modern people get married when they’re older, how important marriage was back then, how parents chose spouses for their children, how she was arranged to marry a good man, and her family’s advice early in her marriage."
            ],
            "412": [
                "1:00:58",
                "Qanemciluni ayagyuange’rmi umyuarniutullerminek, angayuqaagmi cucukekiignek aipangllerminek, aipangqerraallerminek-llu.",
                "Talks about tending to worry at a young age, agreeing to an arranged marriage, and her early marriage."
            ]
        },
        "elderTags": [
            "23.7",
            "23.16",
            "23.60",
            "23.85",
            "23.39",
            "23.48",
            "23.60",
            "23.58"
        ],
        "tags": [
            "2.2.65",
            "2.2.38",
            "2.2.35",
            "2.2.32",
            "2.2.30",
            "2.2.28",
            "2.2.10",
            "2.2.9",
            "3.11",
            "5.1.1.1",
            "5.1.3",
            "5.2.1",
            "6.4.1",
            "7.5.1",
            "8.1",
            "8.2",
            "9.3",
            "12.1.2",
            "12.1.3",
            "13.3.1",
            "13.3.2",
            "13.3.3",
            "13.3.4",
            "13.3.5",
            "13.4",
            "14.3.1",
            "17.4.3",
            "19.5.2",
            "19.6.5",
            "19.13.6",
            "19.15.2",
            "22.5"
        ]
    },
    "cpb-aacip-127-74cnpfqb.h264": {
        "videoID": "cpb-aacip-127-74cnpfqb.h264",
        "title": "Akagalria \"Aanaq\" Sophie Nick - # 70",
        "time": "13:38",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciluni Kass’anek tangerqerraallermeggnek, aglenrraat eyagyaraitnek, mikelnguut kencigyugluteng akuyucuitellratnek, tan’gaurluut tungiitnun nasaurluut callerkaatnek, nuyavvlisqevkenaki, erurirraarluteng-llu neq’liuresqelluki.",
                "Talks about first Western contact, abstinence related to first menstruations, how children avoided the other sex out of deep respect, restrained behavior around boys, keeping hair kempt, and to wash hands before handling food."
            ],
            "30": [
                "02:57",
                "Qalarrluni tan’gaurluut qumaqicaraitnek, neqa kencikesqelluku, kuvyalriani cangtaq atauciungraan ciuniuresqelluku, uitatellriit assiirut’lauciatnek, neqet-llu auluksaraatnek.",
                "Talks about how boys can become sex crazed, to revere food, to welcome even one fish when drift netting, how neglected food goes bad, and how to care for food."
            ],
            "58": [
                "06:25",
                "Qanemciluni enemeggni cat paivngallrunriluciatnek, yuut assiiruyuciatnek, ayagyuat elluarluki yuusqelluki, ayagyuat-llu taangamun agtuumaciatnek.",
                "Talks about how houses had less things back then, how people have gotten worse, wanting youth to live well, and alcohol affecting young people."
            ],
            "82": [
                "09:09",
                "Qanemciluni taangartangqerraallranek, kinguliat elluarluki yuusqelluki, neqkat-llu aulukesqelluki.",
                "Talks about the introduction of alcohol, telling successive generations to live well, and to take care of food."
            ]
        },
        "elderTags": [
            "23.5"
        ],
        "tags": [
            "2.2.37",
            "10.5",
            "10.11",
            "10.12.1",
            "16.2",
            "19.7.1.1",
            "19.8",
            "19.9",
            "19.13.7",
            "19.13.8",
            "19.13.9",
            "22.5"
        ]
    },
    "cpb-aacip-127-74cnpfr2.h264": {
        "videoID": "cpb-aacip-127-74cnpfr2.h264",
        "title": "Apaqutaq Dick Andrew - # 71",
        "time": "20:37",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History, Culture"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:01",
                "Qanemciluni Paaskaam nalliini Elena Andrew-m piunrillranek, qasgimi anglillerminek Kayalivigmi, yaatemeggni Cuukvagtulirmiunek, pinarilriit tan’gaurluut natermi qavatullermeggnek, apa’urluminek-llu anglicarterluni qavaumavkaumayuitellerminek.",
                "Talks about Elena Andrew passing away around Easter, growing up in the community house in Kayalivik, neighboring village of Cuukvagtuli, boys of age sleeping on the floor, and being raised by his grandfather not to sleep too much."
            ],
            "32": [
                "03:12",
                "Qanemciluni qasgimi qavaryarallermeggnek, qasgimi qalartellrianek, nasaurlurnek-llu iterluteng qanerturalrianek niicugniyartulrianek.",
                "Talks about sleeping arrangements in the community house, instruction in the community house, and girls coming into the community house to listen to instruction."
            ],
            "51": [
                "05:00",
                "Qanemciluni tegganret mikelnguut ayuqucirtuaratullratnek.",
                "Talks about how elders always instructed children."
            ],
            "64": [
                "06:23",
                "Qalarrluni tegganret quyungqanriameng cimillruciatnek, piyugngacimitun ayagyuat qalarutetuniluki, tegganret ayagallerkam tungiinun alerquutaitnek, ayakatalriani taquarkanek cassuutnek-llu, ellaqerrutellriani callerkaitnek, kit’ellerminek-llu.",
                "Talks about how elders have changed since becoming separated, how he advises youth as much as he can, elders’ instruction on traveling, provisions and tools for every trip, what to do when the weather turns, and when he fell through the ice."
            ],
            "134": [
                "13:48",
                "Qanemciluni qimugciyunqenrilami piyuaguratullerminek.",
                "Talks about walking a lot since he didn’t like dog mushing."
            ],
            "140": [
                "14:33",
                "Qalarrluni imkut yuut alerquutaitnek, imumi naulluussiyaayuitellratnek, piunrilriit akultullratnek, uluryanrilnguut naulluuyuiluciatnek, angalkunek ukvengqellratnek, agayulirtet-llu tekiteqerraallratnek.",
                "Talks about traditional instructions of people of old, how people didn’t get sick often in the past, how rare death was, how people don’t get sick if they’re not wary of it, how they believed in shamanism, and when missionaries first arrived."
            ],
            "167": [
                "17:37",
                "Qalarrluni Ellam Yuanek ukvengqellratnek, tuunrangayagmek qanyuitellratnek, angalkut tuunritullratnek, angalkut ella kitugtetullratnek yuut-llu mamevkatullratnek, angalkut-llu cikirluki ilateng ikayuusqetullratnek.",
                "Talks about belief in the Spirit of the Universe [Ellam Yua], the lack of concept of the devil, how shamans performed their rituals, shamans fixing the weather and healing people, and how people brought gifts to request healing from shamans."
            ]
        },
        "elderTags": [
            "23.15"
        ],
        "tags": [
            "2.2.38",
            "2.2.20",
            "8.1.2",
            "8.2",
            "8.4",
            "11.2",
            "12.1",
            "19.3.1",
            "19.6",
            "21.2",
            "22.6"
        ]
    },
    "cpb-aacip-127-74qjqbsc.h264": {
        "videoID": "cpb-aacip-127-74qjqbsc.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip - # 72",
        "time": "21:34",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Arnaraq Mary Gregory"
            ]
        },
        "summary": {
            "1": [
                "00:06",
                "Qalarrluni Ellam Yuanek tangvagtengquratucimteńek, qanrucunarluteng qanruyutet maligtaqusqelluki, maligtaquyaram umyuarturinarqucianek, qanruyutet-llu maligtaqustait qanerteńgurtetuciatnek.",
                "Talks about how the Spirit of the Universe is always watching, to heed advice and obey wisdom, how adhering to traditional instruction makes one wise, and how those who adhere to traditional wisdom become instructors."
            ],
            "23": [
                "02:34",
                "Qalarrluni yuut assiuciat wall’u assiiluciat nallunrit’laucimeggnek, maa-i ellailkarrnarqellrianek, qanrucunarluki neplirpek’nateng-llu yuusqelluki inerquutnek, tegganret-llu uitanqegcilriamek ernermek cikitullratnek.",
                "Talks about knowing people’s good or bad ways, modern causes of senselessness, adages to heed advice and live without commotion, and how elders gave a day of peace."
            ],
            "43": [
                "04:58",
                "Qalarrluni yuut assilriit piciryaraitnek nallunriryaraitnek, tunciurteńi anglillerminek, yuut inglukucuitellratnek, nunarraat pillgutekluteng nuna aulukesqumaniluku, Yugni-llu nunaput ataniuresqumaniluki.",
                "Talks about recognizing the good in people, growing up around reindeer herding, how people didn’t contend with each other, how each village should work together to preserve the land, and how we should govern our lands."
            ],
            "76": [
                "08:28",
                "Qalarrluni ayagyuat angayuqrit calilaata alerquastekailuciatnek, taangakun akilluuqertelauciatnek, niisngalriit calirpatuciatnek, paistet-llu ilaita ayuqucirrluuciatnek ilaita-llu ayuqucirtulauciatnek.",
                "Talks about how youth don’t have instructors because their parents are working, how people squander money on alcohol, how obedient people work hard, and how some babysitters set bad examples and others instruct the children."
            ],
            "101": [
                "11:12",
                "Qalarrluni irniarit unuakumi tupallratni ayuqucirtuusqelluki, ayuqucirtuutetgun kenkekun-llu yuut kitugcaraitnek, yuut-llu tamarmeng alartelauciatnek.",
                "Talks about instructing children when they wake up in the morning, fixing people’s behavior with instruction and love, and how all people have faults."
            ],
            "121": [
                "13:40",
                "Qanemciluni yun’erraat qasgini elitnautullratnek, Kass’artaat elitnaurviit Yugtaat alerquastekait enaillruciatnek, ayagyuat qanrucunairuyuciatnek nepengluteng-llu, iimegteggun-llu elluanrilngurnek tangvauciatnek [Qaneryaranek].",
                "Talks about how young men were instructed in the community house, how Western schools replaced traditional instructors, how youth have become unruly and prone to disquiet, and how their eyes only focus on unrighteous things [Bible]."
            ],
            "132": [
                "15:10",
                "Qalarrluni yuk ukverunani calritesciigalucianek, qanrucunailnguum ukvelriarunrilucianek, qanrucunailnguut au͡gtarnarquciatnek, qanrucunailnguut-llu piinanermeggni tayimqertelauciatnek [piunrirluteng].",
                "Talks about how a person needs faith to be healthy, how one who doesn’t listen to instruction has no faith, how those who do not heed advice hinder others, and how those who don’t heed advice disappear [passing away]."
            ],
            "151": [
                "17:27",
                "Qalarrluni alerquutet Qaneryarani Qulen Alerquutetun ayuqniluki, umyuaqaciit irniateng kiingita inerqulauciatnek, umyualinqigtellriit-llu ayuqucillermeggnun utertesqevkenaki.",
                "Talks about how traditional instructions are like the Biblical commandments, how unmindful people don’t admonish only their children, and when a person changes their ways not to go back."
            ],
            "169": [
                "19:50",
                "Qanemciluni arnagnek ayuqucirturatullregnek, akingellerkani-llu umyuaqevkenaku ikayuasqelluku.",
                "Talks about two women who always instructed people, and to help others without expecting payment."
            ]
        },
        "elderTags": [
            "23.52"
        ],
        "tags": [
            "2.2.42",
            "2.2.31",
            "3.9.2",
            "3.9.3",
            "8.1.3",
            "8.2",
            "16.4",
            "19.3.4",
            "19.6",
            "19.11.1",
            "19.13.10",
            "21.2",
            "21.5",
            "22.5"
        ]
    },
    "cpb-aacip-127-752fr7q2.h264": {
        "videoID": "cpb-aacip-127-752fr7q2.h264",
        "title": "Mumess'aq Peter John - # 73",
        "time": "58:49",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Compilation"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Sophie Kusak",
                "Uquuviar Olinka \"Ollie\" Andrew",
                "Atmak Lillian Michaels"
            ]
        },
        "summary": {
            "1": [
                "00:15",
                "Qalartua taangaryulrianek.",
                "Talks about alcohol abuse."
            ],
            "14": [
                "02:01",
                "Qanemciluni nunameggni callarterpallermeggni iinruklerminek, callarcillni-llu teq’ukun erullerminek.",
                "Talks about a remedy she used when the village had sores, and washing her sores with urine."
            ],
            "37": [
                "04:39",
                "Qalarrluni uksumi ellaliurcuutet nancunailuciatnek, arenqiallugtellriani wall’u ayuquciirutellriani arulairesqelluki, pirtungutellriani qanikcarmi uqicaramek, ayarum anirtuutngucianek, pirciqan kanarvikneret aarnarquciatnek, qengarugmi-llu uqicaramek.",
                "Talks about the importance of rain gear in winter, to stop when in and accident or when lost, sheltering in snow during a blizzard, how a staff will save your life, how dangerous depressions are during blizzards, and sheltering in the side of a snowbank."
            ],
            "64": [
                "09:07",
                "Qalarrluni alerquutet cakaarnarqenriluciatnek, iliini kaitullermeggnek, unangkengamegteggun kiingitgun yuutullermeggnek, tememegteggun pinillermeggnek, naklegtallermeggnek, akusrarcaram piitnarqucianek, umyuartulriit-llu elluarrluteng eglertelauciatnek.",
                "Talks about how we shouldn’t ignore traditional instructions, how they sometimes went hungry, how they survived off of what they subsisted off of, how strong their bodies were, how compassionate people were, how mischief leads to need, and how sensible people go through life well."
            ],
            "81": [
                "11:56",
                "Qalarrluni caqlam iinruucianek, igyariqellriit-llu tamatumek iirulauciatnek.",
                "Talks about how caqlaq [rosewort] is medicinal, and how it’s used for sore throats."
            ],
            "98": [
                "14:05",
                "Qalarrluni pakissaagyaramek, irr’inarqelrianek pakikengelrianek, yugnikek’ngaminek-llu ciissinek pakikengllermek.",
                "Talks about gathering from vole caches, strange finds in vole caches, and her friend finding bugs in a vole cache."
            ],
            "116": [
                "16:15",
                "Qanemciluni qetunraminek keggumallermini naumalrianek kevirraarluki unuaquani mamllermek.",
                "Talks about her son stuffing his bite punctures with a plant and how it was healed the next day."
            ],
            "127": [
                "17:57",
                "Qalarrluni yurrluut nunakenrilkemeggni nallunritniluki, ilani naklekesqelluki, ayagyuat-llu angayuqateng niisngasqelluki.",
                "Talks about how disobedient people are widely known, to be compassionate to everyone, and for youth to listen to their parents."
            ],
            "139": [
                "19:56",
                "Qanemciluni naryalngunarqellriartangqerraqan qengateng uqumek mingutullermeggnek, uqum-llu iinruucianek.",
                "Talks about applying seal oil on their noses when there’s strong odors, and how seal oil is medicinal."
            ],
            "151": [
                "21:54",
                "Qalarrluni taangam assiilucianek, kuingirrluum-llu assiilucianek.",
                "Talks about how detrimental alcohol is, and how detrimental marijuana is."
            ],
            "165": [
                "23:51",
                "Qanemciluni qanikcaam aciani epsarpiallermeggnek, qanikcaam acian epsalngunarqucianek, pirciqan ilutulrianun uqitesqevkenaki, tekitarkaunrilngurni utetmun kapuarciluteng qavaasqelluki, apertunriaceteng-llu qaneryaraq nalluyagutengniluki.",
                "Talks about how almost suffocated under snow, how being under snow is suffocating, not to shelter in hollows during a blizzard, marking the direction toward home if you have to stop for the night, and how wisdom is fading because they don’t talk about it anymore."
            ],
            "184": [
                "27:11",
                "Qanemciluni nanlengraata ilakucimeggnek qanrucimatullermeggnek, maa-i ilakuciiruyuciatnek, ilakuyuciirucameng-llu nakukut’nguciatnek.",
                "Talks about how they were told of their extended familes all over, how people don’t know their families anymore, and how people are fighting because they don’t know how they’re related."
            ],
            "200": [
                "29:59",
                "Qalarrluni Kass’artarnek aklunguciatnek, nakukut’nguciatnek, yullret-llu maa-i-tun ayuqellrunriluciatnek.",
                "Talks about having more Western possessions, people starting to fight, and how different people were in the past."
            ],
            "212": [
                "32:08",
                "Qanemciluni qanikcarpatullranek, urugnariaqami merpayuiruyucianek, kuiget cikuit mamtuyuiruyuciatnek, qerrulrianek niicuitellermeggnek, ciunganitun nenglliyuilucianek, aklut-llu maqarqeńanriuciatnek.",
                "Talks about how much snow there used to be, how meltoff isn’t as much as it used to be, river ice not getting thich anymore, how people freezing to death were rare, how it’s not as cold as before, and how clothes aren’t as warm anymore."
            ],
            "225": [
                "34:09",
                "Qanemciluni pitarkat mikutullratnek, yuilquq-llu nepaunani yaqulelitullranek.",
                "Talks about how plentiful animals used to be, and how the wilderness was peaceful and filled with birds."
            ],
            "240": [
                "36:50",
                "Qanemciluni aklumeggnek uksillerkameggnun ayaucitullermeggnek, tekicameng enepialitullermeggnek, ilakuralriit [family] qavcin enelgutketullermeggnek, enelgutkellriit-llu ataucimek neqautengqetullermeggnek.",
                "Talks about traveling to winter camps with their things, building sod houses when they arrive, how several families lived in a single house, and how each household compiled their food."
            ],
            "263": [
                "40:17",
                "Qanemciluni yaqulecuarcurluteng elitnaullermeggnek, yaqulecuaraat meqtarluki elitnaullratnek, neqkaurtarkat qigciktullermeggnek, yaqulecuaraat pissurnanriiceteng catairuyuciatnek, yaqulecuartameng-llu nakaculiyaraitnek [kinercirluki].",
                "Talks about hunting small birds for practice, plucking small birds’ feathers to practice, how much they respected food sources, how small birds are disappearing since they don’t hunt them anymore, and how they would hang small birds to dry [nakaculiluki]."
            ],
            "282": [
                "43:03",
                "Qanemciluni up’nerkarpak neqsurnatkameggnun yaqulegturatullermeggnek, nangyuitellratnek tau͡gaam allamiaquaqan ikgetqetaatullratnek, neqsurnami Akula yugtairulluni Kusquqvagmuun upagluteng, kencikngaceteng amllerrlainalallratnek, neq’litullranek-llu.",
                "Talks about how they ate birds all spring until fishing season, how populations weren’t endangered but fluctuated, how the Akula region emptied to the Kuskokwim for fishing, how reverence made all animals plentiful, and how many fish there used to be."
            ],
            "299": [
                "45:50",
                "Qalarrluni cetuarcuraqata inerquutellermeggnek, pissurnanriiceteng nanguciatnek, maa-i-llarnek imumillarnek-llu unguvalriit kellucaraitnek, allrakumi-llu neqketukaitnek.",
                "Talks about admonishments during beluga hunting season, how they depleted since they’re not hunted, modern versus traditional game management, and rotating food sources."
            ],
            "313": [
                "48:17",
                "Qanemciluni qimugteminek camek elpekellriamek, iternerkun aliurtullerminek, his dogs supernatural sensitivity like all dogs, upluni-llu qimallermeggnek.",
                "Talks about his dog sensing a supernatural presence, a supernatural fog coming in, qimugteminek pilaucimegcetun elpegtallranek, and getting ready and escaping."
            ],
            "346": [
                "52:43",
                "Qanemciluni apa’urlumeng alerquutaitnek qanruyutaitnek-llu, qertulrianek nuna elitesqelluku, ella assiiruskan anirtuutekciqniluku, cacetulria arenqiallugtellerkaminun tekitaatucianek, aiparluni-llu pellaallermegnek.",
                "Talks about their grandfathers instructions and wisdom, memorizing the land from vantage point, how that will save one when the weather turns bad, how overconfidence leads to misfortune, and getting lost with a companion."
            ],
            "368": [
                "56:02",
                "Qalarrluni kiimelnge’rmi yuilqumi anagyugngacianek, teq’ukun urumayaramek, pellaallermini teq’umikun anagyugngallerminek, yuilqumi arenqiallugingalria teq’umek mer’esqelluku wall’u mertesqelluku, qerruqatalriit-llu puqlamun pisqevkenaki.",
                "Talks about how one can survive in the wilderness alone, keeping warm with urine, how he survived with urine when he was lost, to give urine to someone who has been lost in the wilderness, and not to warm up people who are hypothermic."
            ]
        },
        "elderTags": [
            "23.56"
        ],
        "tags": [
            "2.2.27",
            "2.1.2",
            "3.4",
            "3.5.1",
            "5.2",
            "5.4.4",
            "8.5.1",
            "9.1.2",
            "9.2",
            "9.5.3",
            "9.6",
            "9.8",
            "10.3.1",
            "11.7",
            "11.8.1",
            "11.8.2",
            "11.8.3",
            "11.8.4",
            "11.9.1",
            "11.9.2",
            "13.3.1",
            "16.1.1",
            "16.3",
            "17.1.1",
            "19.3.2.1",
            "19.3.5",
            "19.5.2",
            "19.5.3",
            "19.6.1",
            "19.6.6",
            "19.12",
            "19.13",
            "21.4",
            "22.5",
            "22.7",
            "22.12.2.1",
            "22.12.2.2",
            "22.12.2.3",
            "24.3"
        ]
    },
    "cpb-aacip-127-7634tx89.h264": {
        "videoID": "cpb-aacip-127-7634tx89.h264",
        "title": "Narullgiar Elena Nick - # 74",
        "time": "22:16",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qanemciluni Kass’artarnek piinateng yuutullermeggnek, Kass’artangucim-llu ilakucaramteńun agtuumacianek.",
                "Talks about how they lived with no Western things in the past, and how Western contact has affected familial relationships."
            ],
            "10": [
                "00:49",
                "Qalarrluni ilakellriit ayuquciata cimillranek, aanateng murilkurluki ayuqeliyugngaciatnek, elitnaurvigteggun caarkateng elicuiruyuciatnek, irniami iliit elitnauvsiaryarturraarluni taq’illranek enemi-llu cayuilucianek, alla-llu elitnauvsiaryarturpek’nani enemi ikayuutetucianek.",
                "Talks about how family dynamics have changed, how children can learn to do things from their mothers, how schools are heavily impacting traditional learning, how one of her children dropped out of college and doesn’t help out around the house, and how another didn’t go to college but helped out around the house."
            ],
            "41": [
                "04:19",
                "Qalarrluni tangvagluteng elicugngaciatnek, Cakayiinkugni uitatullerminek, elitnaullermini elitenritlerminek, ayagyuange’rmi uingellerminek, taqnerurtenqegcaarluteng-llu kassuutelangniluki.",
                "Talks about learning through observation, staying with Cakayak and his wife, how little she learned at school, getting married at a young age, and how they now get married later."
            ],
            "67": [
                "06:43",
                "Qanemciluni kassuutesqumatullermeggnek, angayuqrita yuvrirluki irniateng aiparkiutullratnek, angutet ilaita cayuiluciatnek, aipani-llu ayagyuarlutek kassuutellermegnek, uiminek ellaitnun pistekangarkaucimeggnek, allamek kenkellruniluni, uikani-llu takaqellruniluku.",
                "Talks about how they were expected to marry, how parents examined and chose spouses for their children, how some men are lazy, how she and her husband married young, how her husband would provide for them, being in love with another, and being intimidated by her fiancee."
            ],
            "90": [
                "09:22",
                "Qanemciluni anngani piunriqan uikaminek pistekangqerrarkaucimeggnek, aiparkiurani angerluku, aipaqeqerraallermegnek, uini unilluku ilaminun utertetullerminek, uiminek-llu cikiuteminek.",
                "Talks about her husband being the provider when her brother passes away, agreeing to marry, their early marriage, staying with her family instead of husband, and her bridewealth."
            ],
            "129": [
                "12:58",
                "Qanemciluni uksuarmi tegullratnek, uimi nengaugitellranek, uini kenegyagutellerminek, yagirayaram-llu inerquutngucianek.",
                "Talks about getting married in the fall, her husband moving to her family’s village, waming up to her husband, and not to raise hands against each other."
            ],
            "152": [
                "15:13",
                "Qanemciluni qingaqerraallerminek, Nick-am [uinga] Qaneryaranek naaquratullranek calilgutullranek-llu, ayagyuarluni Nick-am agayulirteńgurtellranek, qulngunrita’arnek irniangellermegnek, kipusvingellranek, taangartuyuitellermegnek, kipusvingumariluku-llu Anchorage-aartelallermegnek.",
                "Talks about her first pregnancy, Nick [her husband] always reading the Bible and working hard, Nick becoming a pastor at a young age, having nine children, opening up a trading post, how they never drank alcohol, and traveling to Anchorage after getting his trading post."
            ],
            "194": [
                "19:59",
                "Qanemciluni melqulegglainarkun kipusvimikun-llu Nick-am akingetullranek, angayuqrita elitnauristeńguciatnek, angayuqamegcetun elliryugngaciatnek, irniami anngaatnun aulukumacimeggnek, eneminek kagiuratullerminek, eruriyaramek-llu keniryaramek-llu.",
                "Talks about how Nick earned money only through fur hunting and his trading post, how parents are teachers, how children can become like their parents, how her oldest son takes care of them, how she tries to keep the home clean, and washing dishes and cooking."
            ]
        },
        "elderTags": [
            "23.58"
        ],
        "tags": [
            "2.2.35",
            "9.4",
            "9.6",
            "14.1.1",
            "14.2.1",
            "14.3.1",
            "14.5",
            "14.6.1",
            "16.1",
            "16.4",
            "19.6.7",
            "21.4"
        ]
    },
    "cpb-aacip-127-76f1vspw.h264": {
        "videoID": "cpb-aacip-127-76f1vspw.h264",
        "title": "Nauciralrea Joseph Friday - # 75",
        "time": "16:55",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:01",
                "Qanemciuq angayuqaagminun qasgimun cingumallerminek, qacarneret atritnek, angutet qasgimiungullratnek, angukara’urlurnek angutnek-llu qaneryaramek egelracilrianek, quyigingnaqevkenateng, tegganret-llu ikayuusqelluki.",
                "Talks about his parents encouraging him to go to the community house, terms for walls, how the men lived in the community house, how the elders and men spoke of traditional wisdom, not to be proud, and to help elders."
            ],
            "31": [
                "04:03",
                "Qanemciluni tegganret qaneryaraitnek maligtaquqapigtelallratnek, ilait qaneryaranek niicuiluciatnek, qanrucunailnguut unguvamayuiluciatnek, qaneryaram-llu maligtaqustiin yuunertucianek.",
                "Talks about how they completely followed the elders’ wisdom, how some people don’t heed wisdom, how disobedient people don’t live long, and how those who adhere to wisdom live long."
            ],
            "43": [
                "06:12",
                "Qanemciuni Qissunami yuurtellerminek, angllurraarluni ikamraryaurtellerminek, nunat ilaitnun ayaasqumanritlerminek, kiutaaresqevkenani inerquumallerminek, arcayaguskuniki-llu pitatni kiusqelluki.",
                "Talks about being born in Qissunaq, dog mushing after being baptized, being told to avoid certain villages, not to talk back, and to talk back to peers when they are incessantly aggravating."
            ],
            "61": [
                "08:45",
                "Qanemciluni ciuliateng pirpaktullruniluki, maa-i-llarnek enengellranek, nevumek muragnek evegnek-llu enepianek, arnat uitayuitellratnek, enemeggni tupiganek curungqetullratnek, enelgutkellriit-llu tupiganek caputengqellratnek.",
                "Talks about valuing their elders, the advent of modern houses, traditional houses made of sod, wood, and grass, how women were not sedentary, having grass mats in the house, and grass partitions between members of the house."
            ],
            "76": [
                "10:43",
                "Qanemciluni tegganernek tan’gurrarnun ciunerkiulrianek, qasgimi qaneryaraita ayuqaitnek maurluita eneni qaneryariutullratnek, Cupiunrilngurnek avungeciqniluki tegganret ciunerkiullratnek, Kass’at amlleriarkauciqnillratnek, arenqiallugutet amllericiqnillratnek, yuullgutkenrilkeput-llu inglulingnaqesqelluki.",
                "Talks about elders speaking of the future for the boys, grandmothers teaching the same wisdom to girls in the houses, elders’ prediction that non-Cup’ik people would come, how Westerners would increase, how there would be more misfortune, and working together with different peoples."
            ],
            "98": [
                "14:00",
                "Qalarrluni Yugnun nunam pikucianek, cimingraata Yuut ikayuulluteng pisqelluki, kinguverminun qaneryaranek kinguvatullerminek, elitnaurvigteng teguluku ataniuryaurtellermeggnek, tutgaraminek-llu elicarangqerruciminek.",
                "Talks about Yup’ik land sovriegnty, Yup’ik solidarity despite change, how he would pass on wisdom to the next generations, taking over governence over their school, and teaching one of his grandchildren."
            ]
        },
        "elderTags": [
            "23.59"
        ],
        "tags": [
            "2.2.18",
            "17.5",
            "6.3.8",
            "8.1.4",
            "9.6",
            "16.1.1.1",
            "16.2",
            "16.4",
            "17.5",
            "19.3.4.1",
            "19.5.4",
            "19.11",
            "19.13.11",
            "19.13.12",
            "19.15",
            "21.2"
        ]
    },
    "cpb-aacip-127-773txm5v.h264": {
        "videoID": "cpb-aacip-127-773txm5v.h264",
        "title": "Nauyaq Anna Andrew - # 76",
        "time": "22:19",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:01",
                "Imirissuutet naspaagait.",
                "Audio testing."
            ],
            "10": [
                "00:24",
                "Qanemciuq Quunermi Tagyaram iluani ellangellerminek, ellami kiimeng yug’uyuketullerminek, nunameggnek Qinarmek angain tekitetullratnek, aataminek Ciutmek Kass’artarnek tekiutetullranek, atameng Ekvicuarmun ayatullranek, aatani-llu maligcaurtellerminek.",
                "Talks about growing up in Quuneq along Tagyaraq, thinking they were alone in the world, how her uncles would return form their home village Qinaq, her father returning with Western things from Ciun, how their father would travel to Eek, and starting to travel with her father."
            ],
            "35": [
                "03:12",
                "Qanemciluni neqlillermeggni Cuukvalegmiuni ellangenqegcaallerminek, neqlillerni kiaguuryuktullerminek, kinguqlingllermegnek, Qurrelvagmi uksuitullermeggnek, Qukaqlircarametetullermeggnek, 1951-aami Tuntutuliarni elitnaungellerminek, ayagayuirutlermeggnek-llu.",
                "Talks about growing up in their fish camp Cuukvalegmiut, how she thought it was always summer in fish camp, getting a younger sibling, spending winter camp in Qurrelvak, staying in Qukaqlircaraq, starting school in Tuntutuliak in 1951, and how they stopped going to camps."
            ],
            "54": [
                "05:11",
                "Qanemciluni caranglluut carrirturaasqumallermegnek, cavkenatek unguvamayuglutek cauraasqumallermegnek, essuilnguut tanqitullratnek naulluuyuunateng-llu, naulluulriit pelqevkenaki kenugtelaasqelluki, kevgiulriit-llu menuurcuiluciatnek.",
                "Talks about being told to always clean debris, to always do chores to live long and healthy lives, how spiritually clean people would radiate light and wouldn’t get sick, to take care of the sick without aversion, and how those who serve do not becom impure."
            ],
            "75": [
                "07:40",
                "Qalarrluni caarrluum yugmun nepucuilucianek, qantat erurturaasqelluki, neqallret tutmarngalngurmun ciqitesqelluki, qanruyun amlleq nalluyagutengniluku, qanruyutet eneqaqercetaaresqelluki, yuut-llu qaskuit ayuquciit-llu ayuqenritniluki.",
                "Talks about how dirt doesn’t stick to a person, to always wash bowls, dispose of scraps where they won’t be stepped on, how a lot of wisdom has been forgotten, to try to have people remember wisdom, and how people’s appearance and nature are different."
            ],
            "114": [
                "12:31",
                "Qalarrluni yuut assirluki pisqelluki, yuut umyugait ayuqenriluciatnek, niicugniaqami aptelallerminek ciin, ilaita qaskuit ayuquciit-llu ayuqenriluciat umyuaqesqelluku, kiularasqevkenaki, umyuarteng quyigisqevkenaku, qaillun-llu ayuqeng’e’rmeng ayuqengraata-llu ilaliuresqelluki.",
                "Talks about treating people well, how people’s mindsets are different, asking why when instructed, to remember that people’s appearance and nature may be different, not to talk back, not to be proud, and to keep socializing no matter what you or they are like."
            ],
            "135": [
                "14:44",
                "Qanemciluni an’aqamek Ellam qukaa tangrresqumallermegnek, ella cuqequraasqelluku, akerteḿek sass’angqetullermeggnek, takarnarqengraata-llu qanrucimatullermeggnek.",
                "Talks about looking at the middle of the Universe when they go out, to always survey the weather, measuring time with the sun, and how they were taught uncomfortable subjects."
            ],
            "159": [
                "17:32",
                "Qalarrluni Yuut tamarmeng cakviutuciatnek, umyuamegteggun cakviulriit umyuaqesqelluki ikayurluki-llu, ilateng-llu umyuaquraasqelluki.",
                "Talks about how every person struggles, to remember and support those who struggle with mental health, and to keep each other in mind."
            ]
        },
        "elderTags": [
            "23.60"
        ],
        "tags": [
            "2.2.30",
            "3.2",
            "3.12.1",
            "8.2",
            "9.8",
            "9.9",
            "10.12.1",
            "16.4",
            "16.5",
            "19.5.5",
            "19.6.5.1",
            "19.6.8.1",
            "19.6.9",
            "19.7.2",
            "19.11.2",
            "19.13.12",
            "21.6",
            "22.6.1",
            "22.8"
        ]
    },
    "cpb-aacip-127-784j17vw.h264": {
        "videoID": "cpb-aacip-127-784j17vw.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip - # 77",
        "time": "40:01",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History, Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:11",
                "Qanemciuq Qinarmiuni ellangellerminek, Qaneryarangeksaitellranek agayumayaramek-llu, kinguqlia tuqullrani ellangellerminek, Kass’at enurnallratnek, Kass’at aliketullruniluki, qasgimun pilangellerminek, maurluan-llu aiparkami apa’urlua yukainaunritnillranek.",
                "Talks about growing up in Qinarmiut, how there was no Bible or Christianity yet, early memories of his sibling dying, how few Caucasians there were, how they were scared of Caucasians, getting old enough to go to the community house, and his grandmother’s fantastical tales of his future wife’s grandfather."
            ],
            "30": [
                "03:19",
                "Qalarrluni tan’gaurluut yaquleyagartaqarraaritnek nakaculitullratnek kalukautetullratnek-llu, qangqiirteqerraalerminek, ayuqenrilngurnek taluyatullermeggnek, akutapiamek, qangqiirteqerraallni Qinarmi kalukautellermeggnek, Kassiyum-llu iqluklitellranek.",
                "Talks about drying boys’ first catches of little birds and holding a celebratory feast, catching his first ptarmigan, how they would use fish traps for various fish, traditional akutaq, celebrating his first ptarmigan in Qinaq, and the end of the festival"
            ],
            "64": [
                "07:11",
                "Qanemciluni qasgimiungurtellerminek, qavarnariaqan inarrviirutetullermeggnek, qanerturalrianun tupatullerminek, maqirraarluteng qanerturalrianek, tegganemeggnek-llu ayagyuallermeggni ayuqucirtuutnek maligtaquqapigtetullratnek.",
                "Talks about starting to sleep in the community house, how there was no room left to sleep in the community house, waking up to instruction, instruction after fire baths, how their elders closely followed instructions when they were young, and split spruce at the door for instruction."
            ],
            "83": [
                "09:29",
                "Qanemciluni ayuqucirturilriani cigyagmek, qanerturainanratni tan’gaurlurnek anelrianek, arnat eneni ayuqucirturyaraitnek, qanerturalriani tupiganek caniqerrilitnek, qanrinanratni-llu anelrianek.",
                "Talks about split spruce blocking the door during instruction, boys walking out during instruction, women’s instruction in homes, woven grass belts blocking door during instruction, and those who go out during instruction."
            ],
            "128": [
                "14:04",
                "Qalarrluni uingarkaulriit qanruyutaitnek, kaignami nulirqellriit ayuquciita nasvaumalaucianek, maa-i kumivigteggun qemagcitulaucimeggnek, allamiaquaqan Kassiyutullermeggnek, angutet aturaqata arnat nerka’rnek itruciluteng yuratullratnek, yurarraarluteng kalukatullermeggnek, ayuqenrilngurnek-llu Yugtarnek.",
                "Talks about advice when getting a husband, how couples’ true natures come out during famine, modern storage with freezers, holding yearly Kassiyuq festivals, women brining in ceremonial bowls of food and dancing while men sing, feasting after dancing, and different types of Yup’ik food."
            ],
            "178": [
                "18:59",
                "Qanemciluni Itruka’armek, arnaunrek angutngunrem-llu Itruka’ar yuratullratnek, Kevgimek yuraryarainek-llu, Kevgiraqameng cikiqengtullermeggnek, Kass’artangengan Kass’artarnek cikiqengtullermeggnek, yuralriani-llu aturpatullerminek.",
                "Talks about Itruka’ar [Inviting-In Feast], two women and a man dancing for a ceremonial Itruka’ar, the Messenger Feast and dances, giving gifts during the Messenger Feast, Western gifts after contact, and singing for the festival."
            ],
            "210": [
                "22:16",
                "Qanemciluni angalkunek tuunriyaraitnek-llu, umyuarrliqenrilnguut ikayulallratnek umyuarrliqellriit-llu yugtelallratnek, angalkut ikayuriaqameng pisqutaitnek, cauyarluteng tuunrilrianek, arcassiyaalriit angalkut tuqutelallratnek, akinauresqevkenaki-llu.",
                "Talks about shamans and their rituals, good shamans healing people and bad shamans tormenting them, shamans’ commands when healing, shamanistic rituals using drums, executing very bad shamans, and never to retaliate."
            ],
            "246": [
                "26:42",
                "Qalarrluni ircenrrarnek, aataminek ircenrrarmek tangllermek, Tuntuankuk Qeng’angiaraam-llu anglicartegkegnek ircenrrarnek tangellragnek, Agartessaagam qagatellra sevtellratnek, manialkuni-llu Sugtulimi angyaqainaunrilngurmek yukainaunrilngurmek-llu.",
                "Talks about legendary little people, his father seeing a legendary little person, Tuntuaq’s and Qeng’angiar’s parents seeing legendary little people, draining the lake source of Agartessaagaq, and a strange boat and person on the area of jagged ice called Sugtuli."
            ],
            "288": [
                "31:39",
                "Qanemciluni ircenrrartarnek elakengtullratnek, ircenrrartaat tumaumayuiluciatnek, nasaurluut ircenrrartarnek taluyanek nataquskuneng qetunrangarkauciatnek, ircenrraat-llu cautaita ciunerkiutuciatnek.",
                "Talks about digging and finding things from little people, how the legendary little people’s things wouldn’t leave traces for long, how girls who find little people’s fish traps will bear a son someday, and how little people’s things portend the future."
            ],
            "303": [
                "33:21",
                "Qanemciluni quyatmek Qaluvialleraam yuarutiinek Kevgillermeggni, quyatengqerrami-llu atuqatauciminek.",
                "Talks about Qaluvialler’s song of gratitude during a Messenger Feast, and how he is going to sing the song out of gratitude."
            ],
            "326": [
                "35:44",
                "Aturtuq.",
                "Singing."
            ],
            "334": [
                "36:26",
                "Qanemciluni anqarautet yuarutaita cukalauciatnek, angayalriani yugtautait ataucitaarluki umyuaqluki eyarluteng pilauciatnek, qavcin Apanuugpak ilakluku Kusquqvagmiumek tangerqengellratnek anguyagtarmek eyalegmek, quyaluteng-llu nangniurluteng.",
                "Talks about how victory songs were fast, how each kill during war earned a tattoo, how some people including Apanuugpak came across a man from the Kuskokwim with a war tattoo, and closing thanks."
            ]
        },
        "elderTags": [
            "23.53"
        ],
        "tags": [
            "2.2.31",
            "2.2.30",
            "8.1.3",
            "8.4.3",
            "9.3.2",
            "10.3.1",
            "10.5.1",
            "10.9.3",
            "13.3.6",
            "15.3.1.1",
            "16.2",
            "19.3.6",
            "19.3.7",
            "19.8.1",
            "19.16.2",
            "20.1.1",
            "20.2.2.1",
            "20.2.4.1",
            "20.2.5",
            "20.7",
            "20.8",
            "21.2.1"
        ]
    },
    "cpb-aacip-127-79h44thw.h264": {
        "videoID": "cpb-aacip-127-79h44thw.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm - # 78",
        "time": "22:21",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [
                "Mary Worm [Kangirnaq -- Kongigonak"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [
                "Kakianaq [Adolph Lewis, Kuigilnguq -- Kwigillingok]"
            ],
            "Role 2:": [
                "Interviewer"
            ]
        },
        "summary": {
            "1": [
                "00:03",
                "Qanemciuq qanernailngurnek angalkunek ikayuqengtulrianek, angalkunek yugnek assirivkatullernek, angalkut meci’irviitellratnek, angalkut-llu umyuarrliquciitnek utercecaraitnek-llu.",
                "Talks about good shamans who help people, shamans healing people, how no one could doubt the shamans’ power, and shamans’ malicious force and deflection."
            ],
            "26": [
                "02:50",
                "Qanemciluni nunurnganateng qalartetullernek, qalarutellriani qanrit murilkelaasqelluki, ayainanermini qanruyutet elitaqaqniluki, qaneryarat-llu pulengtetullratnek.",
                "Talks about being instructed wisdom as if scolding, to watch their mouths when instructed, recognizing wisdom as she goes forward through life, and how they repeatedly told wisdom."
            ],
            "51": [
                "05:59",
                "Qalarrluni Yugtaat agayuviim-llu qaneryaraitnek allakauniluki umyuarteqellrianek, qanrutetgun calriit yuut-llu elitaq’lauciminek, qalarucimalriani-llu nasaurluullguut anelriit qanrucimalriamun tekitarkauciatnek.",
                "Talks about traditional wisdom vs the Bible, recognizing situations and people talked about through wisdom, and how girls walking out during instruction will find out the consequences."
            ],
            "71": [
                "09:04",
                "Qanemciluni qaneryarat aturtaita yuunertutullratnek, ak’allarapiat nugtartaqaceteng enrita enemeggnek yuutullratnek, ak’allarapiat yuuniarayuitellratnek, maurlumeggnek-llu au͡g’utun nugtatertullermeggnek.",
                "Talks about how those who adhered to wisdom lived long, how they would carry the very old and their bones would pop out of socket, how the old people wouldn’t complain of bodily pain, and moving her very old grandmother as above."
            ],
            "101": [
                "12:35",
                "Qanemciluni maurlumeng qanemciinek, angalkumek uingellranek caksuilkeminek, Cakcaarmiuni Qaluyaat nuniitni uinguangellranek, payuggnginanermini uinguani tangerrsukellranek, uterrluni callerminek qanrutellranek.",
                "Talks about her grandmother’s stories, how she married a shaman that she ignored, how she took a lover from Cakcaarmiut around Nelson Island, how she thought she saw her lover when giving gifts of foods, and going back home to explain what happened."
            ],
            "149": [
                "18:44",
                "Qanemciluni maurlumi callerkai tekitestaartiin pitullranek, An’arissuutem tuunritellranek, tuunrisnginanraku uinguaran kalvagyaramek alaillranek, uinguaranun angalkum arnaruamek ayagcecillranek angutnguamek-llu ilalircetellranek, tuunriqaartellruuni-llu assiriyartullranek.",
                "Talks about how her lover would do her chores for her, how An’arissuun performed a shamanic ritual on her, her lover appearing from the tunnel entrance during the ritual, the shaman sending a decoy woman to distract her lover and a decoy man to stay with her, and how she got better after the ritual."
            ]
        },
        "elderTags": [
            "23.16"
        ],
        "tags": [
            "2.2.28",
            "8.1",
            "8.4",
            "19.5.4.1"
        ]
    },
    "cpb-aacip-127-805x6mnx.h264": {
        "videoID": "cpb-aacip-127-805x6mnx.h264",
        "title": "Urutaq Lucy Beaver - # 79",
        "time": "18:30",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History, Cultural"
            ],
            "Quality:": [
                "Genre 4:"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:06",
                "Qanemciluni panimi aumikun apqucianek, chickweed-anek, atsaruanek, panimi utumarillranek, Anchorage-aamu emucartulallranek, arulaiqerluteng-llu.",
                "Talks about an ailment in her daughter’s blood, chickweed, false chamomiles, her daughter recovering, how she was flown to Anchorage for treatment, and stopping for a break"
            ],
            "51": [
                "04:53",
                "Qalarrluni Tabasco-lriani aunranriqertetuciatnek, ciuciqellriit uqumek kucilauciminek, ciuciqellriani atsaruanek, qanmegteggun callartellriani napat cuyaqsuyagaita amiitnek, mumiggluki-llu.",
                "Talks about how Tabasco stops bleeding, seal oil for earaches, false chamomiles for earaches, tree bark for sores in the mouth, and translation."
            ],
            "120": [
                "11:27",
                "Qanemciluni allamiaquaqan uqukun iluteng carrilaucimeggnek, irniani-llu tuatnalaucimeggnek, uqumun anarceqaarluteng neqem imarkuaranek yuurqatucimeggnek, iluminek anallmi ayuquciitnek, mumiggluki-llu.",
                "Talks about clearing out the digestive tract with seal oil once a year, carrying this on with her children, drinking fish broth after defecating from seal oil, the kind of feces that were cleared from her tract, and translation."
            ]
        },
        "elderTags": [
            "23.82"
        ],
        "tags": [
            "2.2.38",
            "6",
            "13",
            "22.12.1.1",
            "22.12.2.3",
            "22.12.2.4"
        ]
    },
    "cpb-aacip-127-816m99hb.h264": {
        "videoID": "cpb-aacip-127-816m99hb.h264",
        "title": "Maqista Ac'urunaq Joshua Phillip - # 80",
        "time": "1:02:05",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Compilation"
            ],
            "Genre 2:": [
                "Personal History, Cultural"
            ],
            "Quality:": [
                "Genre 4:"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Aqumgaciq John Active",
                "Kakianeq Adolph Lewis"
            ]
        },
        "summary": {
            "1": [
                "00:14",
                "Qanemciuq qasgimi anglillerminek, aliimatmeggnek akicitullermeggnek, apa’aurluminun anglicaumallerminek, qavaumavkayuitellerminek, man’a-llu engelkarrluku qavaumayuiluciminek.",
                "Talks about growing up in the community house, how they used their mittens as pillows, being raised by his grandfather, not being allowed to sleep long, and keeping the habit of not sleeping long."
            ],
            "24": [
                "02:46",
                "Qalarrluni ciulirneret qanyuiruciatnek, nuna meq-llu kencikesqumatullermeggnek, “qantamitun pitarrluku” qigcikiyaramek kangianek-llu, tan’gaurluq aipangvailegmi nasaurlurmek aipirtuasqevkenaku, wangkutnek navguacimteńek, taangamek, ciulirnemeggnek-llu qanqauquratullernek.",
                "Talks about how elders don’t instruct anymore, how they were told to revere the land and water, to “respect as much as one’s own bowl” and what it means, for boys not to be with girls before marrying, how people are destroying themselves, alcohol abuse, and how elders used to always give instruction"
            ],
            "51": [
                "05:59",
                "Qanemciluni Qunuitmek Qinarmiumek Tuntutularmiungurtellermek, 1945-aami Tuntutuliarmiungurtellerminek, quyateminek-llu aturluni.",
                "Talks about Qunuin from Qinaq who moved to Tuntutuliak, moving to Tuntutuliak in 1945, and sings a song of gratitude."
            ],
            "67": [
                "07:59",
                "Qanemciluni Qaneryaraunateng agayumalriarunateng-llu Qinarmiuni ellangellerminek, kinguqliminun anernerillermun ellangellerminek, Kass’at enurnallratnek, ataucimek Kass’ameggnek Parumek, elitnaurviitellermeggnek, qasgimi cakirkaminek Akagtamek alingetullerminek, maurluan-llu Akagtaq yugtutuniluku yukainaunritniluku-llu qanrutetullranek.",
                "Talks about growing up in Qinarmiut with no Bible or Christians, first memories of their younger sibling dying, how few Caucasians there were, one resident Caucasian named Paru, how they didn’t have a school, how he was afraid of his future father-in-law Akagtaq in the community house, and his grandma saying Akagtaq was a cannibal and had supernatural powers."
            ],
            "91": [
                "11:15",
                "Qanemciluni yaqulegteqerraarutait nakaculitullratnek, pitqerraalria kalukautetullermeggnek, qangqiirteqerrallerminek, maurluan nakaculillranek, aatiin taluyaanek cangtameggnek-llu, pitqerraarami kalukaucimallerminek, tangviarrlugnek-llu akutanek.",
                "Talks about first bird catches being threaded through the wings and dried, celebrating someone’s first catch, catching his first ptarmigan, his grandmother drying it, his father’s fish trap and the fish they caught, celebrating his first catch, and traditional Yup’ik ice cream with seal blubber."
            ],
            "124": [
                "15:24",
                "Qanemciluni qasgimi inarrviirulluteng qavalangllerminek, qanerturalriamun tupatullerminek, maqirraarluteng qanerturatullratnek, nuliangarkaulrianun-llu qaneryarait.",
                "Talks about starting to sleep in the community house and how little room there was, how he’d wake up to instruction, instruction after fire baths, and instruction about getting a wife."
            ],
            "139": [
                "17:39",
                "Qanemciluni ciulirneri ayagyuallermeggni ayuqucirtuun pinirluku atullratnek, qanrucilriani amiik cigyagmek cani’irrviktullratnek, qanrucimalriani-llu tan’gaurluum ik’ikra cigyak asemlluku anlaucianek.",
                "Talks about how strongly they practiced traditional instruction when the elders of his time were young, split spruce to block the door during instruction, and how improper boys would break the spruce and go out during instruction."
            ],
            "153": [
                "19:30",
                "Qanemciluni arnassagarnek eneni nasaurlurnek qalarucilrianek, uingekuneng auluklerkaitnek, tupiganek naqugutnek caniqerrilitnek, ataucimi enemi qavcinek ilakellrianek yungqetullratnek, qanrucimalriani nasaurluum anelriim taquitaanek, enem natainek, qanruyun atunritem ugaani angayuqriutetuciatnek, qanrucimalriani-llu tan’gaurluum anelriim taquitaanek.",
                "Talks about elderly women instructing girls in the houses, how to take care of their future husbands, woven grass belts to block the door, how each house had several families, the fate for a girl who runs out during instruction, parts of a house, how those who don’t adhere to wisdom lose their parents, and the fate for a boy who runs out during instruction."
            ],
            "184": [
                "23:16",
                "Qanemciluni kalukalriani cauyagnek yuulagnek, aatiin allam-llu yualuk cauyatullragnek, arnat neruka’rnek itrulluteng yuraryartutullratnek, arnat naangata Yugtarrlainarnek nertullermeggnek, puyanek-llu.",
                "Talks about two ceremonial drums [yuulak], his father and another drumming them, women coming in to dance with ceremonial bowls of food, eating nothing but Yup’ik food when the women were done, and puya [akutaq with moss soaked in seal oil, and berries]."
            ],
            "211": [
                "26:26",
                "Qanemciluni Itruka’armek, Itruka’armi angalkurtarnek yuarutetangqellranek, angalkunek yuralrianek, unisteḿi yuarucitullranek, Kevgimek, kevgak ayagtellukek kelegyartuusqetullermeggnek, Kevgiqatalriani-llu piyuutaitnek.",
                "Talks about the “Inviting-In Feast” Itruka’ar, shaman songs during Itruka’ar, shamans dancing, his late father composing songs, the Messenger Feast, sending out two messengers for invitations, and requests for Kevgiq."
            ],
            "237": [
                "29:41",
                "Qanemciluni imumi angalkunek atutullratnek, ikayuqengtulunek umyuarrliqellrianek-llu angalkunek, anirtungnaqkait tallimani ernerni uluarayuitellratnek, angalkut piciryarait akusrarutngunritellranek, qasgimi tuunritetullratnek, angalkut-llu naulluutnek nangluki au͡g’atullratnek.",
                "Talks about how prevalent shamans were back then, helpful and malicious shamans, how someone who was going to be saved would not use a knife for five days, how they took shamans seriously, shamanistic rituals in the community house, and shamanistic healing."
            ],
            "257": [
                "32:33",
                "Qalarrluni ayalriani qanikciurutem, cikuliurutem, ayarum-llu alerquutnguciatnek, imarnitnek, ellam cimirpagyugngacianek, pirtungutellerkani umyuaqurluku upingaasqelluku, qengaruk elagluku uqicaramek, murak-llu kapulluku ellvilisqelluku.",
                "Talks about instruction to always travel with shovel, ice pick, and staff, seal gut rain parkas, how the weather can change drastically, to be ready in the winter for a blizzard, digging into a snowbank for shelter, and to stick a pole or staff for ventilation."
            ],
            "276": [
                "35:38",
                "Qanemciluni pissulallerminun tagkunallerminek, nunam uqlangucianek, imumi yullret nuna menuicet’lallratnek, Matthew Beans-aaq tengssuutmek nunam uqlaucianek tangerrsugngacianek, nunam uqlaucianek apertuikunaciminek.",
                "Talks about planning to return to one of his old hunting grounds, pollution, how the people kept the land pristine back then, how Matthew Beans could see the pollution from a plane, and planning to spread the word about the pollution."
            ],
            "304": [
                "39:33",
                "Qalarrluni nuna kencikluku menuicet’lallratnek, mer’et nuna uqlarcecuitellratnek, Ellam Yuan tangvagturaucianek, nunam Agayutmun pikucianek, nuna uqlarcequranritlerkaanek, Kusquqviim uqlaucianek tanglauciminek, neqet cumacitauciatnek, ciuliat taringumallermegteggun inerqutullratnek, uqlangengan-llu unangetukeput nangengniluki.",
                "Talks about how the land was kept pristine out of reverence, how they kept the waters and land from getting polluted, how the Spirit of the Universe is always watching, how the earth belongs to God, a responsibility to keep the land clean, seeing pollution on the Kuskokwim, how fish can’t stand pollution, how the ancestors admonished according to their understanding, and how food sources are depleting due to pollution."
            ],
            "333": [
                "43:25",
                "Qalarrluni nunam menuicequrallerkaanek, neqet naunraat-llu ikegliciatnek, nunam menuitellerkaa allamun ellisqevkenaku, kinguliateng-llu ayuqucirtunrilamegteki nuna tuaten ellircetniluku.",
                "Talks about keeping the land clean, how fish and plants are depleting, not to put the responsibility of cleaning up the land to anyone else, and how hiding wisdom for the next generations caused pollution."
            ],
            "345": [
                "45:35",
                "Qalarrluni nuna menuitesqelluku ayuqucirtuusqelluki, imumi unangerpatullratnek, atuungailnguut kemget caksaraitnek, uqlalriim-llu atawaqertesciigalucianek.",
                "Talks about instructing to keep the land clean, how many animals they used to catch long ago, to properly dispose of unused meat, and how a polluted land can’t be blessed."
            ],
            "361": [
                "48:04",
                "Qanemciluni aipangllerminek, irniateng eyurutesqevkenaki, eyuruskait-llu iqlungarituniluku niicuirulluteng-llu.",
                "Talks about getting married, not to defend children, and how defended children become liars and disobedient."
            ],
            "373": [
                "50:12",
                "Qanemciluni Kass’artangellranek, massiinangenratgun taangakun-llu kanvengellratnek, Mamterillerni taangarvilitullranek, alerquilriani imumitun ayuqenriuciatnek, aarcirtuutet kenekmek kingunengqerrucianek, alerquutet-llu qanruyutet-llu narurtaita iquggliq’lauciatnek.",
                "Talks about Westernization, increased deaths with boat motors and alcohol, how there were many bars in Bethel, how past and modern instruction are different, how warnings come from love, and how those who don’t heed wisdom or warnings do not turn out well."
            ],
            "391": [
                "53:21",
                "Qalarrluni nunam mer’em-llu auluknarquciagnek, nuna meq-llu kencikenriamtekek cairusngiinaucianek, ella enemcetun carrirturaasqelluku, nunam auluklerkaa kitumun allamun ellisqevkenaku, ella aulukesqelluku ayagyuat ayuqucirtuusqelluki, imumi-llu unangerpatullratnek.",
                "Talks about the responsibility to care for the land and water, how things are depleting from not revering the land and water, to keep nature as clean as our houses, not to put the responsibility of taking care of the land on anyone else, to instruct young people to take care of nature, and how many animals they used to catch back then."
            ],
            "417": [
                "56:52",
                "Qalarrluni kemget tamalkuita alerquutnguciatnek, nerngailnguut enret-llu elaucaraitnek wall’u mermun eggluki, nuna uqlarluni atawaqercecimasciigalucianek, nunam carrillerkaan akitucianek, akimek pivkenateng nunam menuitellerkaanek umyuangqetullratnek, nunateng carriuratullruniluki, carriryaram-llu neqkamek unguvamayaramek-llu akqutengqerrucianek.",
                "Talks about how all meat has traditional instructions, to properly dispose of uneaten meat and bones, how the land cannot be blessed when polluted, how expensive it is to clean up pollution, how they used to prioritize keeping the land pristin over money, how they kept their villages clean, and how cleaning up is rewarded with food and long life."
            ],
            "444": [
                "59:56",
                "Qanemciluni arnassagaurtem angukara’urluurtem-llu ugaani ciisqumeggnek ayapetullernek, Picuilnguum qanemcianek, picuileng’e’rmeng-llu carririuratulit picuriyugngaciatnek.",
                "Talks about how people got so old that they had to support themselves on their knees, the story of Picuilnguq [Bad Hunter], and how bad hunters can become great when they continue to clean up."
            ]
        },
        "elderTags": [
            "23.53"
        ],
        "tags": [
            "2.2.31",
            "2.2.30",
            "2.1.2",
            "2.2.38",
            "3.9.1.1",
            "3.9.2.1",
            "3.9.3",
            "7.5.1",
            "8.1.3",
            "8.2",
            "8.4.3",
            "9.3.2",
            "10.3.1",
            "10.9.4",
            "10.12.1",
            "11.6.1",
            "11.7",
            "11.8.1",
            "11.8.1.1",
            "11.8.1.2",
            "11.8.2",
            "14.1",
            "14.2",
            "14.3",
            "16.1.1.1",
            "16.2.5",
            "17.1.1",
            "17.1.2",
            "17.1.7",
            "19.3.6",
            "19.3.7",
            "19.3.8",
            "19.5.2.1",
            "19.6",
            "19.9.1",
            "19.13",
            "19.13.13",
            "19.13.14.1",
            "20.1",
            "20.2.2",
            "20.2.4.1",
            "20.2.5",
            "20.7",
            "20.8",
            "21.2.1",
            "22.5"
        ]
    },
    "cpb-aacip-127-81jhb5w6.h264": {
        "videoID": "cpb-aacip-127-81jhb5w6.h264",
        "title": "Aalika'ar Alexie Mochin - # 81",
        "time": "22:26",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:01",
                "Qanemciluni Junior-aam irniarinek pingayunek, qavcinek iluperangqerrucimegnek, tuyuurteqarraallerminek, anglillermini Nanvarnarrliim ayuqucillranek, elitnaurvigmi pivkenani tangvaurluni elicungcallerminek, how Uyaquq [Lloyd Nick] was their pastor, qasgimi agayutullermeggnek, igamikun Uyaqum Qaneryarainek, tamaani-llu Qaneryaramek niiteqerraarucimeggnek.",
                "Talks about Junior’s three children, how many great-grandchildren they have, when he first became a pastor, what Nanvarnarrlak was like growing up, how he learned by observation instead of in a school, Uyaqumek [Lloyd Nick] tuyungqellermeggnek, church services in the community house, Uyaquq’s Bible in his orthography, and how it was their first experience with the Bible."
            ],
            "32": [
                "03:26",
                "Qanemciluni maurlumi ellimerutiinek ella paqcarturraarluku qanemcitesqelluku, unuut iliitni pelatekamek tangllerminek, qamaken Qaneryaranek niiteqerraallerminek, niitellerminek naspaallerminek, cali-llu eneqakniluku.",
                "Talks about his grandmother telling him to check on and report the weather, finding a tent one night, listening in and hearing the Bible for the first time, reciting the verses that he just heard, and how he still remembers it."
            ],
            "65": [
                "08:00",
                "Qanemciluni agayulirteńgullerminek, aatiin Robert-aamek Akiarmiumek kelellranek, Robert-aamun Qaneryaranek elicungcallerminek, Uyaqum igaryaraikun yuarutmek eliteqerraallerminek, agayulirteńgullermini-llu kalikaunani Qaneryariutullerminek.",
                "Talks about being a pastor, his father inviting Robert from Akiaq [Akiak] to go eat, Robert teaching him from the Bible, learning his first song with Uyaquq’s orthography, and being able to recite Bible verses from memory as a preacher."
            ],
            "104": [
                "13:58",
                "Qanemciluni Uyaqum urenkutiinek, Qaneryaranek yuarutnek-llu elicungcallerminek, emusngallermini Nallunairutnek [Revelations] elitellerminek, kalikaunani-llu angllurcecitullerminek.",
                "Talks about Uyaquq’s instruction, learning the Bible and songs, learning the book of Revelations while in the hospital, and performing baptisms without textual aid."
            ],
            "125": [
                "17:20",
                "Qanemciluni tuntulgutellerminek, reindeer brands, naqugutkun qukaan cuqtellranek, pirtugmi naqugutem qanikcaq itercessngailucianek, natmurtaqami nuusilgilaasqumallerminek, tunciuryaram qanruyutaikun agayulirteńgullerminek, yungqerrata tuntut akngirtesqevkenaki, qanellri-llu nalluyagutesqevkenaki.",
                "Talks about becoming a reindeer herder, tuntut nallunailkutaitnek, getting his waist measured with a belt, how a belt will protect him from snow getting in during a blizzard, to take a knife with him whenever he travels, using advice from reindeer herding in his pastoral work, not to hurt reindeer because they have spirits, and not to forget what he said."
            ]
        },
        "elderTags": [
            "23.2"
        ],
        "tags": [
            "2.2.64",
            "2.2.37",
            "1.2.1",
            "5.3.1",
            "8.1.2",
            "8.1.3",
            "11.8.5",
            "11.10",
            "15.2.1.1",
            "19.6.7"
        ]
    },
    "cpb-aacip-127-84mkm6tr.h264": {
        "videoID": "cpb-aacip-127-84mkm6tr.h264",
        "title": "Winifred Beans - # 82",
        "time": "6:20",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interivew"
            ],
            "Genre 2:": [
                "Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:09",
                "Qalarrluni ellmeggnek ataneqesqevkenaki, Agayutem wall’u Yupiit alerquutaitnek yuut ukvengqerrarkauniluki, taangam kuingirrluum-llu iquggliqnarquciagnek, agayutem-llu wall’u Yupiit qaneryarait ukveresqelluki.",
                "Talks about not being self-interested, that people need to believe in God’s or Yup’ik commandments, the dangers of alcohol and marijuana abuse, and to obey Christian or Yup’ik wisdom."
            ],
            "21": [
                "03:07",
                "Qanemciluni Yuut ukveqtuniluku Cellam Yua, yuut nalluatni camek tegutesqevkenaki, iqlusqevkevkenaki, iqlumek pinrilkurtellriit ciunerkaqegcilauciatnek, iluperamegnek, Nunam-llu Iquani yuurtellruciminek.",
                "Talks about the Yup’ik belief in the Spirit of the Universe, not to take anything without permission, not to lie, how those who try to live right have good futures, their great-grandchildren, and being born at Nunam Iqua [Sheldon’s Point]."
            ],
            "38": [
                "04:57",
                "Qalarrluni lifetime certificate-aminek, piaqatni wall’u piyugngaaqami ikayuutelauciminek, YKHC-ni qanerteńgutullerminek, news-ani-llu KCC-ni-llu qallatellerminek.",
                "Talks about his lifetime certificate, helping out when they ask or when he can, how he used to speak at YKHC, and speaking on the news and at KCC."
            ]
        },
        "elderTags": [
            "23.85"
        ],
        "tags": [
            "2.2.10",
            "2.2.9",
            "2.2.8",
            "8.1.3",
            "8.2",
            "19.5.4.2",
            "19.13.1",
            "19.13.6",
            "19.13.15",
            "19.13.16",
            "22.5",
            "22.7"
        ]
    },
    "cpb-aacip-127-85n8pw5n.h264": {
        "videoID": "cpb-aacip-127-85n8pw5n.h264",
        "title": "Nurataaq Nelson Angapak - # 83",
        "time": "22:27",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History, Cultural"
            ],
            "Quality:": [],
            "Genre 4 (Location):": [],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": []
        },
        "summary": {
            "1": [
                "00:14",
                "Qanemciluni elitnauryaram cimillrucianek, elitnauqerraallermini qitevtesciigalnge’rmi elitnaurviim avatiini qitevtesqelluni ellimerumallerminek, maa-i Yugtun Kass’atun-llu elitnauryauruciatnek, Yugtun qalartesqevkenateng ellimerumallermeggnek, maa-i Yugtun elitnaurluki cingumaluki-llu qalartesqelluki, Yugtun-llu qaneryaram piciryaramteńi angelriarucianek.",
                "Talks about how school has changed, how he couldn’t speak English when first starting school but was told to always speak it around school, modern bilingual education, how they used to be prohibited from speaking Yup’ik, modern schools teaching and encouraging Yup’ik, and how important Yup’ik language is to culture."
            ],
            "23": [
                "03:09",
                "Qalarrluni aperyaram wall’u qaneryaram piniqapigucianek, utertesciigalata qanteng mulngakesqelluki, ciuliateng takaqesqelluki, ciuliat yuuyaramek qanrucituciatnek, ikayuryugluteng qanrucituciatnek, maligtaqulriit-llu cakviussiyaagngaitniluki.",
                "Talks about how powerful language is, how careful we must be with words since they cannot be taken back, to respect elders, how elders instruct on the Yup’ik way of life, how they instruct to help, and how people won’t struggle too much of adhering to wisdom."
            ],
            "46": [
                "07:11",
                "Qalarrluni takaqiyaramek, ciuliat atullermegteggun tangllermegteggun-llu qalarucituciatnek, taqneret ciuliat-llu kinguliateng ikayuryugngaciatnek, qanertet quyavikesqelluki, tegganret yuuyaraq kinguvararkauniluku, ayagyuat niitarkauniluki, taringenrilnge’rmeng-llu niicugniuresqelluki.",
                "Talks about respect, how elders instruct based on their life experience and what they’ve seen, how adults and elders can help successive generations, to thank instructors, elders’ responsibility to pass on culture, youth’s responsibility to listen, and to listen despite not understanding."
            ],
            "85": [
                "13:30",
                "Qanemciluni apa’urluminek pissuryaramek elitellerminek, anguytem yuullerkaanek, maurluan neviarcat qalarutetullruniluki, piyugngaaqami elitellerminek elicungcatuniluki, ciuliat qanrutesteteng quyavikesqelluki, yuk unguvaqallermini taktaciatun eliquratucianek, ciuliamteńek elitelput kinguvaasqelluki, piyugteqluteng yuuyaramek elitesqelluki, qalartesqumallerminek-llu quyateminek.",
                "Talks about learning to hunt from his grandfather, how a man should live, his grandmother teaching young ladies, passing on what he learned when he can, to thank elders for instruction, that a person learns throughout their entire life, to pass on what we learn from our elders, to actively learn about the Yup’ik way of life, and his gratitude for being able to pass on wisdom."
            ]
        },
        "elderTags": [
            "23.65"
        ],
        "tags": [
            "2.2.68",
            "2.2.30",
            "1",
            "9.1",
            "16.2.2.1",
            "16.4.1",
            "19.5.4.3",
            "19.6.1",
            "19.6.10",
            "19.8",
            "19.14"
        ]
    },
    "cpb-aacip-127-86nzsk0r.h264": {
        "videoID": "cpb-aacip-127-86nzsk0r.h264",
        "title": "Freda Beaver - # 84",
        "time": "13:49",
        "metadata": {
            "Date": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Personal History, Cultural"
            ],
            "Quality:": [
                "Genre 4:"
            ],
            "Name 1:": [
                "Mary Worm [Kangirnaq – Kongigonak]"
            ],
            "Role 1:": [
                "Interviewee"
            ],
            "Name 2:": [
                "Adolph Lewis [Kuigilnguq – Kwigillingok]"
            ],
            "Role 2:": [
                "Interviewer"
            ],
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:01",
                "Qanemciuq ellangeqarraallermeggnek, qavcirraat Kass’at alikellruniluki, Anuuraametellratni elitnaurvikarraamek, angayuqrita elitnauresqumanritellratnek, elitnaurviit akusrarrnarqelrianek ayagnirciqnillratnek, ataucirqumek-llu elitnauryarraarluni uitasqeńgatni uitallerminek.",
                "Talks about their first memories, how they were intimitated by the few resident Caucasians, the first school when they lived in Anuuraaq, how their parents told them not to go to school, warning that schools will corrupt them, and how he went to school once but stayed home after."
            ],
            "19": [
                "01:49",
                "Qanemciluni elitnaurvigni usviiruciiqniluki qanllernek, kinguliameggnek Kass’artarnek elitellernek, angalkunek umyuarrliqellrianek, ciknalriit angalkut yuungnaqellriit aniqlaatullratnek, qessamkat kaigasteńgurtarkauciatnek, ellalkartesqevkenaki-llu.",
                "Talks about warnings that schools will make people foolish, their descendants learning Western ways, shamans with malicious intent, jealous shamans cursing successful people, how lazy people end up as beggars, and not to act foolish."
            ],
            "38": [
                "04:29",
                "Qalarrluni irniangekuneng pikaceteng qimaasqelluki, aipateng kenkesqelluki, allaliurpakarluteng aipaqenrilkemeggnek irniangetuniluki, ciuliat atullermeggnek tangllermeggnek-llu alerquituciatnek, irniateng-llu ceńirutesqevkenaki.",
                "Talks about admonishing children to leave when treated badly, to treat spouses with love, how infidelity leads to having children with other people, that elders instruct from what they experienced and seen, and not to take their children to others’ houses."
            ],
            "56": [
                "06:51",
                "Qalarrluni pissurtet unangkengait quyakluki ciuniuresqelluki, aki pitekluku qenngutesqevkenaki, anglatkevkenaki ukisqiisqelluki, irniameng takuatni akusrartesqevkenaki, anguyagteńun pilriit taangaryartetuciatnek, aviranaunateng elluarrluki yuusqelluki, eneteng uitanqegcinarqevkangnaqluki, iliini-llu piyugyaaqengramta elluarpek’nata pilaucimteńek.",
                "Talks about gratefully accepting what hunters catch, not to be angry over money, to help without taking things lightly, not to abuse substances in front of their children, how many abuse alcohol during military service, to live well without hindering anyone, to keep their houses peaceful, and how we sometimes do not do well despite wanting do"
            ],
            "76": [
                "09:27",
                "Qalarrluni kinguliameng qanrutestekameggnek kepquciatnek, niicugnissuutetgun tiiviitgun-llu qalartelangellruciatnek, aipameng avataitnek irniangesqevkenaki, aatailngurnek irnillerkam inerquutngucianek, tiiviini unaqsarcetaalrianek, taangaasqevkenaki wall’u kuingirrlugmek, yuullrem ikgelucianek, akiteng atu’urkameggnun tau͡gaam atuusqelluki, uini akiliurcet’lauciminek.",
                "Talks about how the next generations are in need of teachers, how they are speaking through radio and television programs, not to have children except with spouses, admonishments against children before marriage, seeing sedation on TV, not to abuse alcohol or marijuana, how short life is, to be responsible with money, and how she leaves her husband to deal with money."
            ]
        },
        "elderTags": [
            "23.34"
        ],
        "tags": [
            "2.2.27",
            "8.4.4.1",
            "9.10.1",
            "14.3",
            "14.7",
            "16.2.2",
            "16.4",
            "19.6.11",
            "19.8.1",
            "19.13.5.1",
            "19.13.17",
            "22.2.3",
            "22.5",
            "22.7"
        ]
    },
    "cpb-aacip-127-87brvbt5.h264": {
        "videoID": "cpb-aacip-127-87brvbt5.h264",
        "title": "Cikiraq Jane Green, Acacungaqa Clotilda Stone, Anganaran Katherine Smart-Bell - # 85",
        "time": "14:30",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Quality:": [
                "Genre 4:"
            ],
            "Name 1:": [],
            "Role 1:": [],
            "Name 2:": [],
            "Role 2:": [],
            "interviewer": [
                "Sophie Kusak"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Qalartuq caqlamek yuungcautmek, igyariqellermi iluliqellermi-llu utumarillragnek, acilqurrit kiingita nertuniluki, Yugtaat iinrut Kass’artarnek cimillratnek, aipangvailegmi akusrartellerkaanek aaniin inerquutiinek, maurluni aanaksuktullerminek, kiimi paniullerminek, quserpagluteng [TB] alqami piunrillratnek, unguvaasqelluni-llu iinrunek nerqumatullerminek.",
                "Talks about medicinal rosewort, how it helped her sore throat and upset stomach, how they only eat the roots, how people went from Yup’ik to Western remedies, her mother’s warning against premarital relations, how she thought her grandmother was her birth mother, being the only daughter, her older sisters succumbing to TB, and being fed medicinal things to keep her alive."
            ],
            "33": [
                "03:14",
                "Qanemciluni maulrlumi ellimerutiinek quarruugnek pakikengkuni ataucimek neresqelluku, aipaminek ciissinek pakikengllermek, kinguqlikacagaatnek keggumarraarluni caqlakun unuaquani mamellranek, uini-llu piunrirraartelluku irniani-llu kiimelucimeggnek.",
                "Talks about her grandmother telling her to eat one needlefish if she finds them in vole caches, her friend finding bugs in a vole cache, her youngest son getting bitten then healing overnight with rosewort, and being alone with her children after her husband’s passing."
            ],
            "76": [
                "07:33",
                "Qanemciluni anglillermini angayuqaagni niitengnaquratullerminek, inerciigalnguut allani nunani elitaqtuniluki, ilani naklekesqelluki, qanruyutet unimesqevkenaki, angayuqateng-llu takaqesqelluki.",
                "Talks about trying to obey her parents growing up, how mischievous people are known in other places, to treat others with compassion, to always remember wisdom, and to respect their parents."
            ],
            "91": [
                "09:26",
                "Qanemciluni naryalngunarqellriartangqerqan qengateng uqumek mingutullermeggnek, qusquneng wall’u igyariqekuneng uqum ikayuutngucianek, wangkutnek-llu elluarrluta yuugarkaucimteńek.",
                "Talks about rubbing their noses with seal oil if there are strong odors, seal oil for coughs and sore throats, and that we are responsible for ourselves to live well."
            ],
            "105": [
                "11:28",
                "Qanemciluni kinguvemegnek, taangam kuingirrluum-llu assiiluciagnek, kuingirrluum-llu qavaumanarqucianek nalluyagutnarqucianek-llu.",
                "Talks about their descendants, how detrimental alcohol and marijuana are, and how marijuana makes people sleep a lot and forgetful."
            ]
        },
        "elderTags": [
            "23.27",
            "23.3",
            "23.10"
        ],
        "tags": [
            "2.2.18",
            "2.2.17",
            "8.4.2",
            "9.5.3",
            "13.2.1",
            "19.3.2.1",
            "19.3.3",
            "19.5",
            "19.10",
            "19.12",
            "19.14.1",
            "22.5",
            "22.7",
            "22.12.2.2",
            "22.12.2.3"
        ]
    },
    "cpb-aacip-127-87pnw7r9.h264": {
        "videoID": "cpb-aacip-127-87pnw7r9.h264",
        "title": "Miisaq Milton Lewis - # 86",
        "time": "17:36",
        "metadata": {
            "Date": [],
            "Name:": [],
            "Genre 1:": [
                "Interview"
            ],
            "Genre 2:": [
                "Cultural, Personal History"
            ],
            "Quality:": [
                "Genre 4:",
                "Kuiggluk [Kwethluk]"
            ],
            "Name 1:": [
                "Nicholai Nicholai (Qugiciq), Olenka K. Nicholai (Angut’aq) [Kuiggluk – Kwethluk]"
            ],
            "Role 1:": [
                "Interviewees"
            ],
            "Name 2:": [
                "John Active"
            ],
            "Role 2:": [
                "Interviewer"
            ],
            "interviewer": [
                "Atmak Lillian Michael"
            ]
        },
        "summary": {
            "1": [
                "00:08",
                "Ikirun. Qanemciuq Kusquqvagmi yugyallrunrilucianek, yuguanek qungunek-llu, ellangellermini Kuigglugmiut enaita nanlucillratnek, Slaavillermeggnek, erpailgan-llu aturyartulriit qaqitellruciatnek.",
                "Introduction. Talks about how there weren’t many people on the Kuskokwim, wooden human figures and graves, the layout of Kuiggluk [Kwethluk] when he was growing up, Russian Christmas, and finishing Russian Christmas singing before dawn."
            ],
            "42": [
                "04:44",
                "Qanemciluni qungullernek, Paniluun aatiin enellranek napat akuliitni, elitnauqacuallermini Kass’amek tangerqerraallerminek, mikelnguullgutni-llu uksuarmi elitnauryatullermeggnek, Kuinerrarmiut kuigata kangranun ayallermeggnek, aatami piunrillruacianek, ilani-llu allanek ilaunateng tamaantellermeggnek.",
                "Talks about the graves in the past, Paniluk’s father’s house in the trees, seeing a Caucasian for the first time at school, going to school in the fall with the other children, going to the headwaters of Quinhagak’s river, his father having passed away, and staying there with no one else but their family."
            ],
            "72": [
                "09:27",
                "Qanemciluni neqsullermeggnek, neq’ngelaayuilucianek, tallimani allrakuni tamaani uitallermeggnek, pissuryaurtellerminek kiimi-llu ayagaaqluni, ikamrarluteng Kuigglumun utertellermeggnek, aanameng aumikun apqucingellranek, uksuaquani yuunrillranek, catairucan-llu qanruyuka’rmek niitnanrillerminek.",
                "Talks about fishing, how fish wouldn’t come early there, staying there for five years, how he started hunting and traveling alone, going back to Kuiggluk in the winter by sled, their mother getting an ailment in her blood, how she passed away that fall, and how he stopped hearing traditional wisdom after her passing."
            ],
            "93": [
                "12:44",
                "Qanemciluni nasperturluku Naparyarrartellerminek, tan’gaurluullgutminek aipaqsuumitelallerminek, Naparyarrarni tegganrek allanitlerminek, angukara’urluum Kuigglugmiunek qalartellranek, angukara’urluum-llu kelgumatullranek.",
                "Talks about trying to go to Naparyarraq [Napakiak] for the first time, not wanting to play with his male peers, visiting elders in Naparyarraq, the old man talking about the people of Kuiggluk, and how the old man used to be invited to eat."
            ],
            "117": [
                "16:17",
                "Qalarrluni ciunganitun nukalpiartairuyucianek, Nutararaam/Amaqlicuaraam mikliricianek, ilaliryaaqellrek alqani-llu kiimelliuciagnek, pissutullermeggni ayagaturatullermeggnek, Cucuam kiimelliucianek, Olenka-mek-llu.",
                "Talks about how there are no great hunters like before, how Nutarar/Amaqlicuar is getting smaller, how he and his sister are the only ones left of their large family, how they used to be nomadic hunters, how Cucuaq is the only one left from his family, and Olenka."
            ],
            "125": [
                "20:03",
                "Qalarrluni qanruyutnek niicuiruyuciatnek, ayagyuat niicugniyuiruyuciatnek, Yugtun qalarcaram cagmariinalriacetun picianek, agayuvigtaat-llu Yuut qaneryaraicetun ayuquciatnek.",
                "Talks about how people don’t hear about traditional wisdom anymore, how youth don’t listen, how the Yup’ik language is getting lost, and how the Bible sounded like Yup’ik wisdom."
            ]
        },
        "elderTags": [
            "23.54"
        ],
        "tags": [
            "2.2.27",
            "1",
            "2.1.2",
            "2.2.39",
            "4.3",
            "8.1.3",
            "9.1",
            "9.3",
            "9.11",
            "16.2.2",
            "16.4",
            "19.5",
            "20.9.1"
        ]
    },
    "cpb-aacip-127-0644j324.h264": {
        "videoID": "cpb-aacip-127-0644j324.h264",
        "title": "Angalraq Andrew Paukan, Benedict Ketcheak, Nauciralrea Joseph Friday - # 6",
        "time": "21:05",
        "metadata": {},
        "summary": {
            "1": [
                "00:00",
                "\"Wangkutnun taug͡aam atauq man'a maani Yugtun piciryaraq eglerutellerkaa.\"",
                "\"It is upon us to continue the Yup'ik culture here.\""
            ],
            "27": [
                "03:18",
                "\"Au͡gkut qaneryaraqegtaaraat, civumni qanellret qaneryarait pegtenritniaraput\",",
                "\"Let's not abandon those wonder pieces of wisdom, the wisdom of the ones who spoke before me\""
            ]
        },
        "elderTags": [
            "23.9",
            "23.20",
            "23.59"
        ],
        "tags": [
            "2.2.18",
            "2.2.10",
            "2.2.3",
            "1",
            "20",
            "19.5"
        ]
    },
    "cpb-aacip-127-23612qck.h264": {
        "videoID": "cpb-aacip-127-23612qck.h264",
        "title": "Yuk 01 Unidentified, Anguyaluk Taac'aq Olinka Pavilla, Alciq Maxie Altsik - # 22",
        "time": "1:01:44",
        "metadata": {
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)",
                "Uquuviar Olinka Andrew",
                "Sophie Kusak",
                "Atmak Lillian Michaels"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Tua-i tamakut pissuryarat alerquutai piyaurcama tua-i aturturluki.\"",
                "\"When I started, I followed his instructions on hunting.\""
            ],
            "100": [
                "14:15",
                "\"Atauciq tauna tuunrituli Qupanuarmek pilallrat\"",
                "\"That one who had shamanistic powers whom they called Qupanuaq.\""
            ],
            "133": [
                "18:40",
                "\"Ullagluku nutaan niicugnisqelluku inerquutnek qalartellria.\"",
                "\"They told me to go and listen to the one speaking about admonishments.\""
            ],
            "228": [
                "34:15",
                "\"Arnat-llu makut enemi agleraqata qanrutnaurait\"",
                "\"And when these women menstruate at home, they'd tell them.\""
            ],
            "277": [
                "39:56",
                "\"Inerquutet makut wani assiitellriit atuqsaileng'erpeciki ayagyuani.\"",
                "\"You young people shouldn't do these bad things that are admonished against.\""
            ],
            "325": [
                "46:27",
                "\"Kenka atunrilkumteggu maani unguvallemteńi qaill' piluta anirtuumaciqceta?\"",
                "\"If we don't practice love as we live here, how will we be saved?\""
            ],
            "360": [
                "51:42",
                "\"Qanikcaq tangerrluku yullret imkut pitullruut.\"",
                "\"People back then would look at the snow.\""
            ],
            "423": [
                "59:29",
                "\"Makut maa-i qanruyutektuaput.\"",
                "\"This is the traditional knowledge we pass down.\""
            ]
        },
        "elderTags": [
            "23.86",
            "23.14",
            "23.6"
        ],
        "tags": [
            "2.2.66",
            "2.2.37",
            "2.2.36",
            "2.2.31",
            "2.2.23",
            "5.3.2",
            "5.3.4",
            "17.1.6.1",
            "9.1",
            "19.13",
            "19.7.1",
            "22.7",
            "22.5",
            "3.5",
            "2",
            "19.10"
        ]
    },
    "cpb-aacip-127-34fn33pp.h264": {
        "videoID": "cpb-aacip-127-34fn33pp.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm - # 33",
        "time": "22:23",
        "metadata": {
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "6": [
                "00:53",
                "\"Tayima una wani qanrucunailnguq. Qanrucunailnguut qaillun tamaani tangerrluki ciunerkait nallunrit'lallruitki?\"",
                "\"There are those who are hard to talk to.  How did they know by observation their journey ahead?\""
            ],
            "51": [
                "10:17",
                "\"Cali man'a akusrarun maa-i ilaitnek yuut allurkengelriatun ayuqelartuq atu'urkaatnek.\"",
                "\"And on using (recreational drugs) nowadays it takes away from some people what they would have provided.\""
            ],
            "80": [
                "16:32",
                "\"Tangerrluk wiingaurluq-llu waniwa aiparma imum tungiinun camek umyuarniurutaitellemnek quyapialalrianga watqapik. Quyatmek tau͡gaam.\"",
                "\"You see, my poor self is thankful having no regrets towards my previous partner.  Only gratefulness.\""
            ]
        },
        "elderTags": [
            "23.16"
        ],
        "tags": [
            "2.2.28",
            "19.3.4",
            "19.3.4.1",
            "19.6.1",
            "22.5",
            "14",
            "14.3.2",
            "13"
        ]
    },
    "cpb-aacip-127-34sj40gx.h264": {
        "videoID": "cpb-aacip-127-34sj40gx.h264",
        "title": "Narullgiar Elena Nick - # 34",
        "time": "15:34",
        "metadata": {
            "interviewer": [
                "Inaanavr Carpenter",
                "Anastasia Cooke Hoffman"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "Assalialiluni Qalamciluni-llu",
                "Making Frybread and Storytelling"
            ]
        },
        "elderTags": [
            "23.58"
        ],
        "tags": [
            "2.2.35",
            "6.1",
            "10.1.1",
            "15.2"
        ]
    },
    "cpb-aacip-127-085hqfqk.h264": {
        "videoID": "cpb-aacip-127-085hqfqk.h264",
        "title": "Ackiar Nick Lupie - # 10",
        "time": "31:54",
        "metadata": {
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Imarpigmiutaat, makut-llu cali yaqulget... enurnaringut.\"",
                "\"Marine animals, and these birds... are getting scarce.\""
            ],
            "77": [
                "10:19",
                "\"Iciw' pellaalliaqa wall'u-q' qaill' piaqata kaingaqameng canek nertullruat yuilqumi?\"",
                "\"You know, if they happened to get lost or something happened, what would they eat in the wilderness if they got hungry?\""
            ],
            "121": [
                "16:07",
                "\"Maani tau͡gken nunam qaingani tua-i arenqiallugeskuni wall'u kiskuni\"",
                "\"However, if one gets into misfortune or sinks into water here on the land\""
            ]
        },
        "elderTags": [
            "23.4"
        ],
        "tags": [
            "2.2.30",
            "13.3.1",
            "9.7",
            "5.2",
            "5.4",
            "9.10",
            "5.1",
            "5.4.4",
            "11.3",
            "11.4",
            "11.5",
            "11.2"
        ]
    },
    "cpb-aacip-127-623bkbxr.h264": {
        "videoID": "cpb-aacip-127-623bkbxr.h264",
        "title": "Kumkaq Noel Polty - # 59",
        "time": "8:26",
        "metadata": {},
        "summary": {
            "1": [
                "00:00",
                "\"Tua-i wangkuta imumi qasgimi, tan'gaurlurni qasgimi uitauratullruukut\"",
                "\"A long time ago in the qasgiq, young men like us stayed in the qasgiq\""
            ],
            "14": [
                "01:43",
                "\"Angenqaa anrutam qam'um imaunani nangtequtekellra.\"",
                "\"Nothing compares to the pain of an empty stomach.\""
            ],
            "24": [
                "02:59",
                "\"Tau͡gken neqaicuilnguut aperturluki cali.\"",
                "\"Also to know which lakes and rivers always have food.\""
            ],
            "42": [
                "05:44",
                "\"Tua-i-ll' neqairutaqan uitavkenata cali can'giilegnun ayagluta, can'giirturyaranun.\"",
                "\"And then when there is no more fish, they told us not to stay but to go to places that have black fish, places where black fish traps are set.\""
            ]
        },
        "elderTags": [
            "23.47"
        ],
        "tags": [
            "2.2.11",
            "21.2",
            "13.3",
            "17.1.2",
            "17.1.7",
            "5.1.1",
            "2"
        ]
    },
    "cpb-aacip-127-881jx4d6.h264": {
        "videoID": "cpb-aacip-127-881jx4d6.h264",
        "title": "Kelucaq Joe Andrew, Urutaq Lucy Beaver, Kumluilnguq Matthew Frye - # 87",
        "time": "51:26",
        "metadata": {},
        "summary": {
            "1": [
                "00:00",
                "\"Akluit-llu eru'urqamteki angutet akluit allakarcetetullruit aanamta\"",
                "\"And when we washed their clothes, our mothers would have us separate the men's clothes\""
            ],
            "14": [
                "01:28",
                "\"Tua-i-llu wangkuta arnani neqnek aulukilriani tua-i qigcikluki angutet unangkengait.\"",
                "\"Then we women who took care of food would treat what the men obtained with respect.\""
            ],
            "28": [
                "03:02",
                "\"Qigcikluku yuum pivianun, yuum piyaraanun pisqumamayuitellruukut.\"",
                "\"Out of respect, we would be told not to go to a person's place, a person's gathering place.\""
            ],
            "32": [
                "03:38",
                "\"Tauna-gguq kuvyiryaraq neqem aruvikellrukani, allrakuani nurciarkauguq neqmek.\"",
                "\"They said that if a fish spoils in that drift netting spot, the fish will be low the next year.\""
            ],
            "43": [
                "05:01",
                "\"Ca tamalkuan au͡gkut yuut qigcikellruat, yuilqurrungraan nunaungraan-llu.\"",
                "\"People back then respected everything, even the wilderness and even the land.\""
            ],
            "82": [
                "10:28",
                "\"Neqet wangkuta piqertuutamek aturluta kepuusqevkenaki, tau͡gaam uluamek aturluta kepluki urumakata.\"",
                "\"We were told not to cut fish with axes, but to cut them with ulus if they're thawed.\""
            ],
            "102": [
                "12:39",
                "\"Leftover-aarqamta qimugtelegnun tua-i tuntuaput, taumun qimugtelilriamun yugmun.\"",
                "\"When we have leftovers, we give them to someone with dogs, a person with many dogs.\""
            ],
            "106": [
                "13:01",
                "\"Cat tua-i ayuqenrilnguut naunraat, au͡gkut-llu berries-aat\"",
                "\"Various plants, and those berries\""
            ],
            "150": [
                "17:32",
                "\"Tau͡gaam tua-i engelqerrluta cumertecetullruitkut tua-i egtarkaunrilngurmek nang'arkamteńek.\"",
                "\"They would only have us gather what was suitable for us, what wouldn't be thrown away, and that we would finish.\""
            ],
            "163": [
                "19:04",
                "\"Tan'gaurlurni nasaurlurni-llu niicugnisqelluci alerquutek'lallemteńek miklemteńi, wiinga-llu tan'gaurlullraullemni.\"",
                "\"Boys and girls, I want you to listen to our traditional instructions when we were small, and when I was a little boy.\""
            ],
            "205": [
                "24:36",
                "\"Quyavkangnaqu'urluki, quyavkangnaqu'urluki tau͡gaam pisqelluki.\"",
                "\"They were told to try to make them feel only gratitude.\""
            ],
            "218": [
                "26:15",
                "\"Tang cuqyucirluteng-llu qalartelallruut, canek imkunek makunek nallunrilkemteńek cuqyucirluteng.\"",
                "\"You see, they also used to speak in metaphors, using these things we know as metaphors.\""
            ],
            "250": [
                "31:07",
                "\"Ekvicuarmiunek kitak' anglillerpenek cali qanemciteqerkut qaillun tamaani ayuq[ellratnek].\"",
                "\"Please tell us about growing up in Eek, what they were like back then.\""
            ],
            "274": [
                "34:36",
                "\"Ellangellemni yugyaggallruuq.\"",
                "\"In my earliest memories, there were pretty many people.\""
            ],
            "294": [
                "37:18",
                "\"Umyuarteqlemni Agayutem, Agayutem erneq una tekicetaa.\"",
                "\"In my opinion, God has brought this day.\""
            ],
            "302": [
                "38:35",
                "\"Taumek tamakut kit'essuutet tua-i qeleksunarqut.\"",
                "\"That's why you should keep those life jackets.\""
            ],
            "322": [
                "41:33",
                "\"Tamaa-i, tamaa-i tamatum nalliini ayagassuutengqertut qayanek.\"",
                "\"Back in that time, they traveled with kayaks.\""
            ],
            "354": [
                "45:22",
                "\"Man'a kitak' cali: waten maa-i niiqurangelriakut qanruyutmek, qanruyutet niitnaunrirniluki.\"",
                "\"This one too: now, we always hear that traditional wisdom is not heard anymore.\""
            ],
            "384": [
                "49:40",
                "\"Camek paiciryarcikut?\"",
                "\"What would you leave with us?\""
            ]
        },
        "elderTags": [
            "23.43",
            "23.82",
            "23.48"
        ],
        "tags": [
            "2.2.38",
            "7",
            "19.3.9.1",
            "19.6.3",
            "19.5.2",
            "5.1",
            "10.11",
            "17.1.6",
            "3.9.1",
            "3.9.2",
            "3.9.1.1",
            "10.2.2",
            "11.10",
            "9.10.2",
            "6",
            "6.1",
            "9.5.1.1",
            "9.5.4",
            "9.12",
            "15.2",
            "19.5",
            "19.6.1",
            "19.10.1",
            "19.13.1",
            "19.6.12",
            "19.6.13",
            "19.6.13.1",
            "19.5.7",
            "2.2.29",
            "1.2",
            "8.1.1.1",
            "2.2.31",
            "2.2.30",
            "2.2.48",
            "2.2.33",
            "2.2.32",
            "11.6",
            "11.2.1",
            "17.4.3",
            "12.1.2",
            "17.4.5",
            "22.5"
        ]
    },
    "cpb-aacip-127-67wm3hhj.h264": {
        "videoID": "cpb-aacip-127-67wm3hhj.h264",
        "title": "Ackiar Nick Lupie - # 65",
        "time": "31:05",
        "metadata": {
            "interviewer": [
                "Uquuviar Olinka \"Ollie\" Andrew"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Kitak' qaillun up'ngelallruat waten uksumi?\"",
                "\"So, how did they prepare in the winter like this?\""
            ],
            "78": [
                "11:25",
                "\"Tau͡gken cali makut arnat allakarmeng waten cikuvailgan-llu uptenglallruit anguteteng.\"",
                "\"However, women would work separately before it froze to prepare things for their men.\""
            ],
            "126": [
                "19:34",
                "\"Tua-i mat'um nalliini-w' tua-i umyuaqaqamki au͡gkut qaill'-wa tua-i yuullruciit\"",
                "\"These days, when I remember how they used to live back then\""
            ],
            "137": [
                "21:24",
                "\"Qaillun-mi uksuarmi iciw' waten ayagaqata iciw' inerquutek'lallrit angutet?\"",
                "\"What about the admonishments they had for men, you know, when they traveled in the fall like this?\""
            ]
        },
        "elderTags": [
            "23.4"
        ],
        "tags": [
            "2.2.30",
            "17.6",
            "7.4.2.1",
            "3.1.2",
            "22.12.2.1",
            "7.4.1",
            "17.1.6.1",
            "19.13",
            "16"
        ]
    },
    "cpb-aacip-127-52j6qcr2.h264": {
        "videoID": "cpb-aacip-127-52j6qcr2.h264",
        "title": "Arnaaquq Aqesgirpak Mary Worm - # 48",
        "time": "1:03:36",
        "metadata": {
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Aipangellruunga taumek, aipangellrulliniunga.\"",
                "\"He became my husband or had become my husband.\""
            ],
            "10": [
                "02:24",
                "\"Nateqsigta tauna Isrimiu, Isrimiut Sevv'arnermiut natiitni?\"",
                "\"Where exactly is Isriq, where were the people of Isriq from Chefornak?\""
            ],
            "24": [
                "05:05",
                "\"Aren, kiituani-tang yuarutii-llu elitarput.  Waten tang atuutullrulria tauna uurcaq tangvaurluku.\",",
                "\"My, we even learned his song.  He sang like this with his eyes on that gaff holder.\""
            ],
            "42": [
                "09:30",
                "\"Tangerrluku ilungarluan wiinga-llu angalkurtellrulrianga.  Tang.\"",
                "\"You see, my dear cousin I also was visited by a medicine man.  See.\""
            ],
            "95": [
                "22:35",
                "\"Kitak, kitak makut wani assilriit qanernailnguut angalkuut canek calilallruat?\"",
                "\"Ok, ok, what did the good quiet shamans work on?\""
            ],
            "109": [
                "25:47",
                "\"Qalarucestemta imkut qalarutetullrukaitkut tuartang nunulriit.\"",
                "\"Our speakers spoke to us like they were scolding.\""
            ],
            "120": [
                "28:27",
                "\"Tua-i taumek cali imna makunek call maa-i waten-llu imkulrianek makunek-wa qaneryariurtet ilaitnek yugnek.\"",
                "\"So, now we have speakers of the good word (bible) who are our own people.\""
            ],
            "133": [
                "31:37",
                "\"Tauna tua-i qanemcitlallruakut cali taum Maurlumta ayuqucillminek.  Uingyaaqellruuq-gguq taumek angutet iliitnek angalkugmek-llu-gguq aprumaluni. Uini-gguq tauna tua-i murilkellrunritaa. Tua-i canianun-llu-gguq inarcuunani.  Itraqan-llu-gguq unugmi unitaqluku.\"",
                "\"That one told us stories our Grandmother and how she was.  She got married to one of the men who was known as a medicine man.  She didn't watch her husband.  She didn't sleep by him.  When he came in at night, she left.\""
            ]
        },
        "elderTags": [
            "23.16"
        ],
        "tags": [
            "2.2.28",
            "8.4",
            "8.4.2",
            "8.4.3",
            "14"
        ]
    },
    "cpb-aacip-127-988gtvzp.h264": {
        "videoID": "cpb-aacip-127-988gtvzp.h264",
        "title": "Wasky Walters - # 95",
        "time": "3:28",
        "metadata": {},
        "summary": {
            "1": [
                "00:00",
                "\"Usviilkelluki-llu, usviilkelluki-llu piksaunaki, cali acirturluki canek atqenrilkaitnek.\"",
                "\"Don't tell them that they are crazy, also don't call them names, names that aren't theirs.\""
            ],
            "10": [
                "01:30",
                "\"Ca tamarmi-wa cimirtuq.\"",
                "\"Everything is changing.\""
            ]
        },
        "elderTags": [
            "23.83"
        ],
        "tags": [
            "2.2.9",
            "19.13",
            "19.15.2",
            "19.10"
        ]
    },
    "cpb-aacip-127-96wwq9xv.h264": {
        "videoID": "cpb-aacip-127-96wwq9xv.h264",
        "title": "Paningayaq Guy Mann, Cimiciaq Natalisia Smith, Tavkaralria Jonathan Johnson, Cikiraq Jane Green - # 94",
        "time": "22:22",
        "metadata": {
            "interviewer": [
                "Sophie Kusak"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Makut civuqliit pingnatullrat nalluku\"",
                "\"They don't know how these ancestors worked hard to survive\""
            ],
            "19": [
                "01:44",
                "\"Imumi makuneng pingvailemta yuut assiq'apiarallruut tamalkurmeng.\"",
                "\"A long time ago, before we had this these, every single person was extremely good.\""
            ],
            "52": [
                "05:28",
                "\"Maa-i takaitqapigtellriakut wangkuta taqestemteńun, Agayutmun taqestemteńun.\"",
                "\"Now, we have absolutely no respect to our creator, God our creator.\""
            ],
            "75": [
                "08:02",
                "\"Cimiciaq.\"",
                "\"Cimiciaq.\""
            ],
            "94": [
                "09:21",
                "\"Makut maa-i, makut maa-i medicine-aqlernaaput civuliamteńeng ayagluteng caqlat.\"",
                "\"These are the medicine that we've always had starting from our ancestors, rosewort roots.\""
            ],
            "151": [
                "14:39",
                "\"Cali ukut nunat teggneqsagullua.\"",
                "\"I am also now the elder of this village.\""
            ]
        },
        "elderTags": [
            "23.69",
            "23.28",
            "23.78",
            "23.27"
        ],
        "tags": [
            "2.2.17",
            "13.3.1",
            "8",
            "22.12",
            "22.12.2.2"
        ]
    },
    "cpb-aacip-127-956djvkd.h264": {
        "videoID": "cpb-aacip-127-956djvkd.h264",
        "title": "Oscar Anvil (?) - # 93",
        "time": "22:10",
        "metadata": {
            "interviewer": [
                "Kakianeq Adolph Lewis (Kuigilnguq)"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Ava-i election-aallratni taangam tungiinun piciurtevkenani ayuqucimitun maa-i ayuqluni.\"",
                "\"When they had an election about alcohol, it didn't pass, and it's how it has been.\""
            ],
            "45": [
                "05:54",
                "\"Wangkuta, wangkuta alerquuteput nalqapiararait ayagyuat\"",
                "\"The young people know nothing about our traditional instructions\""
            ],
            "68": [
                "08:46",
                "\"Piicagyaraq pegcaqunaku.\"",
                "\"Do not give up praying.\""
            ],
            "93": [
                "11:53",
                "\"Cali-llu makut mer'atunge'rmeng Kass'at alerquuteseng uniurrluku piyuilameng anguyagteńi\"",
                "\"Also, though these Caucasians drink, because they don't break their rules in the army\""
            ],
            "105": [
                "13:35",
                "\"Ataucirqumek maligutellruunga, maligutellruunga kalikiulriamun.\"",
                "\"One time, I went with the mail delivery.\""
            ]
        },
        "elderTags": [
            "23.66"
        ],
        "tags": [
            "2.2.66",
            "2.2.38",
            "22.5",
            "19.5",
            "8.1.5"
        ]
    },
    "cpb-aacip-127-945qg6jq.h264": {
        "videoID": "cpb-aacip-127-945qg6jq.h264",
        "title": "Liguaq Annabelle Olik - # 92",
        "time": "22:07",
        "metadata": {
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Kitak' tamakunek qalamciarteqernga ak'allarnek nasaurluullevni up'nerkiyalallevnek.\"",
                "\"Now, please tell me old stories of when you when to spring camp when you were a girl.\""
            ],
            "59": [
                "06:15",
                "\"Arnat-llu pingnaquratullruut tamaani murilkeqarraallemni.\"",
                "\"Women would also subsist back when I first became observant.\""
            ],
            "72": [
                "07:46",
                "\"Tua-ll' qanerturallerpeni ava-i qanqallruuten Nanvarnarrlagmi, Nanvarnarrlagmiungullruniluten.\"",
                "\"So, as you just spoke, you said that you were from Nanvarnarrlak.\""
            ],
            "121": [
                "13:15",
                "\"Kass'at amllellrunritut uani Mamterillerni.\"",
                "\"There weren't a lot of Caucasians downriver in Bethel.\""
            ],
            "148": [
                "16:40",
                "\"Tan'gaurlurnun-llu caumateksaunata pilaasqelluta.\"",
                "\"They also told us not to gravitate to boys.\""
            ],
            "165": [
                "18:46",
                "\"Yugtun qanruteqtarturalaryaaqanka.\"",
                "\"I always speak to them in Yup'ik.\""
            ]
        },
        "elderTags": [
            "23.49"
        ],
        "tags": [
            "2.2.39",
            "16.2",
            "9.7",
            "9",
            "1",
            "19.13"
        ]
    },
    "cpb-aacip-127-91sf7xm0.h264": {
        "videoID": "cpb-aacip-127-91sf7xm0.h264",
        "title": "Tuunralek Jimmy Chimegalrea - # 91",
        "time": "29:55",
        "metadata": {
            "interviewer": [
                "Qang’allugaq Hazel Lincoln"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Waten qanerluni Philippianes tayima 2:12\"",
                "\"It says in Philippians 2:12\""
            ],
            "33": [
                "04:04",
                "\"Atam wiinga tua-i avani ella iqukluku qantullratni, anguanka au͡gkut ella iqukluku qantulriit.\"",
                "\"You see, when they used to speak about the end of the world, I was born in time to see the ones who spoke about the end of the world.\""
            ],
            "41": [
                "05:13",
                "\"Ilait tegularluki qasgimek anulluki maqilallruut\"",
                "\"They would carry some out of the community house to take sweat baths\""
            ],
            "79": [
                "09:29",
                "\"Meluk-gguq man'a tua-i allrakurtaaryaaqeciquq nunam iluani. Tua-i-gguq cangaringaituq.\"",
                "\"They said that fish roe would be in the land year after year. They said it wouldn't spoil.\""
            ],
            "125": [
                "14:27",
                "\"Taukut tua-i kuimallratni yuk piyugngakan qaategtevkenaku piyugngataciatun tamaaken tegutesqelluku.\"",
                "\"While those are swimming, if a person is able, he should not be lazy, but take as much as he can from them.\""
            ]
        },
        "elderTags": [
            "23.80"
        ],
        "tags": [
            "2.2.32",
            "2.2.31",
            "8.1",
            "21.2.1",
            "5.1.3"
        ]
    },
    "cpb-aacip-127-89r22kjv.h264": {
        "videoID": "cpb-aacip-127-89r22kjv.h264",
        "title": "Quriciq Nickolai K. Nicolai, Angut'aq Olinka Nickolai - # 89",
        "time": "21:45",
        "metadata": {
            "interviewer": [
                "Aqumgaciq John Active"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Makunek tua-ll' ak'alla'arnek apqauriukut maavet Kuigglugmun tailuta.\"",
                "\"So, we came here to Kwethluk to ask about things of old.\""
            ],
            "53": [
                "06:50",
                "\"Kass'amek tangerqerraallruunga, elitnauckallruyaaqua.\"",
                "\"I first saw a Caucasian, I went to school for a very short time.\""
            ],
            "76": [
                "10:00",
                "\"Wiinga-llu nukalpiarurrlua anglirilua.\"",
                "\"And I grew up to be in my prime.\""
            ],
            "102": [
                "14:29",
                "\"Kuigglugmiunguniama atam uitauraqerluni maktell' ingleminek.\"",
                "\"When I said I was from Kwethluk, you see, he stayed still then got up from his bed.\""
            ],
            "147": [
                "20:16",
                "\"Ilumun niicuirutut qanruyutnek.\"",
                "\"Indeed, they don't hear about traditional wisdom anymore.\""
            ]
        },
        "elderTags": [
            "23.75",
            "23.12"
        ],
        "tags": [
            "16.2.2",
            "4.3",
            "2.2.39",
            "19.5",
            "21.1"
        ]
    },
    "cpb-aacip-127-98mcvs0p.h264": {
        "videoID": "cpb-aacip-127-98mcvs0p.h264",
        "title": "Kelucaq Joe Andrew, Urutaq Lucy Beaver - # 96",
        "time": "22:23",
        "metadata": {
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Mat'ukun wangkuta yuilqurmiutarmun kuigmiutarmun-llu neqnek-llu unangengnaqtullruukut.\"",
                "\"Through this, we used to try to get land and river animals, and fish.\""
            ],
            "7": [
                "00:48",
                "\"Cali-llu elliraat\"",
                "\"And orphans\""
            ],
            "23": [
                "02:50",
                "\"Iliini unuakumi wiinga imum aanama tamaani ayagyuarlua pilaqiinga maktaqama\"",
                "\"Some mornings when I was young back then, my mother would tell me when I got up\""
            ],
            "50": [
                "06:21",
                "\"Wiinga-llu ellma angucuayaallruaqa tamana tuaten uitalallrat enepigni marayani.\"",
                "\"I was also born on the cusp of that time, when they lived in traditional sod houses.\""
            ],
            "100": [
                "13:01",
                "\"Ikayuutektullruaput tua-i\"",
                "\"That's how we helped others\""
            ]
        },
        "elderTags": [
            "23.43",
            "23.82"
        ],
        "tags": [
            "2.2.38",
            "9.2",
            "4.5",
            "22.3",
            "19.6.13"
        ]
    },
    "cpb-aacip-127-89280sv6.h264": {
        "videoID": "cpb-aacip-127-89280sv6.h264",
        "title": "Kelucaq Joe Andrew, Urutaq Lucy Beaver - # 88",
        "time": "1:04:11",
        "metadata": {
            "interviewer": [
                "Sophie Alexie"
            ]
        },
        "summary": {
            "1": [
                "00:00",
                "\"Mat'ukun wangkuta yuilqurmiutarmun, kuigmiutarmun-llu, neqnek-llu unangengnaqtullruukut.\"",
                "\"With this, we'd try to catch wilderness animals, riverine animals, and fish.\""
            ],
            "26": [
                "03:09",
                "\"Kitaki qakemkut yuut paqeski.\"",
                "\"Now, go out there and check on the people.\""
            ],
            "85": [
                "10:30",
                "\"Tua-i-gguq tamakut tungelququtellriit ilateng ikayuapiatullruit cakneq.\"",
                "\"She said those families helped their relatives a lot.\""
            ],
            "187": [
                "23:37",
                "\"Kenkut'seng mikelngurnun tua-i qanrutkeqerniaran nallunritetacirpegun.\"",
                "\"Talk about how much you know about their love for children.\""
            ],
            "241": [
                "28:42",
                "\"Qurrellranun teq'urranun uqlautevkayuitellruat.\"",
                "\"They never let them be soiled by their urine.\""
            ],
            "273": [
                "31:57",
                "\"Inerqulaqiu erinan tapirpek'naku.\"",
                "\"Admonish them without adding to your voice.\""
            ],
            "315": [
                "36:11",
                "\"Tangvallruamku aanaka ciuqlirmek irnillemni aulukillra.\"",
                "\"Since I watched my mother taking care of me in my first childbirth.\""
            ],
            "343": [
                "39:12",
                "\"Tua-ll' cali mikelnguut kenciyaraatnek\"",
                "\"Then also, watching over children respectfully\""
            ],
            "398": [
                "45:22",
                "\"Makunek alingnarqellrianek pitaqamta qavani, taqukanek-llu, tan'gerlinek-llu\"",
                "\"When we catch those dangerous things upriver, including grizzly bears, and black bears\""
            ],
            "425": [
                "48:14",
                "\"Tua-i anernera tauna tuantelalliuq nakacuani. Tuancukluku pilarngatait.\"",
                "\"Its spirit might be there in its bladder. I think they say it's in the bladder.\""
            ],
            "437": [
                "49:28",
                "\"Tua-i taum angalkum tuaten pivkarluku tamakunun ungavalriat nuniitnun.\"",
                "\"The shaman did that, [sending] him to the place of those living beings.\""
            ],
            "468": [
                "52:24",
                "\"Taqesqenrilengraiciteng tau͡ga tamana tamaa-i aturnanrillruat.\"",
                "\"Though they weren't told to stop, they stopped practicing that.\""
            ],
            "511": [
                "56:48",
                "\"Tamakut-llu piyagauluki pisqevkenaki, mikelnguuluki.\"",
                "\"And never to [hunt] them when they're chicks, when they're small.\""
            ]
        },
        "elderTags": [
            "23.43",
            "23.82"
        ],
        "tags": [
            "2.2.38",
            "19.6.12",
            "19.6.13",
            "21.4.1",
            "22.2",
            "14.6.1",
            "5.3.6",
            "20.3.1",
            "8.4",
            "8.1",
            "9.1"
        ]
    }
};